import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewEncapsulation,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { GroupService } from "./groups.service";
import { FormValidator } from "../form.validator";
import { Offcanvas } from "../form.offcanvas";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../../config/config";
import { Router } from "@angular/router";
import { LoginService } from "../login/login.service";
import { AdmissionService } from "../admission/admission.service";
import { TransportService } from "../transport/transport.service";
import { HeaderComponent } from "../header/header.component";
import { HeaderService } from "../header/header.service";
import { ScriptLoader } from "../script-loader";
import { map } from "rxjs/operators";
import * as string from "../stringFiles/countryCode.json";
import * as nationality from "../stringFiles/nationality.json";
import * as registrationStrings from "../stringFiles/registration.json";
import parsePhoneNumberFromString from "libphonenumber-js/max";
import * as countryCurrency from "iso-country-currency";
import { commonFunctionService } from "../utils/commonFunctions";
import { firstValueFrom } from "rxjs";
import { apiConstants } from "../constant/apiConstant";
import moment from 'moment';
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { ActivatedRoute } from '@angular/router';

declare var $: any;
declare var jquery: any;
declare let moment_js: any;
declare var d3: any;
declare var customToastr: any;
declare var materialadmin: any;

@Component({
  selector: "app-groups",
  templateUrl: "./groups.component.html",
  styleUrls: [
    "./../../assets/css/theme-default/bootstrap.css",
    "./../../assets/css/theme-default/materialadmin.css",
    "./../../assets/css/theme-default/font-awesome.min.css",
    "./../../assets/css/theme-default/material-design-iconic-font.min.css",
    "./../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css",
    "./../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/buttons.dataTables.min.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css",
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    "./../../_crop/css/style.css",
    "./../../_crop/css/style-example.css",
    "./groups.component.css",
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [
    GroupService,
    FormValidator,
    LoginService,
    AdmissionService,
    Offcanvas,
    TransportService,
    HeaderComponent,
    HeaderService,
    ScriptLoader,
  ],
})
export class GroupsComponent implements OnInit {
  @ViewChild("fileInputDocumentHub") fileInputDocumentHub!: ElementRef;
  @ViewChild('mobileNumberEditStaff') mobileNumberInput!: ElementRef;
  private langChangeSubscription: any;
  private genderTranslations: any = {};
  private isActiveTranslations: any = {};
  strings: any;
  documentTypesInfo: any = [];
  selectedDocumentType: any = null;
  fetchingDocumentType: boolean = false;
  selectedFileForUpload: any = null;
  uploadingDocument: boolean = false;
  uploadedDocumentList: any = [];
  fetchingUploadedDocumentList: boolean = false;
  documentHubData: any = [];
  previewingDocumentIndex : any = '';
  documentIndex : any = "";
  private baseURLVersion3 = AppSettings.API_ENDPOINT_V3;
  deletingDocument : any = false;
  registrationIdDocHub : any = "";
  studentCountryCode='91';
  motherCountryCode='91';
  guardianCountryCode='91';
  activeTab: string = 'student';
  constructor(
    private ngZone: NgZone,
    private admissionservice: AdmissionService,
    private router: Router,
    private groupservice: GroupService,
    private formValidator: FormValidator,
    private http: HttpClient,
    elementRef: ElementRef,
    renderer: Renderer2,
    private loginservice: LoginService,
    private elRef: ElementRef,
    private offcanvas: Offcanvas,
    private transportservice: TransportService,
    public headerComponent: HeaderComponent,
    private scriptLoader: ScriptLoader,
    private commonFunction: commonFunctionService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.strings = registrationStrings;
    this.countryCode = Object.values(string);
    this.nationalityData = Object.values(nationality);

    (window as any).angularComponentRef = { component: this, zone: ngZone };

    renderer.listen("document", "click", (evt) => {
      this.paginateClass = evt.srcElement.className;
      this.paginateId = evt.srcElement.getAttribute("aria-controls");
      if (
        this.paginateClass.includes("paginate_button") &&
        this.paginateId.includes("table-importstudent")
      ) {
        this.importstudent_modalproceed();
      }
    });
  }

  handleKeyDown(event: KeyboardEvent) {
    this.commonFunction.handleKeyDown(event);
  }

  academicInfo = {
    current_academic: "",
    current_academic_state: "",
    current_tab: "OVERVIEW",
    year: "",
    academicList: [],
  };
  preLoader = false;
  exportingStaff = false;
  /** True when current staff filters return at least one record (so export is allowed). */
  staffListHasData = false;
  getAuthToken = localStorage.getItem("usertoken");
  getSchoolId = localStorage.getItem("schoolinfo");
  academicId = 0;
  schoolAcademicCurrentYear;
  permissions: any = {
    SCHOOL_STUDENT_MANAGEMENT: "",
    SCHOOL_STAFFS_MANAGEMENT: "",
  };
  // view staff
  selectedStaffName;
  selectedStaffDOB;
  selectedStaffGender;
  selectedStaffAppStatus;
  selectedStaffAccStatus;
  selectedStaffQualification;
  selectedStaffDesignation;
  selectedStaffEmpId;
  selectedStaffDOJ;
  selectedStaffAadharNumber;
  selectedStaffCountryCode;
  selectedStaffAadharCopy;
  selectedStaffEmail;
  selectedStaffAddress;
  selectedStaffImage;
  currentCountryCode: string = "91";
  // edit staff
  editSelectedStaffName;
  editSelectedStaffDOB;
  editSelectedStaffGender;
  editSelectedStaffAppStatus;
  editSelectedStaffAccStatus;
  editSelectedStaffQualification;
  editSelectedStaffDesignation;
  editSelectedStaffEmpId;
  editSelectedStaffAadharNumber;
  editCountryCodeStaff = "91";
  editSelectedStaffAadharCopy;
  editSelectedStaffDOJ;
  editSelectedStaffContact;
  editSelectedStaffEmail;
  editSelectedStaffAddress;

  staffQualificationListArray = [];
  selectedStaffId = 0;

  // country code
  countryCode: any[] = [];
  nationalityData: any[] = [];

  // add staff
  addSelectedStaffName;
  addSelectedStaffDOB;
  addSelectedStaffGender;
  addSelectedStaffAppStatus;
  addSelectedStaffAccStatus;
  addSelectedStaffQualification;
  addSelectedStaffQualificationId;
  addSelectedStaffDesignation;
  addSelectedStaffAadharNumber;
  addSelectedStaffEmpId;
  addSelectedStaffDOJ;
  addSelectedStaffContactCountryCode = "91";
  addSelectedStaffEmail;
  addSelectedStaffAddress;
  selectedStudentCategory;

  // add Designation
  addNewDesignationTitle;
  addNewDesignationFinanceAdminStatus;
  addNewDesignationAdminStatus;
  addNewDesignationFeeDefaulterStatus;
  addNewDesignationTeacherStatus;
  addNewDesignationDriverStatus;
  addNewDesignationDefaultStatus;

  // add Designation
  addNewQualificationTitle;

  // student
  selectedStudentListId = 0;
  selectedStudentname;
  selectedStudentimage;
  selectedStudentsurname;
  selectedStudentemail;
  selectedStudentMobileCountryCode = "91";
  selectedStudentcontact;
  selectedStudentadmissiondate;
  selectedStudentadmissionnumber;
  selectedStudentdateofbirth;
  selectedStudentgender;

  selectedStudentclasscategory;
  selectedStudentclassname;
  selectedStudentclasssection;

  selectedStudentclasscategoryId;
  selectedStudentclassnameId;
  selectedStudentclasssectionId;
  sectionIdChange;

  selectedStudentclassid;
  selectedStudentbwappstatus;
  selectedStudentaccountstatus;
  selectedStudentfathername;
  selectedStudentfathercontact;
  selectedStudentfatheroccupation;
  selectedStudentfatherqualification;
  selectedStudentfatheraddress;
  selectedStudentmothername;
  selectedStudentmothercontact;
  selectedStudentmotheroccupation;
  selectedStudentmotherqualification;
  selectedStudentmotheraddress;
  selectedStudentguardianname;
  selectedStudentguardiancontact;
  selectedStudentguardianoccupation;
  selectedStudentguardianqualification;
  selectedStudentguardianaddress;

  selectedBusTerms = [];
  isTermsVisible = false;

  selectedStudentEditclassid;
  selectedStudentEditbwappstatus;
  selectedStudentEditaccountstatus;

  selectedStaffDesignationId = 0;
  selectedStaffQualificationId = 0;

  loader = false;
  loaderAddStudent = false;
  schoolCategories = [];

  schoolClasses = [];
  schoolClassesSections = [];

  schoolClassesAdd = [];
  schoolClassesSectionsAdd = [];

  schoolAcademicList = [];
  schoolAcademicCurrent = [];
  schoolDesignationList = [];

  staffFilterDesignation = 'all';

  staffFilterAppStatus = 'all';
  schoolCurrency = "INR";
  selectClassStatus = true;
  selectClassSectionStatus = true;

  selectClassStatusAdd = true;
  selectClassSectionStatusAdd = true;

  selectedCategory = null;
  selectedCategoryAdd = null;

  selectedClass = null;
  selectedClassAdd = null;

  selectedSection = null;
  selectedSectionAdd = null;

  // update roll number popup
  showUpdateRollNumberPopup = false;
  updateRollNumberStudentList = [];
  filteredRollNumberStudentList = [];
  updateRollNumberClassName = "";
  updateRollNumberSectionName = "";
  rollNumberSearchText = "";
  updateRollNumberLoading = false;
  savingRollNumbers = false;

  allTermsList = [];
  avalialableTermsList = [];
  studentSelectedTerms = [];
  newStudentSelectedTerms = [];
  viewStudentTerms = [];
  viewStudentTermIds = [];
  //Remove Staff Profile Picture
  removeStaffProfilePicStatus = false;

  // add student variables
  studentName = "";
  studentDOB = "";
  studentGender = 0;
  studentClassId = this.selectedSectionAdd;
  studentAdmissionDate = "";
  studentAdmissionNumber = "";
  studentParentName = "";
  studentParentContact = "";
  studentParentEmail = "";
  studentAddress = "";
  studentAcademicId = this.academicId;
  studentSchoolId = this.getSchoolId;

  addNewStudentgender = 1;

  // import student
  proceedxlx = false;
  Exceldata = "";
  schoolAllClass = [];

  paginateClass;
  paginateId;

  // add new student variables

  profileImageSelected = false;
  profileImageSelectedForStaff = false;

  addNewStudentName = "";
  addNewStudentImage =
    "https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png";
  addNewStudentSurName = "";
  addNewStudentGender = "1";
  addNewStudentDOB = "";
  addNewStudentBloodGroup = "A+";
  addNewStudentReligion = "Hindu";
  addNewStudentCaste = "General";
  addNewStudentNationality = "Indian";
  addNewStudentEmail = "";
  addNewStudentCountryCode = "91";
  addNewStudentNumber = "";
  addNewStudentPENNumber: string = "";
  addNewFatherPinCode: string = "";
  addNewStudentFatherAnnualIncome: string;
  addNewStudentMotherAnnualIncome: string;
  addNewStudentIsEWS: boolean = false;
  addNewStudentIsSpeciallyDisabled: boolean = false;
  addNewStudentIsSingleGirlChild: boolean = false;
  addNewIsMinority: boolean = false;
  addNewStudentAademicid = this.academicId;
  addNewStudentAdmissionBase = "Written exam";
  addNewStudentAdmissionStream = "general";
  addNewStudentAdmissionNumber = "";
  addNewStudentAadharNumber = "";
  addNewStudentClassId = "0";

  addNewGuardianPinCode: string = "";
  addNewMotherPinCode: string = "";
  addNewStudentGuardianAnnualIncome: string = "";

  addNewStudentFatherName = "";
  addNewStudentFatherNumber = "";
  addNewStudentFatherOccupation = "";
  addNewStudentFatherQualification = "";
  addNewStudentFatherAddress = "";
  addNewFatherEmail = null;

  addNewStudentMotherName = "";
  addNewStudentMotherNumber = "";
  addNewStudentMotherOccupation = "";
  addNewStudentMotherQualification = "";
  addNewStudentMotherSameFatherAddress = "";
  addNewStudentMotherAddress = "";
  addNewMotherEmail = null;

  addNewStudentGuardianName = "";
  addNewStudentGuardianNumber = "";
  addNewStudentGuardianOccupation = "";
  addNewStudentGuardianQualification = "";
  addNewStudentGuardianSameFatherAddress = "";
  addNewStudentGuardianAddress = "";
  addNewStudentHouseName = null;
  financeAdminAccess = false;
  superAdminAccess = false;
  feeDafaulterViewAccass = false;
  classTeacherAccess = false;
  driverAccess = false;
  editDesignationState = false;
  editingDesignationId = null;
  pkStaffQualificationId = null;

  editQualificationState = false;
  busSelectionAdd = null;
  studentCategoryListForAdmission = [];

  private URL = AppSettings.API_ENDPOINT;

  tempSelectedStudentId = 0;

  loaderImportStudent = true;

  busListData = [];
  busStopListData = [];
  selectedBusId = 0;
  selectedBusStopId = 0;
  mTotalBusFees = 0;
  generateStudentRegistrationId = "MANUAL";
  selectedStudentsInTable = [];
  selectedStaffsInTable = [];
  studentListTable: any;
  openStudentDeactivatePopup: any;
  studentDeactivatePopupStudentId: any;
  studentDeactivatePopupStudentName: any;

  openStudentTransportOptionSettingsPopup = false;

  studentUpdateHistoryTable = null;
  studentUpdateHistoryList = [];

  openStudentBasicInfoPopup = false;
  studentBasicInfoStudentId: any;
  studentBasicInfoStudentName: any;

  openStudentProfileViewPopup = false;
  studentProfileViewStudentId: any;
  studentProfileViewStudentName: any;

  openStudentContactInfoPopup = false;
  studentContactInfoStudentId: any;
  studentContactInfoStudentName: any;

  onlyOnce = true;

  loaderEditStudent = false;

  classCatId = "";

  amount;
  studentId;
  admissionObj = {};

  selectedCategoryEdit;
  selectedClassEdit;
  selectedSectionEdit;
  schoolClassesEdit = [];
  schoolClassesSectionsEdit = [];

  // token auth
  loginMode = "";

  // import student new one
  // select category function//
  getClassInImport = [];
  getSectionInImport = [];

  getImportStudentsClassId = 0;
  getImportStudentProceedStatus = false;

  importStudentListArray = [];

  fileList = [];
  houseNameList = [];

  selectedBusIdForUpdateStudent;
  isLoading = false;
  debounceTimer: any;
  invalidAddStaffMobileNumber: boolean = false;
  invalidEditStaffMobileNumber: boolean = false;
  invalidAddStudentMobileNumber: boolean = false;
  invalidAddStudentFatherMobileNumber: boolean = false;
  addStaffMobileNumber: string = "";
  addStaffMobileNumberInput: string = "";
  addNewStudentNumberInput: string = "";
  addStudentFatherMobileNumberInput: string = "";
  invalidAddStudentMotherMobileNumber: boolean = false;
  addNewStudentMotherNumberInput: string = "";
  addNewStudentGuardianNumberInput: string = "";
  invalidAddStudentGuardianMobileNumber: boolean = false;

  casteCertificateFileType: string = "";
  speciallyAbledFileType: string = "";
  ewsCertificateFileType: string = "";
  singleGirlChildCertificateFileType: string = "";
  tcOrBirthCertificateFileType: string = "";
  aadharReferenceFileType: string = "";

  isOpenUploadDocument: boolean = false;

  selectStudentFromList() {
    const h = this;
    if (this.onlyOnce) {
      this.onlyOnce = false;

      $("#groups-student-list").on(
        "click",
        "#clicked-on-edit-student-link",
        (e) => {
          h.openEditStudentFromForUpdate(e);
        }
      );
      $("#groups-student-list").on("click", "#student-document-hub", (e) => {
        h.documentHub(e);
      });
      $("#groups-student-list").on(
        "click",
        "#clicked-on-edit-student-contact-link",
        (e) => {
          h.openEditStudentContactFromForUpdate(e);
        }
      );
      $("#groups-student-list").on(
        "click",
        "#clicked-on-delete-student-link",
        (e) => {
          h.initiateDeactivateStudent(e);
        }
      );
      // student-select-check-box
      $("#groups-student-list").on(
        "change",
        "#student-select-check-box",
        (e) => {
          const isSelected = $(e.target).prop("checked");
          h.studentSelectedInTable(isSelected, e);
        }
      );
      $("#groups-student-list").on(
        "click",
        "#edit-student-bus-options",
        (e) => {
          h.openEditStudentTransportOptions(e);
        }
      );
      $("#groups-student-list").on(
        "click",
        "#student-profile-view-action",
        (e) => {
          h.openStudentProfileView(e);
        }
      );
      $("#groups-student-list").on(
        "click",
        "#student-update-history-view-action",
        (e) => {
          h.getStudentUpdateHistoryPopup(e);
        }
      );

      $("#clear-selected-students").on("click", () => {
        h.selectedStudentsInTable = [];
        $("body").find("#multiple-id-cards-trigger").text("");
        $("body").find("#id-print-floating-button").hide();
        $("#groups-student-list").find("input").prop("checked", false);
      });
    }
  }

  selectAllStudentsInTable() {
    const isSelected = $("#student-select-check-box-all").prop("checked");
    $("#groups-student-list").find("input").prop("checked", isSelected);
    // DT_RowId
    this.selectedStudentsInTable = [];
    if (isSelected) {
      const all = this.studentListTable.ajax.json().data;
      for (const item of all) {
        this.selectedStudentsInTable.push(parseInt(item.DT_RowId, 10));
      }
    }
    if (this.selectedStudentsInTable.length > 0) {
      const studentIds = this.selectedStudentsInTable.join(",");
      $("body").find("#multiple-id-cards-trigger").text(studentIds);
      $("body").find("#id-print-floating-button").show();
    } else {
      $("body").find("#id-print-floating-button").hide();
    }
  }

  selectAllStaffsInTable() {
  const isSelected = $("#staff-select-check-box-all").prop("checked");
  $("#staff-list-table").find("input").prop("checked", isSelected);
  
  this.selectedStaffsInTable = [];
  
  if (isSelected) {
    const all = $('#staff-list-table').DataTable().ajax.json().data;
    for (const item of all) {
      const staffId = parseInt(item.staffId, 10);
      
      if (!isNaN(staffId)) {
        this.selectedStaffsInTable.push(staffId);
      } 
    }
  }
  
  if (this.selectedStaffsInTable.length > 0) {
    const staffIds = this.selectedStaffsInTable.join(",");
    $("body").find("#multiple-id-cards-trigger").text(staffIds);
    $("body").find("#id-print-floating-button-staff").show();
  } else {
    $("body").find("#id-print-floating-button-staff").hide();
  }
}

  studentSelectedInTable(isSelected, event) {
    const studentId = parseInt(
      event.target.closest("tr").getAttribute("id"),
      10
    );
    if (isSelected) {
      if (this.selectedStudentsInTable.indexOf(studentId) === -1) {
        this.selectedStudentsInTable.push(studentId);
      }
    } else {
      const itemIndex = this.selectedStudentsInTable.indexOf(studentId);
      this.selectedStudentsInTable.splice(itemIndex, 1);
    }
    if (this.selectedStudentsInTable.length > 0) {
      const studentIds = this.selectedStudentsInTable.join(",");
      $("body").find("#multiple-id-cards-trigger").text(studentIds);
      $("body").find("#id-print-floating-button").show();
    } else {
      $("body").find("#id-print-floating-button").hide();
    }
  }

  staffSelectedInTable(isSelected, event) {
  const row = $(event.target).closest("tr");
  const staffIdAttr = row.attr("id");
  
  const staffId = parseInt(staffIdAttr, 10);
  
 
  if (isNaN(staffId)) {
    return;
  }
  
  if (isSelected) {
    if (this.selectedStaffsInTable.indexOf(staffId) === -1) {
      this.selectedStaffsInTable.push(staffId);
    }
  } else {
    const itemIndex = this.selectedStaffsInTable.indexOf(staffId);
    if (itemIndex !== -1) {
      this.selectedStaffsInTable.splice(itemIndex, 1);
    }
  }
  
  if (this.selectedStaffsInTable.length > 0) {
    const staffIdText = this.selectedStaffsInTable.join(",");
    $("body").find("#multiple-id-cards-trigger").text(staffIdText);
    $("body").find("#id-print-floating-button-staff").show();
  } else {
    $("#staff-select-check-box-all").prop("checked", false);
    $("body").find("#id-print-floating-button-staff").hide();
  }
}

  

  print_bulk_id_cards() {
    const studentIds = this.selectedStudentsInTable.join(",");
    $("body").find("#multiple-id-cards-trigger").text(studentIds);
    $("body")
      .find("#multiple-id-cards-trigger")
      .attr("selected-academic", this.academicInfo.current_academic);
    //  this.headerComponent.print_bulk_id_cards(studentIds)
  }

  openEditStudentContactFromForUpdate(event) {
    const studentId = event.target.closest("tr").getAttribute("id");
    this.studentContactInfoStudentId = event.target
      .closest("tr")
      .getAttribute("id");
    this.studentContactInfoStudentName = event.target
      .closest("tr")
      .getAttribute("studentName");
    this.openStudentContactInfoPopup = true;
  }

  openEditStudentFromForUpdate(event) {
    const studentId = event.target.closest("tr").getAttribute("id");
    this.studentBasicInfoStudentId = event.target
      .closest("tr")
      .getAttribute("id");
    this.studentBasicInfoStudentName = event.target
      .closest("tr")
      .getAttribute("studentName");
    this.openStudentBasicInfoPopup = true;
    // this.headerComponent.openEditStudentFrom(studentId,null);
  }


  documentHub(event) {
    this.registrationIdDocHub = event.target
    .closest("tr").querySelector(".registration-id").innerText
    this.isOpenUploadDocument = false;
    this.documentTypesInfo = [];
    this.studentBasicInfoStudentId = event.target
      .closest("tr")
      .getAttribute("id");
    this.studentBasicInfoStudentName = event.target
      .closest("tr")
      .getAttribute("studentName");
    this.fetchInfoForDocument();
    $("#documentHubData").modal("show");
  }

  openEditStudentTransportOptions(event) {
    this.studentDeactivatePopupStudentId = event.target
      .closest("tr")
      .getAttribute("id");
    this.studentDeactivatePopupStudentName = event.target
      .closest("tr")
      .getAttribute("studentName");
    this.openStudentTransportOptionSettingsPopup = true;
  }

  afterTransportOptionsSaved() {
    this.openStudentTransportOptionSettingsPopup = false;
    // this.searchStudent();
  }

  transportOptionsPopupClose() {
    this.openStudentTransportOptionSettingsPopup = false;
  }

  afterStudentBasicInfoSaved() {
    this.openStudentBasicInfoPopup = false;
  }

  studentBasicInfoPopupClose() {
    this.openStudentBasicInfoPopup = false;
  }

  afterStudentContactInfoSaved() {
    this.openStudentContactInfoPopup = false;
  }

  studentContactInfoPopupClose() {
    this.openStudentContactInfoPopup = false;
  }

  /*
   * Student profile view
   * */
applyStudentUpdateHistoryTable() {
  if (this.studentUpdateHistoryTable === null) {

    this.translate.get([
      'dataTables.sEmptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.zeroRecords',
      'dataTables.paginate.previous',
      'dataTables.paginate.next'
    ]).subscribe(translations => {
      this.studentUpdateHistoryTable = $(
        "#student-update-history-component-table"
      ).DataTable({
        dom: "lCfrtip",
        order: [],
        colVis: {
          buttonText: "Columns",
          overlayFade: 0,
          align: "right",
        },
        language: {
          emptyTable: translations['dataTables.sEmptyTable'],
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i> ' + translations['dataTables.search'],
          info: translations['dataTables.info'],
          zeroRecords: translations['dataTables.zeroRecords'],
          paginate: {
            previous: '<i class="fa fa-angle-left"></i> ' + translations['dataTables.paginate.previous'],
            next: translations['dataTables.paginate.next'] + ' <i class="fa fa-angle-right"></i>'
          }
        },
        columnDefs: [
          {
            targets: [1, 2],
            createdCell: function (td, cellData, rowData, row, col) {
              $(td).addClass("wordWrap");
            },
          },
        ],
      });
    });

  }
}



  getStudentUpdateHistoryPopup(event) {
    $("#studentInfoName").text("");
    $("#studentInfoRegistration").text("");
    this.applyStudentUpdateHistoryTable();
    this.studentUpdateHistoryTable.clear().draw();
    let studentId = event.target.closest("tr").getAttribute("id");
    let params = {
      academicId: this.academicInfo.current_academic,
      studentId: studentId,
    };
    this.groupservice.fetchStudentUpdateHistory(params).subscribe(
      (data: any) => {
        const h = this;
        if (data.errorcode) {
          console.error("errorcode ", data.errorcode);
        } else {
          const rows = [];
          $("#studentInfoName").text(data.studentInfo.studentName);
          $("#studentInfoRegistration").text(data.studentInfo.registrationId);
          this.studentUpdateHistoryList = data.studentUpdateHistory;
          this.studentUpdateHistoryList.forEach((tr) => {
            const result = tr.ColumnName.replace(/([A-Z])/g, " $1");
            const text = result.charAt(0).toUpperCase() + result.slice(1);
            let dateToDisplay = moment_js(tr.UpdatedOn).format(
              "DD-MMM-YYYY hh:mm a"
            );
            let isImage = false;
            let oldValue = tr.OldValue;
            let newValue = tr.NewValue;
            if (
              tr.ColumnName === "studentImage" ||
              tr.ColumnName === "fatherImage" ||
              tr.ColumnName === "motherImage" ||
              tr.ColumnName === "guardianImage"
            ) {
              isImage = true;
              const html = `<img src=${oldValue} style="width: 60px;height: 60px" />`;
              const htmlDom = $(html);
              oldValue = htmlDom[0].outerHTML;
              const html2 = `<img src=${newValue} style="width: 60px;height: 60px" />`;
              const htmlDom2 = $(html2);
              newValue = htmlDom2[0].outerHTML;
            } else if (
              tr.ColumnName === "dateOfBirth" ||
              tr.ColumnName === "dateOfAdmission"
            ) {
              oldValue = moment_js(tr.OldValue, "YYYY-MM-DD").format(
                "DD-MMM-YYYY"
              );
              newValue = moment_js(tr.NewValue, "YYYY-MM-DD").format(
                "DD-MMM-YYYY"
              );
            } else if (tr.ColumnName === "gender") {
              oldValue = tr.OldValue == 0 ? "Female" : "Male";
              newValue = tr.NewValue == 0 ? "Female" : "Male";
            }
            rows.push([text, oldValue, newValue, tr.UpdatedBy, dateToDisplay]);
          });
          this.studentUpdateHistoryTable.rows.add(rows).draw();
        }
      },
      (error) => {
        console.error("error ", error);
      }
    );
  }

  openStudentProfileView(event) {
    const studentId = event.target.closest("tr").getAttribute("id");
    this.studentProfileViewStudentId = event.target
      .closest("tr")
      .getAttribute("id");
    this.studentProfileViewStudentName = event.target
      .closest("tr")
      .getAttribute("studentName");
    this.openStudentProfileViewPopup = true;
  }

  studentProfileViewClose() {
    this.openStudentProfileViewPopup = false;
  }

  handleStudentViewFromList(event) {
    $("#edit_student_select_all_terms").attr("checked", false);
    this.mTotalBusFees = 0;
    this.busListData = [];
    // this.busStopListData = [];
    this.studentSelectedTerms = [];
    this.newStudentSelectedTerms = [];
    this.viewStudentTerms = [];
    this.viewStudentTermIds = [];
    if (
      this.tempSelectedStudentId !==
        event.target.closest("tr").getAttribute("id") ||
      true
    ) {
      this.tempSelectedStudentId = event.target
        .closest("tr")
        .getAttribute("id");
      this.selectedStudentListId = event.target
        .closest("tr")
        .getAttribute("id");
      this.offcanvas.handleOffcanvasOpen("#offcanvas-view-student");

      this.groupservice
        .getSelectedStudentDetail(this.selectedStudentListId, this.getAuthToken)
        .subscribe(
          (data: any) => {
            this.selectedStudentname = data.studentDetail.studentName;
            this.selectedStudentimage = data.studentDetail.studentImage;
            this.selectedStudentsurname = data.studentDetail.surname;
            this.selectedStudentemail = data.studentDetail.studentEmail;
            this.selectedStudentMobileCountryCode =
              data.studentDetail.countryCode;
            this.selectedStudentcontact = data.studentDetail.studentPhone;
            this.selectedStudentadmissiondate =
              data.studentDetail.dateOfAdmission;
            this.selectedStudentadmissionnumber =
              data.studentDetail.registrationId;
            this.selectedStudentdateofbirth = data.studentDetail.dateOfBirth;
            this.selectedStudentCategory = data.studentDetail.studentCategory;

            if (data.studentDetail.gender === 1) {
              this.selectedStudentgender = true;
            } else if (data.studentDetail.gender === 0) {
              this.selectedStudentgender = false;
            } else {
              this.selectedStudentgender = false;
            }
            this.groupservice
              .getClassDetailWithClassId(
                data.studentDetail.classId,
                this.getAuthToken
              )
              .subscribe(
                (classData: any) => {
                  if (classData.classDetail) {
                    this.selectedStudentclasscategory =
                      classData.classDetail.categoryName;
                    this.selectedStudentclassname =
                      classData.classDetail.className;
                    this.selectedStudentclasssection =
                      classData.classDetail.classSection;

                    this.selectedStudentclasscategoryId =
                      classData.classDetail.categoryId;
                    this.selectedStudentclassnameId =
                      classData.classDetail.classNameId;
                    this.selectedStudentclasssectionId =
                      classData.classDetail.classSectionId;
                    this.sectionIdChange = this.selectedStudentclasssectionId;
                  }
                },
                (error) => {}
              );

            this.selectedStudentclassid = data.studentDetail.rollNumber;

            if (data.studentDetail.isAppUser === 0) {
              this.selectedStudentbwappstatus = false;
            } else if (data.studentDetail.isAppUser === 1) {
              this.selectedStudentbwappstatus = true;
            } else {
              this.selectedStudentbwappstatus = false;
            }

            if (data.studentDetail.isBlocked === 0) {
              this.selectedStudentaccountstatus = true;
            } else if (data.studentDetail.isBlocked === 1) {
              this.selectedStudentaccountstatus = false;
            } else {
              this.selectedStudentaccountstatus = true;
            }
            this.selectedStudentfathername = data.studentDetail.parentName;
            $("#edit-student-fathername").val(
              data.studentDetail.parentName || ""
            );
            this.selectedStudentfathercontact = data.studentDetail.mobileNumber;
            $("#edit-student-fathernum").val(data.studentDetail.mobileNumber);
            this.selectedStudentfatheroccupation =
              data.studentDetail.fatherOccupation;
            $("#edit-student-father-occupation").val(
              data.studentDetail.fatherOccupation || ""
            );
            this.selectedStudentfatherqualification =
              data.studentDetail.fatherQualification;
            $("#edit-student-fatherqual").val(
              data.studentDetail.fatherQualification || ""
            );
            this.selectedStudentfatheraddress = data.studentDetail.address;
            $("#edit-student-fatheraddress").val(
              data.studentDetail.address || ""
            );
            this.selectedStudentmothername = data.studentDetail.motherName;
            $("#edit-student-mothername").val(
              data.studentDetail.motherName || ""
            );
            this.selectedStudentmothercontact = data.studentDetail.motherPhone;
            $("#edit-student-mothernum").val(data.studentDetail.motherPhone);
            this.selectedStudentmotheroccupation =
              data.studentDetail.motherOccupation;
            $("#edit-student-mother-occupation").val(
              data.studentDetail.motherOccupation
            );
            this.selectedStudentmotherqualification =
              data.studentDetail.motherQualification;
            $("#edit-student-motherqual").val(
              data.studentDetail.motherQualification || ""
            );
            this.selectedStudentmotheraddress =
              data.studentDetail.motherAddress;
            $("#edit-student-motheradd").val(data.studentDetail.motherAddress);
            this.selectedStudentguardianname = data.studentDetail.guardianName;
            $("#edit-student-guardianname").val(
              data.studentDetail.guardianName || ""
            );
            this.selectedStudentguardiancontact =
              data.studentDetail.guardianPhone;
            $("#edit-student-guardiannum").val(
              data.studentDetail.guardianPhone
            );
            this.selectedStudentguardianoccupation =
              data.studentDetail.guardianOccupation;
            $("#edit-student-gardian-occupation").val(
              data.studentDetail.guardianOccupation
            );
            this.selectedStudentguardianqualification =
              data.studentDetail.guardianQualification;
            $("#edit-student-guardianqual").val(
              data.studentDetail.guardianQualification || ""
            );
            this.selectedStudentguardianaddress =
              data.studentDetail.guardianAddress;
            $("#edit-student-guardianadd").val(
              data.studentDetail.guardianAddress || ""
            );
            this.selectedStudentEditclassid = this.selectedStudentclassid;
            this.selectedStudentEditbwappstatus =
              this.selectedStudentbwappstatus;
            this.selectedStudentEditaccountstatus =
              this.selectedStudentaccountstatus;
            this.mTotalBusFees = 0;

            const studentDetailData = data;
            const h1 = this;

            if (
              studentDetailData.studentDetail.busId &&
              studentDetailData.studentDetail.stopId
            ) {
              let stopName = "";

              $("#bus-stop-selection-edit").val(
                studentDetailData.studentDetail.stopId
              );
              $("#bus-stop-selection-view").val(
                studentDetailData.studentDetail.stopId
              );
              for (const item of this.busStopListData) {
                if (
                  item.PkBusStopId === studentDetailData.studentDetail.stopId
                ) {
                  this.mTotalBusFees = item.fare;
                  stopName = item.BusStopName;
                  h1.isTermsVisible = true;
                }
              }
              this.isTermsVisible = true;
              this.transportservice
                .getBusListForStop(
                  studentDetailData.studentDetail.stopId,
                  this.academicInfo.current_academic,
                  localStorage.getItem("usertoken")
                )
                .subscribe(
                  async (busData: any) => {
                    this.busListData = busData;
                    if (this.busListData.length === 0) {
                      const thereAreNoBusesPassingThroughTheStopTranslation = await firstValueFrom(this.translate.get('thereAreNoBusesPassingThroughTheStop'));
                      customToastr(thereAreNoBusesPassingThroughTheStopTranslation +stopName,"error");
                    }
                    setTimeout(() => {
                      // $('body').find("#bus-stop-selection-edit").val(studentDetailData.studentDetail.busId || '0');
                      $("body")
                        .find("#bus-selection-edit")
                        .val(studentDetailData.studentDetail.busId || "0");
                      $("body")
                        .find("#bus-selection-view")
                        .val(studentDetailData.studentDetail.busId || "0");
                    }, 50);
                  },
                  (error) => {
                    this.busListData = [];
                  }
                );
              this.transportservice
                .getStudentTermsDetail(
                  this.selectedStudentListId,
                  this.getAuthToken
                )
                .subscribe(
                  (termData: any) => {
                    if (termData.success === true) {
                      const studentTerms = termData.data;
                      const sortedTerms = [];
                      for (let i = studentTerms.length - 1; i >= 0; i--) {
                        sortedTerms.push(studentTerms[i]);
                      }
                      for (const item of sortedTerms) {
                        if (item.isSelectedTerm === undefined) {
                          item.isSelectedTerm = false;
                        } else if (item.isSelectedTerm) {
                          this.viewStudentTerms.push(item);
                          this.viewStudentTermIds.push(item.pkBusStopTermId);
                        }
                        if (item.isPaid === undefined) {
                          item.isPaid = false;
                        }
                        item.isEditable = !item.isPaid;
                      }
                      this.studentSelectedTerms = sortedTerms;
                      this.newStudentSelectedTerms = sortedTerms;
                      $("#edit_student_select_all_terms").attr(
                        "checked",
                        this.viewStudentTermIds.length ===
                          this.studentSelectedTerms.length
                      );
                    }
                  },
                  (error) => {}
                );
            } else {
              this.isTermsVisible = false;
              $("body").find("#bus-stop-selection-edit").val("0");
              $("body").find("#bus-stop-selection-view").val("0");
              $("body").find("#bus-selection-edit").val("0");
              $("body").find("#bus-selection-view").val("0");
            }
          },
          (error) => {}
        );
    }
  }
  /*Validation for update student*/

  //  Vaidation for Onchange border Red for edit student

  getBusFare(studentStop) {
    const h = this;

    setTimeout(() => {
      $("body").find("#bus-stop-selection-view").val(studentStop);
      $("body").find("#bus-stop-selection-edit").val(studentStop);
    }, 50);

    this.busStopListData.forEach((item) => {
      if (item.pkBusStopId === studentStop) {
        h.mTotalBusFees = item.fare;
      }
    });
  }

  getStopListForRouteViewStudent(routeId, studentStop) {
    this.transportservice
      .getstopsOfRoute(
        null,
        routeId,
        this.academicInfo.current_academic,
        localStorage.getItem("usertoken")
      )
      .subscribe(
        (data: any) => {
          // this.busStopListData = data;
          //
          this.getBusFare(studentStop);
        },
        (error) => {}
      );
  }

  editStudentAdmissionNumOnchange() {
    const regNo = $("#edit-student-admissionnum").val();
    if (!this.formValidator.validateIsData(regNo)) {
      $("#edit-student-admissionnum").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-admissionnum").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentNameOnchange(editstudentName) {
    const validStudentName = this.formValidator.validateFieldName(
      editstudentName,
      "Student "
    );
    if (validStudentName) {
      $("#edit-studentname").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-studentname").removeClass("validateErrorforAddStudent");
    }
  }

  callClass() {
    $("#hidetextboxedit").removeClass("hide");
    this.offcanvas.handleOffcanvasOpen("#offcanvas-edit-student");
    this.classCatId = this.selectedStudentclasscategoryId;
  }

  editStaffOffcanvas() {
    $("#hideforstaffedit").removeClass("hide");
    this.offcanvas.handleOffcanvasOpen("#offcanvas-edit-staff");
    this.invalidEditStaffMobileNumber = false;
  }

  viewStaffOffcanvas() {
    this.offcanvas.handleOffcanvasOpen("#offcanvas-view-staff");
  }

  viewStudentOffcanvas() {
    this.offcanvas.handleOffcanvasOpen("#offcanvas-view-student");
  }

  offcanvasViewStudent() {
    this.offcanvas.handleOffcanvasOpen("#offcanvas-view-student");
  }

  viewOffcanvasStudent() {
    this.offcanvas.handleOffcanvasOpen("#offcanvas-view-student");
  }

  editStudentSurNameOnchange(editstudentSurname) {
    if ($.isNumeric(editstudentSurname)) {
      $("#edit-student-surname").addClass("input-validator");
    } else {
      $("#edit-student-surname").removeClass("input-validator");
    }
  }

  editStudentContactOnchange(editstudentStudentContactnNumber) {
    const validateStudentContact =
      this.formValidator.validateMobileNumberForNewAdmission(
        this.strings.student,
        editstudentStudentContactnNumber
      );
    if (validateStudentContact) {
      $("#edit-student-num").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-num").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentEmailOnchange(editstudentStudentEmail) {
    if (
      this.formValidator.validateIsData(editstudentStudentEmail) &&
      !this.formValidator.validateIsEmail(editstudentStudentEmail)
    ) {
      $("#edit-student-email").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-email").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentChangeclassRoll(editstudentStudentClassId) {
    if (!this.formValidator.validateDropdownData(editstudentStudentClassId)) {
      $("#edit-student-roll").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-roll").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentChangeFatherName(editstudentFatherName) {
    if (
      (!this.formValidator.validateIsData(editstudentFatherName) &&
        !this.formValidator.validateName(editstudentFatherName)) ||
      $.isNumeric(editstudentFatherName)
    ) {
      $("#edit-student-fathername").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-fathername").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentChangeFatherNumber(editstudentFatherContact) {
    const errorMessage = this.formValidator.validateMobileNumberForNewAdmission(
      this.strings.father,
      editstudentFatherContact
    );
    if (errorMessage) {
      $("#edit-student-fathernum").addClass("validateErrorforAddStudent");
      customToastr(errorMessage, "error");
    } else {
      $("#edit-student-fathernum").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentChangeFatherQualification(editstudentFatherQualifiation) {
    if ($.isNumeric(editstudentFatherQualifiation)) {
      $("#edit-student-fatherqual").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-fatherqual").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentChangeFatherAdress(editstudentFatherAddress) {
    if (
      !this.formValidator.validateIsData(editstudentFatherAddress) ||
      $.isNumeric(editstudentFatherAddress)
    ) {
      $("#edit-student-fatheraddress").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-fatheraddress").removeClass(
        "validateErrorforAddStudent"
      );
    }
  }

  editStudentChangeMotherName(editstudentMotherName) {
    if (
      (!this.formValidator.validateIsData(editstudentMotherName) &&
        !this.formValidator.validateName(editstudentMotherName)) ||
      $.isNumeric(editstudentMotherName)
    ) {
      $("#edit-student-mothername").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-mothername").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentChangeMotherNumber(editstudentMotherContact) {
    if (
      this.formValidator.validateMobileNumberForNewAdmission(
        this.strings.mother,
        editstudentMotherContact
      )
    ) {
      $("#edit-student-mothernum").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-mothernum").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentMotherQualificationOnchange(editstudentMotherQualifiation) {
    if ($.isNumeric(editstudentMotherQualifiation)) {
      $("#edit-student-motherqual").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-motherqual").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentMotherAddress(editstudentMotherAddress) {
    if (
      !this.formValidator.validateIsData(editstudentMotherAddress) ||
      $.isNumeric(editstudentMotherAddress)
    ) {
      $("#edit-student-motheradd").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-motheradd").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentGuardianNameOnchange(editstudentGuardianName) {
    if ($.isNumeric(editstudentGuardianName)) {
      $("#edit-student-guardianname").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-guardianname").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentGuardianNumberOnchange(editstudentGuardianContact) {
    const errorMessage = this.formValidator.validateMobileNumberForNewAdmission(
      this.strings.mother,
      editstudentGuardianContact
    );
    if (errorMessage) {
      $("#edit-student-guardiannum").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-guardiannum").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentGuardianQualificationOnchange(editstudentGuardianQualifiation) {
    if ($.isNumeric(editstudentGuardianQualifiation)) {
      $("#edit-student-guardianqual").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-guardianqual").removeClass("validateErrorforAddStudent");
    }
  }

  editStudentGuardianAddressOnchange(editstudentGuardianAddress) {
    if ($.isNumeric(editstudentGuardianAddress)) {
      $("#edit-student-guardianadd").addClass("validateErrorforAddStudent");
    } else {
      $("#edit-student-guardianadd").removeClass("validateErrorforAddStudent");
    }
  }

  openbrowsertouplaodphotoeditstudent() {
    $("#openbrowserforeditstudent").trigger("click");
  }

  // update selected student details
  async updateSelectedStudentDetails(
    editstudentName,
    editstudentStudentClassId,
    editstudentSurname,
    editstudentStudentEmail,
    editstudentStudentContactnNumber,
    editstudentStudentDOB,
    editstudentStudentGenderMale,
    editstudentStudentGenderFemale,
    editstudentStudentAppStausConnected,
    editstudentStudentAppStausDisConnected,
    editstudentStudentAccountActive,
    editstudentStudentAccountDeActive,
    reasonForDeactiveStudent,
    editstudentFatherName,
    editstudentFatherContact,
    editstudentFatherOccupation,
    editstudentFatherQualifiation,
    editstudentFatherAddress,
    editstudentMotherName,
    editstudentMotherContact,
    editstudentMotherOccupation,
    editstudentMotherQualifiation,
    editstudentMotherAddress,
    editstudentGuardianName,
    editstudentGuardianContact,
    editstudentGuardianOccupation,
    editstudentGuardianQualifiation,
    editstudentGuardianAddress,
    editstudentStudentMobCountryCode
  ) {
    const sectionId = $("#edit-student-section").val();

    let studentGender;
    let studentBluewingsAppStatus;
    let studentAccountStatus;

    const accountStatusActive = $("#accountStatusActive").prop("checked");
    const accountStatusDeactive = $("#accountStatusDeActive").prop("checked");

    if (
      accountStatusDeactive &&
      !this.formValidator.validateIsData(reasonForDeactiveStudent)
    ) {
     const pleaseEnterReasonForDeactivateStudentTranslation = await firstValueFrom(this.translate.get('pleaseEnterReasonForDeactivateStudent')); 
     customToastr(pleaseEnterReasonForDeactivateStudentTranslation, 'error');
      return;
    }

    // gender
    if ($(".statusGenderMale").hasClass("active")) {
      studentGender = 1;
    } else if ($(".statusGenderFemale").hasClass("active")) {
      studentGender = 0;
    }

    // appStatus
    if ($("#appStatusConected").prop("checked") === true) {
      studentBluewingsAppStatus = 1;
    } else if ($("#appStatusDisConneted").prop("checked") === true) {
      studentBluewingsAppStatus = 0;
    }

    // accountStatus
    if ($("#accountStatusActive").prop("checked") === true) {
      studentAccountStatus = 0;
    } else if ($("#accountStatusDeActive").prop("checked") === true) {
      studentAccountStatus = 1;
    }

    editstudentName = $.trim(editstudentName);
    const editStudentAdmissionnum = $.trim(
      $("#edit-student-admissionnum").val()
    );
    editstudentStudentClassId = $.trim(editstudentStudentClassId);
    editstudentSurname = $.trim(editstudentSurname);
    editstudentStudentEmail = $.trim(editstudentStudentEmail);
    editstudentStudentContactnNumber = $.trim(editstudentStudentContactnNumber);
    reasonForDeactiveStudent = $.trim(reasonForDeactiveStudent);

    editstudentFatherName = $.trim($("#edit-student-fathername").val());
    editstudentFatherContact = $.trim($("#edit-student-fathernum").val());
    editstudentFatherQualifiation = $.trim($("#edit-student-fatherqual").val());
    editstudentFatherAddress = $.trim($("#edit-student-fatheraddress").val());
    editstudentFatherOccupation = $("#edit-student-father-occupation").val();

    editstudentMotherName = $.trim($("#edit-student-mothername").val());
    editstudentMotherContact = $.trim($("#edit-student-mothernum").val());
    editstudentMotherQualifiation = $.trim($("#edit-student-motherqual").val());
    editstudentMotherAddress = $.trim($("#edit-student-motheradd").val());
    editstudentMotherOccupation = $("#edit-student-mother-occupation").val();

    editstudentGuardianName = $.trim($("#edit-student-guardianname").val());
    editstudentGuardianContact = $.trim($("#edit-student-guardiannum").val());
    editstudentGuardianQualifiation = $.trim(
      $("#edit-student-guardianqual").val()
    );
    editstudentGuardianAddress = $.trim($("#edit-student-guardianadd").val());
    editstudentGuardianOccupation = $.trim(
      $("#edit-student-gardian-occupation").val()
    );

    let busId = $("body").find("#bus-selection-edit").val();
    let stopId = $("body").find("#bus-stop-selection-edit").val();

    if (
      !this.formValidator.validateIsDataForNumber(
        this.selectedBusIdForUpdateStudent
      )
    ) {
      busId = null;
    }

    if (!this.formValidator.validateIsDataForNumber(stopId) || stopId === 0) {
      stopId = null;
    }

    if (stopId && !this.selectedBusIdForUpdateStudent) {
      const pleaseSelectBusAlsoTranslation = await firstValueFrom(this.translate.get('pleaseSelectBusAlso')); 
      customToastr(pleaseSelectBusAlsoTranslation, 'error');
      return;
    }
    const validateMobileNumber =
      this.formValidator.validateMobileNumberForNewAdmission(
        this.strings.father,
        editstudentFatherContact
      );
    if (
      (!this.formValidator.validateIsData(editstudentName) &&
        !this.formValidator.validateName(editstudentName)) ||
      $.isNumeric(editstudentName)
    ) {
      const studentNameIsMissingPleaseEnterAValidNameTranslation = await firstValueFrom(this.translate.get('studentNameIsMissingPleaseEnterAValidName')); 
      customToastr(studentNameIsMissingPleaseEnterAValidNameTranslation, 'error');
    } else if (!this.formValidator.validateIsData(editstudentStudentDOB)) {
      const enterStudentDobTranslation = await firstValueFrom(this.translate.get('enterStudentDob')); 
      customToastr(enterStudentDobTranslation, 'error');
    } else if (
      (!this.formValidator.validateIsData(editstudentFatherName) &&
        !this.formValidator.validateName(editstudentFatherName)) ||
      $.isNumeric(editstudentFatherName)
    ) {
     const enterStudentFatherNamePleaseEnterAValidNameTranslation = await firstValueFrom(this.translate.get('enterStudentFatherNamePleaseEnterAValidName')); 
     customToastr(enterStudentFatherNamePleaseEnterAValidNameTranslation, 'error');
    } else if (
      !this.formValidator.validateIsData(editstudentFatherContact) ||
      this.formValidator.validateMobileNumberForNewAdmission(
        this.strings.father,
        editstudentFatherContact
      )
    ) {
      const enterValidStudentFatherContactNumber10DigitsOnlyTranslation = await firstValueFrom(this.translate.get('enterValidStudentFatherContactNumber10DigitsOnly')); 
      customToastr(enterValidStudentFatherContactNumber10DigitsOnlyTranslation, 'error');
    } else if (!this.formValidator.validateIsData(editstudentFatherAddress)) {
      const enterStudentFatherAddressTranslation = await firstValueFrom(this.translate.get('enterStudentFatherAddress')); 
      customToastr(enterStudentFatherAddressTranslation, 'error');
    } else if (!this.formValidator.validateIsData(editStudentAdmissionnum)) {
      const enterStudentRegistrationNumberTranslation = await firstValueFrom(this.translate.get('enterStudentRegistrationNumber'));
       customToastr(enterStudentRegistrationNumberTranslation, 'error');
    } else {
      const d = editstudentStudentDOB.split("/");
      editstudentStudentDOB = "" + d[2] + "-" + d[1] + "-" + d[0] + "";
      this.loaderEditStudent = true;

      this.admissionObj = {
        studentId: this.selectedStudentListId,
        studentName: editstudentName,
        rollNumber: editstudentStudentClassId,
        classId: sectionId,
        parentName: editstudentFatherName,
        studentEmail: editstudentStudentEmail,
        dateOfBirth: editstudentStudentDOB,
        mobileNumber: editstudentFatherContact,
        address: editstudentFatherAddress,
        surname: editstudentSurname,
        reason: reasonForDeactiveStudent,
        studentPhone: editstudentStudentContactnNumber,
        fatherOccupation: editstudentFatherOccupation,
        fatherQualification: editstudentFatherQualifiation,
        motherName: editstudentMotherName,
        motherPhone: editstudentMotherContact,
        countryCode: editstudentStudentMobCountryCode,
        motherCountryCode:this.motherCountryCode,
        guardianCountryCode:this.guardianCountryCode,
        studentCountryCode: this.studentCountryCode,
        motherOccupation: editstudentMotherOccupation,
        motherQualification: editstudentMotherQualifiation,
        motherAddress: editstudentMotherAddress,
        guardianName: editstudentGuardianName,
        guardianPhone: editstudentGuardianContact,
        guardianOccupation: editstudentGuardianOccupation,
        guardianQualification: editstudentGuardianQualifiation,
        guardianAddress: editstudentGuardianAddress,
        registrationId: editStudentAdmissionnum,
        gender: studentGender,
        isAppUser: studentBluewingsAppStatus,
        isBlocked: studentAccountStatus,
        busId: this.selectedBusIdForUpdateStudent,
        stopId,
        busTerms: this.viewStudentTermIds,
        busTermStatuses: this.studentSelectedTerms,
      };
      if (sectionId !== this.selectedStudentclasssectionId) {
        this.groupservice
          .fetchingFeesDetailForUpdate(
            sectionId,
            this.selectedStudentListId,
            this.getAuthToken
          )
          .subscribe(
            (data: any) => {
              if (data.length > 0 && data[0].length > 0) {
                this.studentId = data[0][0].student;
                this.amount = data[0][0].amount;
              } else {
                this.studentId = null;
                this.amount = null;
              }

              if (this.studentId || this.amount) {
                $("#notificationForFees").modal("show");
              } else {
                this.updateStudentDetail();
              }
            },
            (error) => {}
          );
      } else {
        this.updateStudentDetail();
      }
    }
  }

  updateStudentDetail() {
    this.groupservice
      .updateStudentDetails(this.admissionObj, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          console.log("updateStudentDetails::",data);
          this.loaderEditStudent = false;
          if (data.status === true) {
            const studentDetailsUpdatedTranslation = await firstValueFrom(this.translate.get('studentDetailsUpdated')); 
            customToastr(studentDetailsUpdatedTranslation, 'success');
            $("#closeUpdateSt").trigger("click");
            $("#notificationpopupclose").trigger("click");
            this.getGroupsClassCategories(this.getSchoolId);
            this.getAllShoolClass(this.getSchoolId);
          } else {
            if (data.message) {
              $("body").find("#bus-selection-edit").val(this.selectedBusId);
              $("body")
                .find("#bus-stop-selection-edit")
                .val(this.selectedBusStopId);
              customToastr(data.message, "error");
            } else {
              const studentDetailsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('studentDetailsNotUpdatedPleaseTryAgain')); customToastr(studentDetailsNotUpdatedPleaseTryAgainTranslation, 'error');
            }
          }
        },
        (error) => {}
      );
  }

  confirmToUpdate() {
    this.updateStudentDetail();
  }

  // select category function
  selectcategoryFunction(selectedCategoryId) {
    this.selectedCategory = selectedCategoryId;
    this.selectedSection = null;
    this.initDataTableServerProcess(
      "groups-student-list",
      this.getSchoolId,
      this.getAuthToken,
      this.academicInfo.current_academic,
      this.selectedCategory,
      "null",
      "null"
    );

    this.selectStudentFromList();
    if (selectedCategoryId !== 0) {
      this.selectClassStatus = false;
      this.schoolClasses = [];
      this.schoolClassesSections = [];
      this.groupservice
        .groupsAvailableClass(
          this.getSchoolId,
          this.selectedCategory,
          localStorage.getItem("usertoken")
        )
        .subscribe(
          (data: any) => {
            for (const item of data.className) {
              this.schoolClasses.push(item);
            }
            this.loader = false;
            this.preLoader = true;
          },
          (error) => {}
        );
    } else {
      this.schoolClasses = [];
      this.schoolClassesSections = [];

      this.selectClassStatus = true;
      this.selectClassSectionStatus = true;

      this.selectedCategory = null;
      this.selectedClass = null;
      this.selectedSection = null;
    }
  }

  // select category function for add student
  selectcategoryFunctionAdd(selectedCategoryId) {
    this.selectedCategoryAdd = null;
    this.selectedClassAdd = null;
    this.selectedSectionAdd = null;

    this.selectedCategoryAdd = selectedCategoryId;
    if (selectedCategoryId !== 0) {
      this.loaderAddStudent = true;
      this.selectClassStatusAdd = false;
      this.schoolClassesAdd = [];
      this.schoolClassesSectionsAdd = [];
      this.groupservice
        .groupsAvailableClass(
          this.getSchoolId,
          this.selectedCategoryAdd,
          localStorage.getItem("usertoken")
        )
        .subscribe(
          (data: any) => {
            try {
              for (const item of data.className) {
                this.schoolClassesAdd.push(item);
              }
              this.loaderAddStudent = false;
            } catch (e) {
              this.loaderAddStudent = false;
            }
          },
          (error) => {
            this.loaderAddStudent = false;
          }
        );
    } else {
      this.loaderAddStudent = false;
      this.schoolClassesAdd = [];
      this.schoolClassesSectionsAdd = [];

      this.selectClassStatusAdd = true;
      this.selectClassSectionStatusAdd = true;

      this.selectedCategoryAdd = null;
      this.selectedClassAdd = null;
      this.selectedSectionAdd = null;
    }
  }

  selectcategoryFunctionEdit(selectedCategoryId) {
    this.selectedCategoryEdit = null;
    this.selectedClassEdit = null;
    this.selectedSectionEdit = null;
    this.selectedCategoryEdit = selectedCategoryId;
    if (selectedCategoryId !== 0) {
      this.schoolClassesEdit = [];
      this.schoolClassesSectionsEdit = [];
      this.groupservice
        .groupsAvailableClass(
          this.getSchoolId,
          this.selectedCategoryEdit,
          localStorage.getItem("usertoken")
        )
        .subscribe(
          (data: any) => {
            try {
              for (const item of data.className) {
                this.schoolClassesEdit.push(item);
              }
            } catch (e) {}
          },
          (error) => {}
        );
    } else {
      this.schoolClassesEdit = [];
      this.schoolClassesSectionsEdit = [];
      this.selectedCategoryEdit = null;
      this.selectedClassEdit = null;
      this.selectedSectionEdit = null;
    }
  }

  // select class function
  selectclassFunction(selectedClassId) {
    this.selectedClass = selectedClassId;
    this.selectedSection = null;
    if (selectedClassId !== 0 || this.selectedCategory !== 0) {
      this.selectClassSectionStatus = false;
      this.schoolClassesSections = [];
      this.initDataTableServerProcess(
        "groups-student-list",
        this.getSchoolId,
        this.getAuthToken,
        this.academicInfo.current_academic,
        this.selectedCategory,
        this.selectedClass,
        "null"
      );
      this.groupservice
        .groupsAvailableClassSection(
          this.selectedClass,
          localStorage.getItem("usertoken")
        )
        .subscribe(
          (data: any) => {
            for (const item of data) {
              this.schoolClassesSections.push(item);
            }
          },
          (error) => {}
        );
    } else {
      this.schoolClassesSections = [];
      this.selectClassSectionStatus = true;
      this.selectedClass = null;
      this.selectedSection = null;
    }
  }

  // select class function for add student
  selectclassFunctionAdd(selectedClassId) {
    this.selectedClassAdd = null;
    this.selectedSectionAdd = null;
    this.selectedClassAdd = selectedClassId;
    if (selectedClassId !== 0 && this.selectedCategoryAdd !== 0) {
      this.selectClassSectionStatusAdd = false;
      this.schoolClassesSectionsAdd = [];
      this.loaderAddStudent = true;
      this.groupservice
        .groupsAvailableClassSection(
          this.selectedClassAdd,
          localStorage.getItem("usertoken")
        )
        .subscribe(
          (data: any) => {
            try {
              for (const item of data) {
                this.schoolClassesSectionsAdd.push(item);
              }
              this.loaderAddStudent = false;
            } catch (e) {
              this.loaderAddStudent = false;
            }
          },
          (error) => {
            this.loaderAddStudent = false;
          }
        );
    } else {
      this.loaderAddStudent = false;
      this.schoolClassesSectionsAdd = [];
      this.selectClassSectionStatusAdd = true;

      this.selectedClassAdd = null;
      this.selectedSectionAdd = null;
    }
  }

  // select class function for add student
  selectclassFunctionEdit(selectedClassId) {
    this.selectedClassEdit = null;
    this.selectedSectionEdit = null;
    this.selectedClassEdit = selectedClassId;
    if (selectedClassId !== 0 && this.selectedCategoryAdd !== 0) {
      this.schoolClassesSectionsEdit = [];
      this.groupservice
        .groupsAvailableClassSection(
          this.selectedClassEdit,
          localStorage.getItem("usertoken")
        )
        .subscribe(
          (data: any) => {
            try {
              for (const item of data) {
                this.schoolClassesSectionsEdit.push(item);
              }
            } catch (e) {}
          },
          (error) => {}
        );
    } else {
      this.schoolClassesSectionsEdit = [];
      this.selectedClassEdit = null;
      this.selectedSectionEdit = null;
    }
  }

  // select section function
  selectsectionFunction(selectedSectionId) {
    this.selectedSection = selectedSectionId;
    this.initDataTableServerProcess(
      "groups-student-list",
      this.getSchoolId,
      this.getAuthToken,
      this.academicInfo.current_academic,
      this.selectedCategory,
      this.selectedClass,
      this.selectedSection
    );
  }

  // select section function for add student
  selectsectionFunctionAdd(selectedSectionId) {
    this.selectedSectionAdd = selectedSectionId;
  }

  selectsectionFunctionEdit(selectedSectionId) {
    this.selectedSectionEdit = selectedSectionId;
  }

  // select designation function
  selectdesignationFunction(selectedDesignationId) {
    this.staffFilterDesignation = selectedDesignationId ?? 'all';
    this.initDataTableServerProcessStaffs();
  }

  selectstaffStatusFunction(selectedStatusId) {
    this.staffFilterAppStatus = selectedStatusId ?? 'all';
    this.initDataTableServerProcessStaffs();
  }

  
  exportStaffToExcel() {
    if (this.exportingStaff || !this.staffListHasData) return;

    let designationId: number[] | null = null;
    if (this.staffFilterDesignation !== 'all') {
      const id = parseInt(this.staffFilterDesignation, 10);
      if (!isNaN(id)) designationId = [id];
    }

    let appStatus: number | null = null;
    if (this.staffFilterAppStatus !== 'all') {
      const status = parseInt(this.staffFilterAppStatus, 10);
      if (!isNaN(status)) appStatus = status;
    }

    this.exportingStaff = true;
    this.groupservice.exportStaffList(designationId, appStatus).subscribe({
      next: (blob) => {
        this.exportingStaff = false;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'staff-list.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
        firstValueFrom(this.translate.get('fileDownloadMessage')).then(msg => customToastr(msg, 'success'));
      },
      error: (err) => {
        this.exportingStaff = false;
        const msg = err?.error?.message || err?.message || 'Export failed.';
        customToastr(msg, 'error');
      }
    });
  }

  // get staff designation list
  getStaffQualificationList(schoolId) {
    this.staffQualificationListArray = [];
    this.groupservice
      .groupsStaffQualifList(schoolId, localStorage.getItem("usertoken"))
      .subscribe(
        (data: any) => {
          for (const item of data.staffQualification) {
            this.staffQualificationListArray.push(item);
          }
        },
        (error) => {}
      );
  }

  // view staff from table
  listSelectedStaff(getStaffId) {
    this.selectedStaffId = getStaffId;
    this.offcanvas.handleOffcanvasOpen("#offcanvas-view-staff");
    this.groupservice
      .groupsStaffListDetail(getStaffId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.selectedStaffImage = data.staffDetail.staffImage;
          this.selectedStaffName = data.staffDetail.staffName;
          this.selectedStaffDOB = data.staffDetail.dateOfBirth;
          this.selectedStaffAadharNumber = data.staffDetail.aadharNumber;
          this.selectedStaffAadharCopy = data.staffDetail.aadharCopy;
          if (
            data.staffDetail.dateOfBirth !== "0000-00-00" &&
            this.formValidator.validateIsDataForNumber(
              data.staffDetail.dateOfBirth
            )
          ) {
            this.selectedStaffDOB = data.staffDetail.dateOfBirth;
          } else {
            this.selectedStaffDOB = "";
          }
          if (
            data.staffDetail.dateOfJoining !== "0000-00-00" &&
            this.formValidator.validateIsDataForNumber(
              data.staffDetail.dateOfJoining
            )
          ) {
            this.selectedStaffDOJ = data.staffDetail.dateOfJoining;
          } else {
            this.selectedStaffDOJ = "";
          }
          if (data.staffDetail.gender === 1) {
            this.selectedStaffGender = true;
          } else if (data.staffDetail.gender === 0) {
            this.selectedStaffGender = false;
          } else {
            this.selectedStaffGender = true;
          }
          if (data.staffDetail.isAppUser === 0) {
            this.selectedStaffAppStatus = false;
          } else if (data.staffDetail.isAppUser === 1) {
            this.selectedStaffAppStatus = true;
          } else {
            this.selectedStaffAppStatus = false;
          }

          if (data.staffDetail.isBlocked === 0) {
            this.selectedStaffAccStatus = true;
          } else if (data.staffDetail.isBlocked === 1) {
            this.selectedStaffAccStatus = false;
          } else {
            this.selectedStaffAccStatus = true;
          }

          this.selectedStaffQualification = data.staffDetail.Qualification;
          this.selectedStaffDesignation = data.staffDetail.designation;
          this.selectedStaffDesignationId = data.staffDetail.designationId;
          $("#designation").val(this.selectedStaffDesignationId);

          this.selectedStaffEmpId = data.staffDetail.employmentId;
          this.selectedStaffEmail = data.staffDetail.emailId;
          this.selectedStaffAddress = data.staffDetail.address;
          this.selectedStaffCountryCode = data.staffDetail.countryCode;
          this.selectedStaffQualificationId =
            data.staffDetail.fkStaffQualificationId;
          $("#qualification").val(this.selectedStaffQualificationId);

          this.editSelectedStaffName = this.selectedStaffName;
          this.editSelectedStaffDOB = this.selectedStaffDOB;
          this.editSelectedStaffGender = data.staffDetail.gender;
          this.editSelectedStaffAppStatus = data.staffDetail.isAppUser;
          this.editSelectedStaffAccStatus = data.staffDetail.isBlocked;
          this.editSelectedStaffQualification = this.selectedStaffQualificationId;
          this.editSelectedStaffDesignation = this.selectedStaffDesignationId;
          this.editSelectedStaffEmpId = this.selectedStaffEmpId;
          this.editSelectedStaffDOJ = this.selectedStaffDOJ;
          this.editSelectedStaffContact = data.staffDetail.mobileNumber;
          const countryData = this.getIntlTelInputGlobals().getCountryData();
          const matchedCountry = countryData.find((country: any) => {
            return `${country.dialCode}` == this.selectedStaffCountryCode;
          }); 
          this.editSelectedStaffEmail = this.selectedStaffEmail;
          this.editSelectedStaffAddress = this.selectedStaffAddress;
          this.editSelectedStaffAadharNumber = this.selectedStaffAadharNumber;
          this.editCountryCodeStaff = this.selectedStaffCountryCode || '91';
          this.updateMobileCountryCode();
          this.editSelectedStaffAadharCopy = this.selectedStaffAadharCopy;
          if (this.editSelectedStaffAadharCopy) {
           this.translate.get('change').subscribe((translatedText: string) => { $('#edti-staff-aadhar-copy-button').text(translatedText); });
            $("#edit-staff-aadhar-copy").val("");
            $("#edit-staff-aadhar-image-ele").attr(
              "src",
              this.editSelectedStaffAadharCopy
            );
            $("#view-staff-aadhar-image-ele").attr(
              "src",
              this.editSelectedStaffAadharCopy
            );
            $("#view-staff-aadhar-image-id").removeClass("hide");
          } else {
            this.translate.get('upload').subscribe((translatedText: string) => { $('#edti-staff-aadhar-copy-button').text(translatedText); });
            $("#edit-staff-aadhar-copy").val("");
            $("#edit-staff-aadhar-image-ele").attr("src", "");
            $("#edit-staff-aadhar-image-ele").addClass("hide");
            $("#view-staff-aadhar-image-id").addClass("hide");
          }
        },
        (error) => {}
      );
  }

  updateMobileCountryCode() { 
    const countryData = this.getIntlTelInputGlobals().getCountryData();
    const matchedCountry = countryData.find((country: any) => {
      return `${country.dialCode}` == this.selectedStaffCountryCode;
    });
    const mobileNumberForEditStaff = $("[name='mobile-number-edit-staff']");
    if (mobileNumberForEditStaff.data('intlTelInput')) {
      mobileNumberForEditStaff.intlTelInput('destroy');
    }
    mobileNumberForEditStaff.intlTelInput({
      initialCountry: matchedCountry.iso2,
      separateDialCode: false,
      autoPlaceholder: 'off',
      autoFormat: false,
      nationalMode: false,
      formatOnDisplay: false,
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js",
    });
       
      mobileNumberForEditStaff.intlTelInput("setCountry", matchedCountry.iso2);
        mobileNumberForEditStaff.val(this.editSelectedStaffContact);
        mobileNumberForEditStaff.trigger('input');
        const currentCountry = mobileNumberForEditStaff.intlTelInput("getSelectedCountryData");
        this.editCountryCodeStaff = currentCountry.dialCode; 

    mobileNumberForEditStaff.on("countrychange", () => {
      const countryCode = mobileNumberForEditStaff.intlTelInput(
        "getSelectedCountryData"
      ).dialCode;
      mobileNumberForEditStaff.val("");
      this.editCountryCodeStaff = countryCode;
    }); 
  }

  getIntlTelInputGlobals(): any {
    return (window as any).intlTelInputGlobals;
  }

  editStaffQualification(qualificcationId) {
    this.editSelectedStaffQualification = qualificcationId;
  }

  editStaffDesignation(designationId) {
    this.editSelectedStaffDesignation = designationId;
  }

  //  Vaidation for Onchange border Red for edit staff
  staffNameOnChange() {
    if (
      !this.formValidator.validateIsData(this.editSelectedStaffName) ||
      $.isNumeric(this.editSelectedStaffName)
    ) {
      $("#staffnameborderredname").addClass("input-validator");
    } else {
      $("#staffnameborderredname").removeClass("input-validator");
    }
  }

  staffEmpIdOnChange() {
    if (!this.formValidator.validateIsData(this.editSelectedStaffEmpId)) {
      $("#staffnameborderredempid").addClass("input-validator");
    } else {
      $("#staffnameborderredempid").removeClass("input-validator");
    }
  }

  staffEmailOnchange(editSelectedStaffEmail) {
    if (!this.formValidator.validateIsEmail(editSelectedStaffEmail)) {
      $("#staffnameborderredemail").addClass("input-validator");
    } else {
      $("#staffnameborderredemail").removeClass("input-validator");
    }
  }

  staffAddressOnchange() {
    if (
      !this.formValidator.validateIsData(this.editSelectedStaffAddress) ||
      $.isNumeric(this.editSelectedStaffAddress)
    ) {
      $("#staffnameborderredaddress").addClass("input-validator");
    } else {
      $("#staffnameborderredaddress").removeClass("input-validator");
    }
  }

  callstaff() {
    this.offcanvas.handleOffcanvasOpen("#offcanvas-edit-staff");
  }

  openbrowsertouplaodEditStaffphoto() {
    $("#openbrowserstaffedit").trigger("click");
  }

  async updateStaffDetails() {
    let staffAppStatus;
    let staffAccStatus;
    const reasonForDeactiveStaff = $("#edit-staff-deactive-reason-input").val();
    // App status
    if ($("#appstatus").prop("checked") === true) {
      staffAppStatus = 1;
    } else if ($("#appstatus2").prop("checked") === true) {
      staffAppStatus = 0;
    }

    // Account status
    if ($("#accstatus").prop("checked") === true) {
      staffAccStatus = 0;
    } else if ($("#accstatus2").prop("checked") === true) {
      staffAccStatus = 1;
    }
    if (
      staffAccStatus === 1 &&
      !this.formValidator.validateIsData(reasonForDeactiveStaff)
    ) {
      const pleaseEnterReasonForDeactivateStaffTranslation = await firstValueFrom(this.translate.get('pleaseEnterReasonForDeactivateStaff')); 
      customToastr(pleaseEnterReasonForDeactivateStaffTranslation, 'error');
      return;
    }
    const editSelectedStaffDOJ = $(".edit-staff-doj").val();
    const editSelectedStaffDOB = $(".staff-edit-dob").val();
    const validateEditSelectedStaffDOB = this.formValidator.validateStaffDOB(
      this.editSelectedStaffDOB
    );
    const validateDates = this.formValidator.validateDates(
      editSelectedStaffDOB,
      editSelectedStaffDOJ
    );
    if ($("#editstaffmale").hasClass("active")) {
      this.editSelectedStaffGender = 1;
    } else {
      this.editSelectedStaffGender = 0;
    }
    this.editSelectedStaffName = $.trim(this.editSelectedStaffName);
    this.editSelectedStaffEmpId = $.trim(this.editSelectedStaffEmpId);
    this.editSelectedStaffContact = $.trim(this.editSelectedStaffContact);
    this.editSelectedStaffEmail = $.trim(this.editSelectedStaffEmail);
    this.editSelectedStaffAddress = $.trim(this.editSelectedStaffAddress);
    this.editSelectedStaffAadharNumber = $.trim(
      this.editSelectedStaffAadharNumber
    );
    this.editStaffMobileNumberValidator(this.mobileNumberInput.nativeElement);
    if (!this.formValidator.validateIsData(this.editSelectedStaffName)) {
      const staffNameIsMissingTranslation = await firstValueFrom(this.translate.get('staffNameIsMissing')); 
      customToastr(staffNameIsMissingTranslation, 'error');
    } else if (
      !this.formValidator.validateIsData(this.editSelectedStaffEmpId)
    ) {
      const pleaseEnterStaffEmployeeIdTranslation = await firstValueFrom(this.translate.get('pleaseEnterStaffEmployeeId')); 
      customToastr(pleaseEnterStaffEmployeeIdTranslation, 'error');
    } else if (
      !this.formValidator.validateIsEmail(this.editSelectedStaffEmail)
    ) {
      const pleaseFillInStaffEmailIdInCorrectFormatTranslation = await firstValueFrom(this.translate.get('pleaseFillInStaffEmailIdInCorrectFormat')); 
      customToastr(pleaseFillInStaffEmailIdInCorrectFormatTranslation, 'error');
    } else if (
      !this.formValidator.validateIsData(this.editSelectedStaffAddress)
    ) {
      const pleaseFillInStaffAddressTranslation = await firstValueFrom(this.translate.get('pleaseFillInStaffAddress')); customToastr(pleaseFillInStaffAddressTranslation, 'error');
    } else if (
      this.formValidator.validateIsData(this.editSelectedStaffAadharNumber) &&
      !/^[0-9]{12}$/.test(this.editSelectedStaffAadharNumber)
    ) {
      const pleaseEnterAValid12DigitAadharUidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValid12DigitAadharUidNumber')); 
      customToastr(pleaseEnterAValid12DigitAadharUidNumberTranslation, 'error');
    } else if (!this.editSelectedStaffContact ||(this.editSelectedStaffContact && this.invalidEditStaffMobileNumber)) {
      const pleaseEnterValidStaffMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidStaffMobileNumber')); 
      customToastr(pleaseEnterValidStaffMobileNumberTranslation, 'error');
      return;
    } 
    else if (validateEditSelectedStaffDOB) {
      customToastr(validateEditSelectedStaffDOB, "error");
    } else if (validateDates) {
      $(".edit-staff-doj").addClass("input-validator");
      $(".staff-edit-dob").addClass("input-validator");
      customToastr(validateDates, "error");
    } else {
      const date = editSelectedStaffDOB.split("/");
      this.editSelectedStaffDOB =
        "" + date[2] + "-" + date[1] + "-" + date[0] + "";
      const doj = editSelectedStaffDOJ.split("/");
      this.editSelectedStaffDOJ =
        "" + doj[2] + "-" + doj[1] + "-" + doj[0] + "";
      this.groupservice
        .groupsStaffUpdate(
          this.editSelectedStaffName,
          this.editSelectedStaffDOB,
          this.editSelectedStaffGender,
          staffAppStatus,
          staffAccStatus,
          this.editSelectedStaffQualification,
          this.editSelectedStaffDesignation,
          this.editSelectedStaffEmpId,
          this.editSelectedStaffDOJ,
          this.editSelectedStaffContact,
          this.editCountryCodeStaff,
          this.editSelectedStaffEmail,
          this.editSelectedStaffAddress,
          this.selectedStaffId,
          reasonForDeactiveStaff,
          this.editSelectedStaffAadharNumber,
          this.getAuthToken
        )
        .subscribe(
          async (data: any) => {
            if (data.update === true) {
              const staffDetailUpdatedTranslation = await firstValueFrom(this.translate.get('staffDetailUpdated')); 
              customToastr(staffDetailUpdatedTranslation, 'success');
              $("#closeUpdateStaff").trigger("click");
              this.selectdesignationFunction(this.editSelectedStaffDesignation);
            } else if (data.message) {
              customToastr(data.message, "error");
            } else {
              const failedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedPleaseTryAgain')); 
              customToastr(failedPleaseTryAgainTranslation, 'error');
            }
          },
          (error) => {}
        );
    }
  }

  addStaffSelectedQualification(getQualificationId) {
    this.addSelectedStaffQualificationId = getQualificationId;

    for (const i in this.staffQualificationListArray) {
      if (
        this.staffQualificationListArray[i].pkStaffQualificationId ===
        getQualificationId
      ) {
        this.addSelectedStaffQualification =
          this.staffQualificationListArray[i].Qualification;
      }
    }
  }

  addStaffSelectedDesignation(getDesignation) {
    this.addSelectedStaffDesignation = getDesignation;
  }

  addNewStaffDataClear() {
    $("#progressbar").addClass("hide");
    this.addSelectedStaffName = "";
    this.addSelectedStaffDOB = "";
    $("#addstaffqual").val("0");
    $("#addstaffdesig").val("0");
    this.addSelectedStaffEmpId = "";
    this.addSelectedStaffDOJ = "";
    this.addStaffMobileNumber = "";
    this.addSelectedStaffEmail = "";
    this.addSelectedStaffAddress = "";
    this.addSelectedStaffAadharNumber = "";
    $("#new-staff-aadhar-copy").val("");
    this.translate.get('upload').subscribe((translatedText: string) => { $('#new-staff-aadhar-copy-button').text(translatedText); });
    $("#mobile-number-add-staff").val("");
    $("#new-staff-aadhar-image-ele").attr("src", "");
  }

  //  Vaidation for Onchange border Red for Add staff
  AddStaffNameOnChange(addSelectedStaffName) {
    if (
      !this.formValidator.validateIsData(addSelectedStaffName) ||
      $.isNumeric(addSelectedStaffName)
    ) {
      $("#add-stfname").addClass("input-validator");
    } else {
      $("#add-stfname").removeClass("input-validator");
    }
  }

  AddStaffOnChangeQualification(addSelectedStaffQualificationId) {
    if (
      !this.formValidator.validateDropdownData(addSelectedStaffQualificationId)
    ) {
      $(".add-qualification").addClass("input-validator");
    } else {
      $(".add-qualification").removeClass("input-validator");
    }
  }

  AddStaffOnChangeDesignation(addSelectedStaffDesignation) {
    if (!this.formValidator.validateDropdownData(addSelectedStaffDesignation)) {
      $(".add-designation").addClass("input-validator");
    } else {
      $(".add-designation").removeClass("input-validator");
    }
  }

  AddStaffEmpIdOnChange(addSelectedStaffEmpId) {
    if (!this.formValidator.validateIsData(addSelectedStaffEmpId)) {
      $("#empId").addClass("input-validator");
    } else {
      $("#empId").removeClass("input-validator");
    }
  }

  onChangeAadharNum(id) {
    const name = $.trim($(id).val());
    if (this.formValidator.validateIsData(name) && !/^[0-9]{12}$/.test(name)) {
      $(id).addClass("input-validator");
    } else {
      $(id).removeClass("input-validator");
    }
  }

  AddStaffEmailOnchange(addSelectedStaffEmail) {
    if (!this.formValidator.validateIsEmail(addSelectedStaffEmail)) {
      $("#staffMail").addClass("input-validator");
    } else {
      $("#staffMail").removeClass("input-validator");
    }
  }

  AddStaffAddressOnchange(addSelectedStaffAddress) {
    if (
      !this.formValidator.validateIsData(addSelectedStaffAddress) ||
      $.isNumeric(addSelectedStaffAddress)
    ) {
      $("#staffAddress").addClass("input-validator");
    } else {
      $("#staffAddress").removeClass("input-validator");
    }
  }

  addNewStaffButton() {
    $("#hidetextbox").removeClass("hide");
    this.offcanvas.handleOffcanvasOpen("#offcanvas-add-newstaff");
    $("#staff-progressbar").addClass("hide");
    $("#staffimage").attr(
      "src",
      "https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png"
    );
    $("#add-staff-button").attr("disabled", false);
    this.translate.get('addDetails').subscribe((translatedText: string) => { $('#add-staff-button').text(translatedText); });
    $(".edit-staff-doj").remove("input-validator");
    $("#add-stfname").removeClass("input-validator");
    $("#add-dob").removeClass("input-validator");
    $("#addstaffqual").removeClass("input-validator");
    $("#addstaffdesig").removeClass("input-validator");
    $("#empId").removeClass("input-validator");
    $("#staffNo").removeClass("input-validator");
    $("#staffMail").removeClass("input-validator");
    $("#staffAddress").removeClass("input-validator");
    this.invalidAddStaffMobileNumber = false;
    this.addStaffMobileNumber = "";
    this.addStaffMobileNumberInput = "";
    if ($.fn.intlTelInput) {
      const mobileNumberInput = $("#mobile-number-add-staff");
      const countryData = this.getIntlTelInputGlobals().getCountryData();
      const matchedCountry = countryData.find((country: any) => {
        return `${country.dialCode}` == this.addSelectedStaffContactCountryCode;
      });
      mobileNumberInput.val("");
      mobileNumberInput.intlTelInput({
        initialCountry: matchedCountry.iso2,
        separateDialCode: false,
        autoPlaceholder: 'off',
        autoFormat: false,
        nationalMode: false,
        formatOnDisplay:false, 
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js",
      });
      mobileNumberInput.on("countrychange", () => {
        const countryCode = mobileNumberInput.intlTelInput(
          "getSelectedCountryData"
        ).dialCode;
        mobileNumberInput.val("");
        this.addSelectedStaffContactCountryCode = countryCode;
        this.addStaffMobileNumberInput = "";
        this.addStaffMobileNumber = "";
      });
    }
  }

  openBrowserToUploadStaffPhoto() {
    $("#staffuploadImage").trigger("click");
    // $("#progressbar").show();
  }

  addDesignation() {
    this.offcanvas.handleOffcanvasOpen("#offcanvas-staff-desgnation");
  }

  addQualification() {
    this.offcanvas.handleOffcanvasOpen("#offcanvas-staff-qualification");
  }

  async addNewStaffDetail() {
    this.addStaffMobileNumber = this.addStaffMobileNumberInput;
    this.addSelectedStaffDOB = $(".addstaffDOB").val();
    this.addSelectedStaffGender = $(".addstaffGender label.active input").val();
    this.addSelectedStaffAppStatus = 0;
    this.addSelectedStaffAccStatus = 0;
    this.addSelectedStaffDOJ = $(".addstaffDOJ").val();
    const validateStaffDOB = this.formValidator.validateStaffDOB(
      this.addSelectedStaffDOB
    );
    if (!this.formValidator.validateIsData(this.addSelectedStaffName)) {
      $("#add-stfname").addClass("input-validator");
    }
    if (validateStaffDOB) {
      this.addSelectedStaffDOB = null;
      $("#add-dob").addClass("input-validator");
      customToastr(validateStaffDOB, "error");
    }

    if (
      !this.formValidator.validateDropdownData(
        this.addSelectedStaffQualificationId
      )
    ) {
      $("#addstaffqual").addClass("input-validator");
    }
    if (
      !this.formValidator.validateDropdownData(this.addSelectedStaffDesignation)
    ) {
      $("#addstaffdesig").addClass("input-validator");
    }
    if (!this.formValidator.validateIsData(this.addSelectedStaffEmpId)) {
      $("#empId").addClass("input-validator");
    }

    if (!this.addStaffMobileNumber) {
      $("#staffNo").addClass("input-validator");
    }
    if (!this.formValidator.validateIsData(this.addSelectedStaffEmail)) {
      $("#staffMail").addClass("input-validator");
    }
    if (
      this.formValidator.validateIsData(this.addSelectedStaffAadharNumber) &&
      !/^[0-9]{12}$/.test(this.addSelectedStaffAadharNumber)
    ) {
      $("#add-staff-aadharNumber").addClass("input-validator");
    }
    if (!this.formValidator.validateIsData(this.addSelectedStaffAddress)) {
      this.addSelectedStaffAddress = null;
      $("#staffAddress").addClass("input-validator");
    }
    this.addSelectedStaffName = $.trim(this.addSelectedStaffName);
    this.addSelectedStaffEmpId = $.trim(this.addSelectedStaffEmpId);
    this.addStaffMobileNumber = $.trim(this.addStaffMobileNumber);
    this.addSelectedStaffEmail = $.trim(this.addSelectedStaffEmail);
    this.addSelectedStaffAddress = $.trim(this.addSelectedStaffAddress);
    this.addSelectedStaffAadharNumber = $.trim(
      this.addSelectedStaffAadharNumber
    );
    let dob = null;
    let doj = null;

    if (
      this.formValidator.validateIsData(this.addSelectedStaffName) &&
      this.formValidator.validateIsData(this.addSelectedStaffQualification) &&
      this.formValidator.validateIsData(this.addSelectedStaffDesignation) &&
      this.formValidator.validateIsData(this.addSelectedStaffEmpId) &&
      this.formValidator.validateIsData(this.addSelectedStaffAddress) &&
      this.formValidator.validateIsData(this.addSelectedStaffEmail) &&
      !validateStaffDOB
    ) {
      dob = this.addSelectedStaffDOB.split("/");
      doj = this.addSelectedStaffDOJ.split("/");
      const validateDates = this.formValidator.validateDates(
        this.addSelectedStaffDOB,
        this.addSelectedStaffDOJ
      );
      if (!this.formValidator.validateIsData(this.addSelectedStaffAddress)) {
        this.addSelectedStaffAddress = null;
      } else if (!this.formValidator.validateIsData(this.addSelectedStaffDOB)) {
        this.addSelectedStaffDOB = null;
      } else if (
        this.addSelectedStaffDOB &&
        !this.formValidator.isValidDateStr(dob[2] + "-" + dob[1] + "-" + dob[0])
      ) {
        const pleaseEnterValidDateOfBirthTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidDateOfBirth')); 
        customToastr(pleaseEnterValidDateOfBirthTranslation, 'error');
        return;
      } 
       else if (validateDates) {
        $("#staffDoj").addClass("input-validator");
        customToastr(validateDates, "error");
      }
      else if (
        this.formValidator.validateIsData(this.addSelectedStaffAadharNumber) &&
        !/^[0-9]{12}$/.test(this.addSelectedStaffAadharNumber)
      ) {
        const pleaseEnterValid12DigitAadharUidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValid12DigitAadharUidNumber')); 
        customToastr(pleaseEnterValid12DigitAadharUidNumberTranslation, 'error');
        return;
      } else if (
        !this.formValidator.validateIsEmail(
          this.addSelectedStaffEmail.toString()
        )
      ) {
        const pleaseEnterValidEmailIdTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidEmailId')); 
        customToastr(pleaseEnterValidEmailIdTranslation, 'error');
        return;
      } else if (
        !this.addStaffMobileNumber ||
        (this.addStaffMobileNumber && this.invalidAddStaffMobileNumber)
      ) {
        const pleaseEnterValidMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMobileNumber')); 
        customToastr(pleaseEnterValidMobileNumberTranslation, 'error');
        return;
      } else if (this.addSelectedStaffQualification === "add-new") {
        const pleaseSelectAValidQualificationTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidQualification')); 
        customToastr(pleaseSelectAValidQualificationTranslation, 'error');
        return;
      } else if (this.addSelectedStaffDesignation === "add-new") {
        const pleaseSelectAValidDesignationTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidDesignation')); 
        customToastr(pleaseSelectAValidDesignationTranslation, 'error');
        return;
      } else {
        const dateDOB = this.addSelectedStaffDOB.split("/");
        dob = dateDOB[2] + "-" + dateDOB[1] + "-" + dateDOB[0];
        if(this.addSelectedStaffDOJ){
          const d = this.addSelectedStaffDOJ.split("/");
          doj = d[2] + "-" + d[1] + "-" + d[0];
        }
        
        $(this).datepicker("hide");
        $("#add-staff-button").attr("disabled", true);        
        this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#add-staff-button').text(translatedText); });
        $("#staffDoj").removeClass("input-validator");
        this.groupservice
          .groupsAddNewStaff(
            this.addSelectedStaffName,
            this.addSelectedStaffEmpId,
            dob,
            this.addSelectedStaffGender,
            this.addSelectedStaffAppStatus,
            this.addSelectedStaffAccStatus,
            this.addSelectedStaffQualification,
            this.addSelectedStaffQualification,
            this.addSelectedStaffDesignation,
            doj,
            this.addStaffMobileNumber,
            this.addSelectedStaffContactCountryCode,
            this.addSelectedStaffEmail,
            this.addSelectedStaffAddress,
            this.addSelectedStaffAadharNumber,
            this.getSchoolId,
            this.getAuthToken
          )
          .subscribe(
            async (data: any) => {
              $("#add-staff-button").attr("disabled", false);
              this.translate.get('addDetails').subscribe((translatedText: string) => { $('#add-staff-button').text(translatedText); });
              if (data.addStaff === true) {
                this.uploadStaffImage(
                  localStorage.getItem("usertoken"),
                  "staffuploadImage",
                  data.staffId
                );
                //fetch staff list
                this.initDataTableServerProcessStaffs();
                this.addNewStaffDataClear();
                materialadmin.AppOffcanvas._handleOffcanvasOpen($(""));
              } else if (data.message === "STAFF_ALREADY_EXIST") {
                $(".disable-element").attr("disabled", false);
                this.translate.get('addDetails').subscribe((translatedText: string) => { $('#add-staff-button').text(translatedText); });
                if (data.messageText) {
                  customToastr(data.messageText, "error");
                } else {
                 const staffAlreadyExistsWithSameMobileNumberEmailIdOrEmployeeIdPleaseCheckItTranslation = await firstValueFrom(this.translate.get('staffAlreadyExistsWithSameMobileNumberEmailIdOrEmployeeIdPleaseCheckIt')); 
                 customToastr(staffAlreadyExistsWithSameMobileNumberEmailIdOrEmployeeIdPleaseCheckItTranslation, 'error');
                }
              } else if (data.message === "AADHAR_NUM_EXIST") {
                $(".disable-element").attr("disabled", false);
                this.translate.get('addDetails').subscribe((translatedText: string) => { $('#add-staff-button').text(translatedText); });
                const staffAlreadyExistsWithSameAadharUidNumberPleaseCheckItTranslation = await firstValueFrom(this.translate.get('staffAlreadyExistsWithSameAadharUidNumberPleaseCheckIt')); 
                customToastr(staffAlreadyExistsWithSameAadharUidNumberPleaseCheckItTranslation, 'error');
              } else if (data.errorcode === 10037) {
                $(".disable-element").attr("disabled", false);
                this.translate.get('addDetails').subscribe((translatedText: string) => { $('#add-staff-button').text(translatedText); });
               const only10StaffsAreAllowedToAddInTrailSubscriptionTranslation = await firstValueFrom(this.translate.get('only10StaffsAreAllowedToAddInTrailSubscription')); 
               customToastr(only10StaffsAreAllowedToAddInTrailSubscriptionTranslation, 'error');
              } else {
                $(".disable-element").attr("disabled", false);
                this.translate.get('addDetails').subscribe((translatedText: string) => { $('#add-staff-button').text(translatedText); });
                customToastr(data.message, "error");
              }
            },
            (error) => {
              $(".disable-element").attr("disabled", false);
              this.translate.get('addDetails').subscribe((translatedText: string) => { $('#add-staff-button').text(translatedText); });
            }
          );
      }
    } else {
      if (!this.addStaffMobileNumber) {
        $("#mobile-number-add-staff").addClass("add-staff-mobile-number-error");
      }
      $(".disable-element").attr("disabled", false);
      this.translate.get('addDetails').subscribe((translatedText: string) => { $('#add-staff-button').text(translatedText); });
      const pleaseFillAllTheMandatoryFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllTheMandatoryFields')); 
      customToastr(pleaseFillAllTheMandatoryFieldsTranslation, 'error');
    }
  }

  addDesigFinanceadminAccess(event) {
    if (event.target.checked) {
      this.addNewDesignationFinanceAdminStatus = 1;
    } else {
      this.addNewDesignationFinanceAdminStatus = 0;
    }
  }

  addDesigSuperadminAccess(event) {
    if (event.target.checked) {
      this.addNewDesignationAdminStatus = 1;
    } else {
      this.addNewDesignationAdminStatus = 0;
    }
  }

  addDesignationFeeDefaulterManager(event) {
    if (event.target.checked) {
      this.addNewDesignationFeeDefaulterStatus = 1;
    } else {
      this.addNewDesignationFeeDefaulterStatus = 0;
    }
  }

  addDesigTeacherAccess(event) {
    if (event.target.checked) {
      this.addNewDesignationTeacherStatus = 1;
    } else {
      this.addNewDesignationTeacherStatus = 0;
    }
  }

  addDesigDriverAccess(event) {
    if (event.target.checked) {
      this.addNewDesignationDriverStatus = 1;
    } else {
      this.addNewDesignationDriverStatus = 0;
    }
  }

  //add new designation
  async addNewStaffDesignation() {
    this.addNewDesignationDefaultStatus = 1;
    if (this.formValidator.validateIsData(this.addNewDesignationTitle)) {
      if (this.addNewDesignationFinanceAdminStatus === null) {
        this.addNewDesignationFinanceAdminStatus = 0;
      }
      if (this.addNewDesignationAdminStatus === null) {
        this.addNewDesignationAdminStatus = 0;
      }

      if (this.addNewDesignationFeeDefaulterStatus === null) {
        this.addNewDesignationFeeDefaulterStatus = 0;
      }
      if (this.addNewDesignationTeacherStatus === null) {
        this.addNewDesignationTeacherStatus = 0;
      }
      if (this.addNewDesignationDriverStatus === null) {
        this.addNewDesignationDriverStatus = 0;
      }
      this.isLoading = true;
      this.groupservice
        .groupsStaffAdddesignation(
          this.getSchoolId,
          this.addNewDesignationTitle,
          this.addNewDesignationAdminStatus,
          this.addNewDesignationFeeDefaulterStatus,
          this.addNewDesignationFinanceAdminStatus,
          this.addNewDesignationTeacherStatus,
          this.addNewDesignationDriverStatus,
          this.getAuthToken
        )
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            if (data.addDesignation === true) {
              const designationSuccessfullyAddedTranslation = await firstValueFrom(this.translate.get('designationSuccessfullyAdded')); 
              customToastr(designationSuccessfullyAddedTranslation, 'success');
              this.addNewDesignationTitle = "";
              this.financeAdminAccess = false;
              this.superAdminAccess = false;
              this.feeDafaulterViewAccass = false;
              this.classTeacherAccess = false;
              this.driverAccess = false;
              this.editDesignationState = false;

              this.addNewDesignationFinanceAdminStatus = 0;
              this.addNewDesignationAdminStatus = 0;
              this.addNewDesignationFeeDefaulterStatus = 0;
              this.addNewDesignationTeacherStatus = 0;
              this.addNewDesignationDriverStatus = 0;
              this.getSchoolDesignationList(this.getSchoolId);
            } else if (data.message) {
              customToastr(data.message, "error");
            } else {
             const failedToAddDesignationPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToAddDesignationPleaseTryAgain')); 
             customToastr(failedToAddDesignationPleaseTryAgainTranslation, 'error');
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      const pleaseProvideValidDesignationNameTranslation = await firstValueFrom(this.translate.get('pleaseProvideValidDesignationName')); 
      customToastr(pleaseProvideValidDesignationNameTranslation, 'error');
    }
  }

  // add new designation
  async editDesignationSubmit() {
    if (this.formValidator.validateIsData(this.addNewDesignationTitle)) {
      this.isLoading = true;
      this.groupservice
        .groupsStaffEditDesignation(
          this.editingDesignationId,
          this.addNewDesignationTitle,
          this.addNewDesignationAdminStatus,
          this.addNewDesignationFeeDefaulterStatus,
          this.addNewDesignationFinanceAdminStatus,
          this.addNewDesignationTeacherStatus,
          this.addNewDesignationDriverStatus,
          this.getAuthToken
        )
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            if (data.status) {
              const designationSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('designationSuccessfullyUpdated')); 
              customToastr(designationSuccessfullyUpdatedTranslation, 'success');
              this.editDesignationState = false;
              this.addNewDesignationTitle = "";
              this.financeAdminAccess = false;
              this.superAdminAccess = false;
              this.feeDafaulterViewAccass = false;
              this.classTeacherAccess = false;
              this.driverAccess = false;

              this.addNewDesignationFinanceAdminStatus = 0;
              this.addNewDesignationAdminStatus = 0;
              this.addNewDesignationFeeDefaulterStatus = 0;
              this.addNewDesignationTeacherStatus = 0;
              this.addNewDesignationDriverStatus = 0;
              this.getSchoolDesignationList(this.getSchoolId);
            } else if (data.message) {
              customToastr(data.message, "error");
            } else {
              const failedToUpdateDesignationPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateDesignationPleaseTryAgain')); 
              customToastr(failedToUpdateDesignationPleaseTryAgainTranslation, 'error');
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      const pleaseProvideValidDesignationNameTranslation = await firstValueFrom(this.translate.get('pleaseProvideValidDesignationName')); 
      customToastr(pleaseProvideValidDesignationNameTranslation, 'error');
    }
  }

  editDesignation(designation) {
    this.editDesignationState = true;
    this.addNewDesignationTitle = designation.designation;
    this.financeAdminAccess = designation.isFinanceAdmin === 1;
    this.addNewDesignationFinanceAdminStatus = designation.isFinanceAdmin;
    this.feeDafaulterViewAccass = designation.isFeeDefaulterAdmin === 1;
    this.addNewDesignationFeeDefaulterStatus = designation.isFeeDefaulterAdmin;
    this.superAdminAccess = designation.isSuperAdmin === 1;
    this.addNewDesignationAdminStatus = designation.isSuperAdmin;
    this.classTeacherAccess = designation.isClassTeacher === 1;
    this.addNewDesignationTeacherStatus = designation.isClassTeacher;
    this.driverAccess = designation.isDriver === 1;
    this.addNewDesignationDriverStatus = designation.isDriver;
    this.editingDesignationId = designation.designationId;
    $("#groupbutton9").focus();
  }

  cancelEditDesignation() {
    this.isLoading = false;
    this.addNewDesignationTitle = "";
    this.financeAdminAccess = false;
    this.superAdminAccess = false;
    this.feeDafaulterViewAccass = false;
    this.classTeacherAccess = false;
    this.driverAccess = false;
    this.editDesignationState = false;
  }

  async editStaffQualificationList() {
    if (this.formValidator.validateIsData(this.addNewQualificationTitle)) {
      this.isLoading = true;
      this.groupservice
        .groupsStaffEditQualification(
          this.pkStaffQualificationId,
          this.addNewQualificationTitle,
          this.getAuthToken
        )
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            if (data.status) {
              const qualificationUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('qualificationUpdatedSuccessfully')); 
              customToastr(qualificationUpdatedSuccessfullyTranslation, 'success');
              this.addNewQualificationTitle = "";
              this.editQualificationState = false;
              this.getStaffQualificationList(this.getSchoolId);
            } else if (data.message) {
              customToastr(data.message, "error");
            } else {
             const failedToUpdateQualificationPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateQualificationPleaseTryAgain')); 
             customToastr(failedToUpdateQualificationPleaseTryAgainTranslation, 'error');
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      const pleaseProvideQualificationNameToUpdateTranslation = await firstValueFrom(this.translate.get('pleaseProvideQualificationNameToUpdate')); 
      customToastr(pleaseProvideQualificationNameToUpdateTranslation, 'error');
    }
  }

  cancelEditQualification() {
    this.isLoading = false;
    this.editQualificationState = false;
    this.addNewQualificationTitle = "";
  }

  startEditQualification(qualification) {
    this.editQualificationState = true;
    this.addNewQualificationTitle = qualification.Qualification;
    this.pkStaffQualificationId = qualification.pkStaffQualificationId;
    $(".groupbutton9_focus").focus();
  }

  // add new staff qualification
  async addNewStaffQualification() {
    if (this.formValidator.validateIsData(this.addNewQualificationTitle)) {
      this.isLoading = true;
      this.groupservice
        .groupsStaffAddqualification(
          this.getSchoolId,
          this.addNewQualificationTitle,
          this.getAuthToken
        )
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            if (data.addQualification === true) {
              const qualificationAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('qualificationAddedSuccessfully')); 
              customToastr(qualificationAddedSuccessfullyTranslation, 'success');
              this.addNewQualificationTitle = "";
              this.getStaffQualificationList(this.getSchoolId);
            } else if (data.message) {
              customToastr(data.message, "error");
            } else {
              const failedToAddQualificationPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToAddQualificationPleaseTryAgain')); 
              customToastr(failedToAddQualificationPleaseTryAgainTranslation, 'error');
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      const pleaseProvideQualificationNameToAddTranslation = await firstValueFrom(this.translate.get('pleaseProvideQualificationNameToAdd')); 
      customToastr(pleaseProvideQualificationNameToAddTranslation, 'error');
    }
  }

  // import student procceed file upload
  async importstudent_proceedsheet($event) {
    const filename = $("#file-bulkupload").val();
    //  check if file extn is the required one
    let extension = filename.replace(/^.*\./, "");
    if (extension === filename) {
      extension = "";
    } else {
      extension = extension.toLowerCase();
    }

    if (extension === "xls" || extension === "xlsx") {
      this.proceedxlx = true;

      // service
      const fileList: FileList = $event.target.files;
      if (fileList.length > 0) {
        const file: File = fileList[0];
        const formData: FormData = new FormData();
        formData.append("uploadfile", file, file.name);
        this.http
          .post(this.URL + "/uploadxlsjson", formData)
          .pipe(map((res) => res))
          .subscribe(
            (data: any) => {
              this.Exceldata = data.ExcelJSONPath;
              this.displayExcelToTable();
            },
            (error) => () => {}
          );
      }
    } else {
      const fileFormatShouldBeInXlsFormatDownloadTheTemplateFileAndUseItTranslation = await firstValueFrom(this.translate.get('fileFormatShouldBeInXlsFormatDownloadTheTemplateFileAndUseIt')); 
      customToastr(fileFormatShouldBeInXlsFormatDownloadTheTemplateFileAndUseItTranslation, 'error');
      this.proceedxlx = false;
    }
  }

  displayExcelToTable() {
    function renderTable(xhrdata) {
      const cols = [];
      const exampleRecord = xhrdata[0];
      const keys = Object.keys(exampleRecord);
      keys.forEach((k) => {
        cols.push({
          title: k,
          data: k,
        });
      });

    
        this.translate.get([
          'dataTables.lengthMenu',    
        ]).subscribe(translations => {
          const table = $("#table-importstudent").DataTable({
            dom: "lCfrtip",
            order: [],
            colVis: {
              buttonText: "Columns",
              overlayFade: 0,
              align: "right",
            },
            columns: cols,
            language: {
              lengthMenu: translations['dataTables.lengthMenu'],
              search: '<i class="fa fa-search"></i>',
              paginate: {
                previous: '<i class="fa fa-angle-left"></i>',
                next: '<i class="fa fa-angle-right"></i>',
              },
            },
          });
          table.rows.add(xhrdata).draw();
        });


    }
    
    // xhr call to retrieve data
    const xhrcall = $.ajax(this.Exceldata);
    if (xhrcall.done(renderTable)) {
    }
  }

  importstudent_modalproceed() {
    const table = $("#table-importstudent").DataTable();
    const allData = table.columns().data();
    const dob = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < table.columns(1).data()[0].length; i++) {
      dob.push(table.columns(1).data()[0][i]);
      if (
        !$.isNumeric(
          ("" + table.columns(1).data()[0][i] + "").replace(/\//g, "")
        )
      ) {
        if (!this.formValidator.isValidDate(table.columns(1).data()[0][i])) {
          $("#table-importstudent td").each(function () {
            if ($(this).html() === table.columns(1).data()[0][i]) {
              $(this).addClass("import-error");
            }
          });
        }
      }
    }

    // admission date validation [columns(6)]
    const doa = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < table.columns(6).data()[0].length; i++) {
      doa.push(table.columns(6).data()[0][i]);
      if (
        !$.isNumeric(
          ("" + table.columns(6).data()[0][i] + "").replace(/\//g, "")
        )
      ) {
        if (!this.formValidator.isValidDate(table.columns(6).data()[0][i])) {
          $("#table-importstudent td").each(function () {
            if ($(this).html() === table.columns(6).data()[0][i]) {
              $(this).addClass("import-error");
            }
          });
        }
      }
    }

    // class number validation [columns(8)]
    const classnumber = [];
    const classData = table.columns(8).data()[0];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < classData.length; i++) {
      classnumber.push(classData[i]);
      if ($.inArray(classData[i], this.schoolAllClass) === -1) {
        //  not found
        $("#table-importstudent td").each(function () {
          if ($(this).html() === classData[i]) {
            $(this).addClass("import-error");
          }
        });
      }
    }
  }

  proceedImportData() {
    $("#table-importstudent").empty();
    $("#table-importstudent").DataTable().destroy();
  }

  isValidToken() {
    let isValidToken = false;
    let isValidSchool = 0;
    this.loginservice.isValidToken(localStorage.getItem("usertoken")).subscribe(
      (data: any) => {
        isValidToken = data.isValid;
        if (data.errorcode === 10010) {
          this.router.navigate(["/suspended"]);
        } else if (isValidToken === true) {
          this.loginservice
            .isValidSchoolId(localStorage.getItem("schoolinfo"))
            .subscribe(
              (isValidData: any) => {
                isValidSchool = isValidData.schoolExist;
                this.getSchoolId = localStorage.getItem("schoolinfo");
                if (isValidSchool !== 1) {
                  this.router.navigate(["/login"]);
                } else if (this.loginMode === "STAFF") {
                  this.router.navigate(["/exams"]);
                } else {
                  // this.initScript();
                  this.getGroupsClassCategories(this.getSchoolId);
                  this.getGroupsAcademicList(this.getSchoolId);
                  this.getSchoolDesignationList(this.getSchoolId);
                  this.getAllShoolClass(this.getSchoolId);
                  this.getStaffQualificationList(this.getSchoolId);
                  this.getAllStopTerms();
                }
              },
              (error) => {}
            );
        } else {
          this.router.navigate(["/login"]);
        }
      },
      (error) => {}
    );
  }

  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>$('.groups')" +
        ".addClass('active');$('.add-qualification')" +
        ".on('change', () => {var value = $(this).val();if(value === 'add-new'){$('#add-qualification-new')" +
        ".popover('show');$('select option[value=0]')" +
        ".attr('selected',true);$('.close-add-qualification')" +
        ".click(() =>{$('#add-qualification-new').popover('hide');});}});" +
        "$('.add-designation').on('change', () => {var value = $(this).val();" +
        "if(value === 'add-new'){$('#add-designation-new').popover('show');" +
        "$('select option[value=0]').attr('selected',true);" +
        "$('.close-add-designation').click(() =>{$('#add-designation-new').popover('hide');});}});" +
        "function customToastr(message,type,title){toastr.options.hideDuration = 0;toastr.clear();" +
        "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
        "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
        "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
        "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';" +
        "toastr.options.hideMethod = 'slideUp';toastr[type](message, title || '');return 0;}</" +
        "script>"
    );
  }

  /*Data table operation*/
  destroyDataTable(table) {
    $("#" + table)
      .DataTable()
      .destroy();
  }

  initializeDataTable(table) {
    setTimeout(() => {
      $("#" + table).DataTable();
    }, 500);
  }

  initializeDataTableNoPagination(table) {
    setTimeout(() => {
      $("#" + table).DataTable({
        paging: false,
        ordering: false,
        info: false,
      });
    }, 500);
  }

  /*// // // // // // // // // /*/

  initializeCategoryData(initialCatid) {
    setTimeout(() => {
      $("#groups-category option[value=" + initialCatid + "]").prop(
        "selected",
        true
      );
    }, 500);

    setTimeout(() => this.selectcategoryFunction(initialCatid), 500);
  }

  initializeStaffListData(initialCatid) {
    setTimeout(() => {
      $("#staff-category option[value=" + initialCatid + "]").prop(
        "selected",
        true
      );
    }, 500);

    setTimeout(() => this.selectdesignationFunction(initialCatid), 500);
  }

  initDataTableServerProcess(
  tableid,
  schoolId,
  authToken,
  academicId,
  categoryId,
  classId,
  sectionId
) {
  const h = this;
  const utilFun = {
    getText() {
      let text =
        "Students export sheet " +
        $("#groups-category option:selected").text();
      if ($("#select14").val() !== "0") {
        text += "-" + $("#select14 option:selected").text();
      }
      if ($("#select15").val() !== "0") {
        text += "-" + $("#select15 option:selected").text();
      }
      return text;
    },
  };

  const genderTranslations = this.genderTranslations;
  const isActiveTranslations = this.isActiveTranslations;

  let pageLength = 25;
  if (this.selectedSection) {
    pageLength = 100;
  }

  this.translate.get([
    'dataTables.search',
    'dataTables.processing',
    'dataTables.lengthMenu',
    'dataTables.info',
    'dataTables.emptyTable',
    'dataTables.infoEmpty',
    'dataTables.infoFiltered',
    'dataTables.paginate.first',
    'dataTables.paginate.last',
    'dataTables.paginate.next',
    'dataTables.paginate.previous',
    'dataTables.buttons.copy',
    'dataTables.buttons.excel',
    'dataTables.buttons.csv',
    'dataTables.buttons.colvis',
    'dataTables.buttons.colvisRestore',
    'dataTables.exportTitle',
    'dataTables.studentListOption.basicInfo',
    'dataTables.studentListOption.documentHub',
    'dataTables.studentListOption.contactDetails',
    'dataTables.studentListOption.transportOptions',
    'dataTables.studentListOption.deactivate',
    'dataTables.studentListOption.close',
  ]).subscribe(translations => {
  
  const stringHtml =
    '<div class="btn-group dropleft">' +
    '<i class="fas fa-user-edit cursor-pointer" data-toggle="dropdown" aria-expanded="true"></i>' +
    '<ul class="dropdown-menu animation-expand dropdown-menu-down" role="menu">' +
    '<li id="clicked-on-edit-student-link" class="cursor-pointer">' +
    `<a><i class="fas fa-user-edit" aria-hidden="true"></i>&nbsp;&nbsp;${translations['dataTables.studentListOption.basicInfo']}</a>` +
    '</li>' +
    '<li id="student-document-hub" class="cursor-pointer">' +
    `<a><i class="ri-file-fill"></i>&nbsp;&nbsp;${translations['dataTables.studentListOption.documentHub']} </a>` +
    '</li>' +
    '<li id="clicked-on-edit-student-contact-link" class="cursor-pointer">' +
    `<a><i class="fa fa-phone" aria-hidden="true"></i>&nbsp;&nbsp;${translations['dataTables.studentListOption.contactDetails']}</a>` +
    '</li>' +
    '<li id="edit-student-bus-options" class="cursor-pointer">' +
    `<a><i class="fa fa-bus" aria-hidden="true"></i>&nbsp;&nbsp;${translations['dataTables.studentListOption.transportOptions']}</a>` +
    '</li>' +
    '<li id="clicked-on-delete-student-link" class="cursor-pointer">' +
    `<a><i class="fas fa-user-times" aria-hidden="true"></i>&nbsp;&nbsp;${translations['dataTables.studentListOption.deactivate']}</a>` +
    '</li>' +
    '<li class="divider"></li>' +
    '<li class="cursor-pointer">' +
    `<a data-dismiss="modal" aria-hidden="true"><i class="fa fa-fw fa-times text-danger"></i> ${translations['dataTables.studentListOption.close']}</a>` +
    '</li>' +
    '</ul>' +
    '</div> &nbsp;|&nbsp; ' +
    '<i id="student-profile-view-action" class="fas fa-print cursor-pointer"></i>' +
    '&nbsp;|&nbsp; ' +
    '<i id="student-update-history-view-action" class="fas fa-history cursor-pointer" data-toggle="modal" data-target="#student-update-history-popup"></i>';

    this.studentListTable = $("#" + tableid).DataTable({
      destroy: true,
      language: {
        search: translations['dataTables.search'],
        lengthMenu: translations['dataTables.lengthMenu'],
        info: translations['dataTables.info'],
        infoEmpty: translations['dataTables.infoEmpty'],
        infoFiltered: translations['dataTables.infoFiltered'],
        emptyTable: translations['dataTables.emptyTable'],
        paginate: {
          first: translations['dataTables.paginate.first'],
          last: translations['dataTables.paginate.last'],
          next: translations['dataTables.paginate.next'],
          previous: translations['dataTables.paginate.previous']
        },
        processing: `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`,
      },
      processing: true,
      serverSide: true,
      dom: "lfBrtip",
      buttons: [
        {
          extend: "copyHtml5",
          title: utilFun.getText(),
          text: translations['dataTables.buttons.copy']
        },
        {
          extend: "excelHtml5",
          title: utilFun.getText(),
          text: translations['dataTables.buttons.excel']
        },
        {
          extend: "csvHtml5",
          title: utilFun.getText(),
          text: translations['dataTables.buttons.csv']
        },
        {
          extend: "colvis",
          targets: 0,
          text: translations['dataTables.buttons.colvis'],
          columns: ":not(.noVis)",
          postfixButtons: ["colvisRestore"],
        },
      ],
      pageLength,
      ajax: {
        beforeSend(request) {
          request.setRequestHeader("Content-Type", "application/json");
          request.setRequestHeader("authToken", authToken);
        },
        url: AppSettings.API_ENDPOINT + "/studentlist",
        type: "POST",
        data(d) {
          return JSON.stringify({
            schoolId: localStorage.getItem("schoolinfo"),
            academicId,
            categoryId,
            classId,
            sectionId,
            countFrom: d.start,
            lengthOf: d.length,
            search: d.search.value,
            sort: d.order,
          });
        },
      },
      columnDefs: [
        {
          targets: 1,
          className: "noVis",
        },
      ],
   columns: [
  {
    title: "S.No",
    data: null,
    orderable: false,
    render: function (data, type, row, meta) {
      // meta.row = index on current page, meta.settings._iDisplayStart = start index
      return meta.row + meta.settings._iDisplayStart + 1;
    },
    class: "serial-number",
  },
  { class: "studentId", data: "rollNumber", visible: false },
  { data: "registrationId", class: "novis registration-id" },
  { data: "studentName" },
  { data: "parentName" },
  { data: "motherName", visible: false },
  { data: "stdClassName", orderable: false },
  { data: "mobileNumber", class: "primary-mobile-number" },
  { data: "dateOfAdmission" },
  { data: "dateOfBirth", visible: false },
  { data: "gender", visible: false ,
    render: function (data, type, row) {
      return data === 0 ? genderTranslations['female'] : genderTranslations['male'];
    }
  },
  { data: "isAppUser", visible: false ,
    render: function (data, type, row) {
      return data === 0 ? isActiveTranslations['inactive'] : isActiveTranslations['active'];
    }
  },
  { data: "emailId", visible: false },
  { data: "surname", visible: false },
  { data: "address", visible: false },
  { data: "guardianName", visible: false },
  { data: "aadharNumber", visible: false },
  { data: "houseName", visible: false },
  { data: "bloodGroup", visible: false },
  { data: "tcOrBirthCertificateUploaded", visible: false },
  { data: "busName", visible: false },
  { data: "busStopName", visible: false },
  {
    class: "student-profile-action",
    orderable: false,
    defaultContent: "",
    width: "10%",
  },
  {
    class: "student-id-print-action",
    width: "10%",
    defaultContent:
      '<label class="checkbox-inline checkbox-styled checkbox-primary">' +
      '<input id="student-select-check-box" type="checkbox"><span class="checkbox-material">' +
      '<span class="check"></span></span></label>',
    orderable: false,
  },
],
      rowCallback(row, data, index) {
        $(row).attr("studentName", data.studentName);
        if (
          h.academicInfo.current_academic_state === "RUNNING" ||
          h.academicInfo.current_academic_state === "NOT_STARTED"
        ) {
          let domHtml = $(stringHtml);
          if (h.academicInfo.current_academic_state === "NOT_STARTED") {
            domHtml.find("#edit-student-bus-options").remove();
          }

          if (h.permissions.DEACTIVATE != "ENABLED") {
            domHtml.find("#clicked-on-delete-student-link").addClass("disabled").attr("id", "");
          }

          if (h.permissions.EDIT_STUDENT != "ENABLED") {
            domHtml.find(".fa-user-edit, i").addClass("disabled");
            domHtml.find("i").removeClass("cursor-pointer");
            domHtml.find(".fa-user-edit").removeAttr("data-toggle");
          }

          $(row).find(".student-profile-action").prepend(domHtml);
          const tableApi = $("#" + tableid).DataTable();
          const totalRows = tableApi.rows().count();
          const isLastFourthRows = index >= totalRows - 4;
          const isGreaterThan6 = totalRows > 6 && index > 6;

          if (totalRows >= 1 && totalRows <= 5) {
            $(row).find(".dropdown-menu").removeClass("dropdown-menu-up");
          } else if (isLastFourthRows || isGreaterThan6) {
            $(row)
              .find(".dropdown-menu")
              .addClass("dropdown-menu-up")
              .removeClass("dropdown-menu-down");
          } else {
            $(row).find(".dropdown-menu").removeClass("dropdown-menu-up");
          }

          h.autoCheckSelectedStudentsOnTableLoad(row, data);
        } else {
          $(row).find(".student-profile-action").hide();
        }
      }
    });
  });
}


  autoCheckSelectedStudentsOnTableLoad(row, data) {
    if (this.selectedStudentsInTable.indexOf(data.DT_RowId) !== -1) {
      $(row).find("#student-select-check-box").prop("checked", true);
    }
  }

  /*// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // /*/

  initiateDeactivateStudent(event) {
    this.studentDeactivatePopupStudentId = event.target
      .closest("tr")
      .getAttribute("id");
    this.studentDeactivatePopupStudentName = event.target
      .closest("tr")
      .getAttribute("studentName");
    this.openStudentDeactivatePopup = true;
  }

  afterStudentDeactivated() {
    this.studentDeactivatePopupClose();
    this.getGroupsClassCategories(this.getSchoolId);
  }

  studentDeactivatePopupClose() {
    this.studentDeactivatePopupStudentId = null;
    this.studentDeactivatePopupStudentName = null;
    this.openStudentDeactivatePopup = false;
  }

  async ngOnInit() {
    let state = window.history.state;
      $(document).on('clearStaffSelections', () => {
    this.selectedStaffsInTable = [];
  });

    this.route.params.subscribe(params => {
    const tab = params['tab'];
    
    if (tab === 'staff') {
      this.activeTab = 'staff';
      this.initDataTableServerProcessStaffs()
    } else {
      this.activeTab = 'student';
      this.initDataTable(this.academicId, 0,0,0)
    }
  });



    this.loginMode = localStorage.getItem("loginMode");
    this.schoolCurrency = localStorage.getItem("currency") || "INR";
    this.currentCountryCode = localStorage.getItem("countryCode") || '91';
    this.studentDeactivatePopupStudentId = null;
    this.studentDeactivatePopupStudentName = null;
    this.openStudentDeactivatePopup = false;

    // if (this.getSchoolId === "56") {
    //   this.addNewStudentCountryCode = "254";
    //   this.addSelectedStaffContactCountryCode = "254";
    // }

    if (this.loginMode === "STAFF") {
      this.router.navigate(["/exams"]);
    }
    const h = this;
    let profileImageSelected = false;

    $("#add-dob").change(function () {
      h.addSelectedStaffDOB = $("#add-dob").val();
      const validateStaffDOB = h.formValidator.validateStaffDOB(
        h.addSelectedStaffDOB
      );
      if (validateStaffDOB) {
        $("#add-dob").addClass("input-validator");
        customToastr(validateStaffDOB, "error");
      } else {
        $("#add-dob").removeClass("input-validator");
        $(this).datepicker("hide");
      }
    });
    $("#staffDoj").change(function () {
      const selectedStaffDOB = $("#add-dob").val();
      const selectedStaffDOJ = $("#staffDoj").val();
      if (selectedStaffDOJ && selectedStaffDOB) {
        const validateDates = h.formValidator.validateDates(
          selectedStaffDOB,
          selectedStaffDOJ
        );
        if (validateDates) {
          $("#staffDoj").addClass("input-validator");
          $("#add-dob").addClass("input-validator");
          customToastr(validateDates, "error");
        } else {
          $("#staffDoj").removeClass("input-validator");
          $("#add-dob").removeClass("input-validator");
          $(this).datepicker("hide");
        }
      } else {
        $("#staffDoj").removeClass("input-validator");
        $("#add-dob").removeClass("input-validator");
        $(this).datepicker("hide");
      }
    });

    $("#staffnameborderreddob").change(function () {
      h.editSelectedStaffDOB = $(this).val();
      const validateStaffDOB = h.formValidator.validateStaffDOB(
        h.editSelectedStaffDOB
      );
      if (validateStaffDOB) {
        h.editSelectedStaffDOB = null;
        $("#staffnameborderreddob").addClass("input-validator");
        customToastr(validateStaffDOB, "error");
      } else {
        $("#staffnameborderreddob").removeClass("input-validator");
        $(this).datepicker("hide");
      }
    });

    $("#staffnameborderreddoj").change(function () {
      const editSelectedStaffDOB = $(".staff-edit-dob").val();
      const editSelectedStaffDOJ = $(".edit-staff-doj").val();
      if (editSelectedStaffDOB && editSelectedStaffDOJ) {
        const validateDates = h.formValidator.validateDates(
          editSelectedStaffDOB,
          editSelectedStaffDOJ
        );
        if (validateDates) {
          $("#staffnameborderreddoj").addClass("input-validator");
          $("#staffnameborderreddob").addClass("input-validator");
          customToastr(validateDates, "error");
        } else {
          $("#staffnameborderreddoj").removeClass("input-validator");
          $("#staffnameborderreddob").removeClass("input-validator");
          $(this).datepicker("hide");
        }
      } else {
        $("#staffnameborderreddoj").removeClass("input-validator");
        $(this).datepicker("hide");
      }
    });

    $(".changestudDob").change(function () {
      h.addNewStudentDOB = $(this).val();
      const StudentDOBIsValid = h.formValidator.valdateDOB(h.addNewStudentDOB);
      if (StudentDOBIsValid) {
        h.addNewStudentDOB = null;
        $(".changestudDob").addClass("validateErrorforAddStudent");
        customToastr(StudentDOBIsValid, "error");
      } else {
        $(".changestudDob").removeClass("validateErrorforAddStudent");
        $(this).datepicker("hide");
      }
    });
    $("#editstudentdob").change(function () {
      h.selectedStudentdateofbirth = $(this).val();
      const StudentDOBIsValid = h.formValidator.valdateDOB(
        h.selectedStudentdateofbirth
      );
      if (StudentDOBIsValid) {
        h.selectedStudentdateofbirth = null;
        $("#editstudentdob").addClass("validateErrorforAddStudent");
      } else {
        $("#editstudentdob").removeClass("validateErrorforAddStudent");
        $(this).datepicker("hide");
      }
    });

    $("#openbrowser").change(async function () {
      const extension = $(this).val().split(".").pop().toLowerCase();
      const ExtListToUpload = new Array("gif", "jpeg", "png", "jpg");
      const isValidFileExt = $.inArray(extension, ExtListToUpload);
      if (isValidFileExt === -1) {
        profileImageSelected = false;
        $(this).replaceWith($(this).val("").clone(true));
       const pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidImageTypeOfGifJpegPngJpg')); 
       customToastr(pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation, 'error');
      } else {
        profileImageSelected = false;
        if ($(this).get(0).files[0].size > 1024 * 1024 * 20) {
          $(this).replaceWith($(this).val("").clone(true));
          const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('imageSizeShouldNotExceed20Mb')); 
          customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
        } else {
          profileImageSelected = true;
          if ($(this).get(0).files && $(this).get(0).files[0]) {
            const reader = new FileReader();
            reader.onload = imageIsLoaded;
            reader.readAsDataURL($(this).get(0).files[0]);
          }
        }
      }
    });

    function imageIsLoaded(e) {
      $("#studentimage").attr("src", e.target.result);
    }
    $("#openbrowserforeditstudent").change(async function () {
      $("#hidetextboxedit").addClass("hide");
      $("#editStudent-progressbar").removeClass("hide");

      const extension = $(this).val().split(".").pop().toLowerCase();
      const ExtListToUpload = new Array("gif", "jpeg", "png", "jpg");
      const isValidFileExt = $.inArray(extension, ExtListToUpload);
      if (isValidFileExt === -1) {
        profileImageSelected = false;
        $(this).replaceWith($(this).val("").clone(true));
        $("#hidetextboxedit").removeClass("hide");
        $("#editStudent-progressbar").addClass("hide");
        const pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidImageTypeOfGifJpegPngJpg')); 
        customToastr(pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation, 'error');
      } else {
        profileImageSelected = false;
        if ($(this).get(0).files[0].size > 1024 * 1024 * 20) {
          $(this).replaceWith($(this).val("").clone(true));
          $("#hidetextboxedit").removeClass("hide");
          $("#editStudent-progressbar").addClass("hide");
          const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('imageSizeShouldNotExceed20Mb')); 
          customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
        } else {
          profileImageSelected = true;
          if ($(this).get(0).files && $(this).get(0).files[0]) {
            const reader = new FileReader();
            reader.onload = imageIsLoadedForEditStudent;
            reader.readAsDataURL($(this).get(0).files[0]);
          }
          h.uploadEditStudentImage(
            localStorage.getItem("usertoken"),
            "openbrowserforeditstudent",
            h.selectedStudentListId
          );
        }
      }
    });

    function imageIsLoadedForEditStudent(e) {
      $("#editstudentimage").attr("src", e.target.result);
    }

    $("#staffuploadImage").change(async function () {
      const extensionforstaff = $(this).val().split(".").pop().toLowerCase();
      const ExtListToUploadforstaff = new Array("gif", "jpeg", "png", "jpg");
      const isValidFileExtension = $.inArray(
        extensionforstaff,
        ExtListToUploadforstaff
      );
      if (isValidFileExtension === -1) {
        profileImageSelected = false;
        $(this).replaceWith($(this).val("").clone(true));
        const pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidImageTypeOfGifJpegPngJpg')); 
        customToastr(pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation, 'error');
      } else {
        profileImageSelected = false;
        if ($(this).get(0).files[0].size > 1024 * 1024 * 20) {
          $(this).replaceWith($(this).val("").clone(true));
          const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('imageSizeShouldNotExceed20Mb')); 
          customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
        } else {
          profileImageSelected = true;
          if ($(this).get(0).files && $(this).get(0).files[0]) {
            const reader = new FileReader();
            reader.onload = imageIsLoadedForStaff;
            reader.readAsDataURL($(this).get(0).files[0]);
          }
          /*h.uploadStudentImage("openbrowser",new Date().getMilliseconds());*/
        }
      }
    });

    function imageIsLoadedForStaff(e) {
      $("#staffimage").attr("src", e.target.result);
    }

    $("#openbrowserstaffedit").change(async function () {
      $("#hideforstaffedit").addClass("hide");
      $("#staffedit-progressbar").removeClass("hide");

      const extensionforstaff = $(this).val().split(".").pop().toLowerCase();
      const ExtListToUploadforstaff = new Array("gif", "jpeg", "png", "jpg");
      const isValidFileExtension = $.inArray(
        extensionforstaff,
        ExtListToUploadforstaff
      );
      if (isValidFileExtension === -1) {
        profileImageSelected = false;
        $(this).replaceWith($(this).val("").clone(true));
        $("#hideforstaffedit").removeClass("hide");
        $("#staffedit-progressbar").addClass("hide");
        const pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidImageTypeOfGifJpegPngJpg')); 
        customToastr(pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation, 'error');
      } else {
        profileImageSelected = false;
        if ($(this).get(0).files[0].size > 1024 * 1024 * 20) {
          $(this).replaceWith($(this).val("").clone(true));
          $("#hideforstaffedit").removeClass("hide");
          $("#staffedit-progressbar").addClass("hide");
          const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('imageSizeShouldNotExceed20Mb')); 
          customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
        } else {
          profileImageSelected = true;
          if ($(this).get(0).files && $(this).get(0).files[0]) {
            const reader = new FileReader();
            reader.onload = imageIsLoadedForEditStaff;
            reader.readAsDataURL($(this).get(0).files[0]);
          }
          h.uploadEditStaffImage(
            localStorage.getItem("usertoken"),
            "openbrowserstaffedit",
            h.selectedStaffId
          );
        }
      }
    });

    function imageIsLoadedForEditStaff(e) {
      $("#staffimagedit").attr("src", e.target.result);
    }

    const adminPermissionlist = localStorage.getItem("adminPermissionlist");
    if (adminPermissionlist) {
      const list = JSON.parse(adminPermissionlist);
      this.permissions = list;
      if (this.permissions.SCHOOL_STUDENT_MANAGEMENT === "ENABLED") {
        $("#first1").addClass("active");
        $("#second1").removeClass("active");
        $("#student_tab").trigger("click");
        $("#student_tab").on("click", function () {
          $("#id-print-floating-button").hide();
          $("#id-print-floating-button-staff").hide();
          $("input[type='checkbox']").prop('checked', false);
        });
        if (
          state &&
          state.tab === "staffs" &&
          this.permissions.SCHOOL_STAFFS_MANAGEMENT === "ENABLED"
        ) {
          $("#first1").removeClass("active");
          $("#second1").addClass("active");
          $("#staff_tab").trigger("click");
        }
      } else if (this.permissions.SCHOOL_STAFFS_MANAGEMENT === "ENABLED") {
        
        $("#first1").removeClass("active");
        $("#second1").addClass("active");
        $("#staff_tab").trigger("click");
      }
      $("#staff_tab").on("click", function () {
          $("#id-print-floating-button").hide();
          $("#id-print-floating-button-staff").hide();
          $("input[type='checkbox']").prop('checked', false);
        });
    }
    this.isValidToken();
    $("#accountStatusDeActive").click(() => {
      $("#reason").show();
    });
    $("#accountStatusActive").click(() => {
      $("#reason").hide();
    });
    $("#accstatus2").change(() => {
      $("#reasonStaff").show();
    });
    $("#accstatus").click(() => {
      $("#reasonStaff").hide();
    });
    this.getAllStops();
    this.translate.get(['male', 'female', 'active', 'inactive']).subscribe(translations => {
        this.genderTranslations = {
          male: translations['male'],
          female: translations['female']
        };
        this.isActiveTranslations = {
          active: translations['active'],
          inactive: translations['inactive']
        };

        this.initDataTableServerProcessStaffs();
      });
    this.getSchoolHouseListDetails();

    $("#confirm-student-details-updated").on("click", () => {
      // h.fetchFeeCollectionInfo(h.selectedStudentIdForUpdate);
      h.getGroupsClassCategories(this["schoolId"]);
      h.getAllShoolClass(this["schoolId"]);
    });

    setTimeout(() => this.initScripts(), 500);

       await this.updateTableHeaders();

    this.translate.get(['male', 'female', 'active', 'inactive']).subscribe(translations => {
      this.genderTranslations = {
        male: translations['male'],
        female: translations['female']
      };
      this.isActiveTranslations = {
        active: translations['active'],
        inactive: translations['inactive']
      };

      // Call DataTable init only after translations are set
      this.initDataTableServerProcessStaffs();
    });

    this.langChangeSubscription = this.translate.onLangChange.subscribe(async (event: LangChangeEvent) => {
      this.cdr.detectChanges();

      this.translate.get(['male', 'female']).subscribe(translations => {
        this.genderTranslations = translations;
      });

      this.translate.get(['active', 'inactive']).subscribe(translations => {
        this.isActiveTranslations = translations;
      });
      this.destroyDataTable("groups-student-list");
      this.destroyDataTable("student-update-history-component-table");
      this.studentUpdateHistoryTable = null;
      this.applyStudentUpdateHistoryTable()
      await this.updateTableHeaders();

      this.initDataTableServerProcess(
        "groups-student-list",
        this.getSchoolId,
        this.getAuthToken,
        this.academicInfo.current_academic,
        this.selectedCategory,
        this.selectedClass,
        this.selectedSection
      );
  
      this.translate.get(['male', 'female', 'active', 'inactive']).subscribe(translations => {
        this.genderTranslations = {
          male: translations['male'],
          female: translations['female']
        };
        this.isActiveTranslations = {
          active: translations['active'],
          inactive: translations['inactive']
        };

        this.initDataTableServerProcessStaffs();
      });
    });

  }

 private updateTableHeaders(): Promise<void> {
  return new Promise((resolve) => {
    this.translate.get([
      'rollNo',
      'registrationNo',
      'student',
      'parent',
      'mother',
      'class',
      'mobileNumber',
      'admissionDate',
      'dateOfBirth',
      'gender',
      'isappuser',
      'emailId',
      'surname',
      'address',
      'guardian',
      'aadharNo',
      'houseName',
      'bloodGroup',
      'tcBirthCertificateUploaded',
      'busName',
      'boardingPoint',
      'action',
      'printId'
    ]).subscribe(translations => {
      const headerMap = {
        rollNoHeader: translations['rollNo'],
        registrationNoHeader: translations['registrationNo'],
        studentHeader: translations['student'],
        parentHeader: translations['parent'],
        motherHeader: translations['mother'],
        classHeader: translations['class'],
        mobileNumberHeader: translations['mobileNumber'],
        admissionDateHeader: translations['admissionDate'],
        dateOfBirthHeader: translations['dateOfBirth'],
        genderHeader: translations['gender'],
        isAppUserHeader: translations['isappuser'],
        emailIdHeader: translations['emailId'],
        surnameHeader: translations['surname'],
        addressHeader: translations['address'],
        guardianHeader: translations['guardian'],
        aadharNoHeader: translations['aadharNo'],
        houseNameHeader: translations['houseName'],
        bloodGroupHeader: translations['bloodGroup'],
        tcBirthCertificateUploadedHeader: translations['tcBirthCertificateUploaded'],
        busNameHeader: translations['busName'],
        boardingPointHeader: translations['boardingPoint'],
        actionHeader: translations['action'],
       
      };

      for (const [id, value] of Object.entries(headerMap)) {
        const element = document.getElementById(id);
        if (element) {
          element.innerText = value;
        }
      }

      const printIdElement = document.getElementById('printIdHeader');
      if (printIdElement) {
        printIdElement.innerHTML = `
          ${translations['printId']}
          <label class="checkbox-inline checkbox-styled checkbox-primary">
            <input id="student-select-check-box-all" type="checkbox" />
            <span class="checkbox-material"><span class="check"></span></span>
          </label>
        `;

        // Manually bind the change event to the checkbox
        const checkbox = document.getElementById('student-select-check-box-all');
        checkbox?.addEventListener('change', () => {
          this.selectAllStudentsInTable();
        });
      }

      resolve(); // let the caller continue AFTER headers are fully updated
    });
  });
}



  ngOnDestroy(): void {
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
        $("body").find("#id-print-floating-button").hide();
        $("body").find("#id-print-floating-button-staff").hide();
    }

  getSchoolHouseListDetails() {
    this.groupservice
      .getSchoolHouseList(localStorage.getItem("usertoken"))
      .subscribe(
        (data: any) => {
          if (data.status) {
            this.houseNameList = JSON.parse(JSON.stringify(data.list));
          } else {
            this.houseNameList = [];
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  initScripts() {
    this.scriptLoader.loadScript($, "DASHBOARD");
  }

  initDataTable(academicId, categoryId, classId, sectionId) {

    this.translate.get([
      'dataTables.processing',
    ]).subscribe(translations => {
      $("#example").DataTable({
        destroy: true,
        language: {
          processing:
            `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`,
        },
        processing: true,
        serverSide: true,

        ajax: {
          beforeSend(request) {
            request.setRequestHeader("Content-Type", "application/json");
            request.setRequestHeader(
              "authToken",
              localStorage.getItem("usertoken")
            );
          },

          url: AppSettings.API_ENDPOINT + "/studentlist",
          type: "POST",
          data(d) {
            return JSON.stringify({
              schoolId: localStorage.getItem("schoolinfo"),
              academicId,
              categoryId,
              classId,
              sectionId,
              countFrom: d.start,
              lengthOf: d.length,
            });
          },
        },
        columns: [
          { data: "rollNumber" },
          { data: "studentName" },
          { data: "parentName" },
          { data: "mobileNumber" },
          { data: "dateOfBirth" },
          { data: "gender" },
          { data: "isAppUser" },
        ],
      });
    });
  }

  getAllShoolClass(schoolId) {
    this.groupservice
      .groupsAvailableAllClass(schoolId, localStorage.getItem("usertoken"))
      .subscribe(
        (data: any) => {
          try {
            for (const item of data.className) {
              this.schoolAllClass.push(item);
            }
          } catch (e) {}
        },
        (error) => {}
      );
  }

  getGroupsClassCategories(schoolId) {
    this.schoolCategories = [];
    this.groupservice
      .groupsClassCategories(schoolId, localStorage.getItem("usertoken"))
      .subscribe(
        (data: any) => {
          for (let i = 0; i < data.schoolCategory.length; i++) {
            this.schoolCategories.push(data.schoolCategory[i]);

            if (
              data.schoolCategory.length - 1 === i &&
              this.schoolCategories.length !== 0
            ) {
              this.initializeCategoryData(0);
            }
          }
        },
        (error) => {}
      );
  }

  getGroupsAcademicList(schoolId) {
    this.schoolAcademicList = [];
    this.groupservice
      .groupsStudentAcademicList(schoolId, localStorage.getItem("usertoken"))
      .subscribe(
        (data: any) => {
          for (const item of data.academicList) {
            this.schoolAcademicList.push(item);
            if (item.InActive === 0) {
              this.schoolAcademicCurrent.push(item);
              this.academicId = item.pkAcademicId;
              this.schoolAcademicCurrentYear = item.Year;
            }
          }
          data = data.academicList;
          if (data && data.length > 0) {
            this.academicInfo.academicList = data;
            let indexOfCurrent = null;
            for (let i = 0; i < this.academicInfo.academicList.length; i++) {
              this.academicInfo.academicList[i].current = false;
              this.academicInfo.academicList[i].notstarted = false;
              this.academicInfo.academicList[i].completed = false;
              if (this.academicInfo.academicList[i].InActive === 0) {
                indexOfCurrent = i;
                this.academicInfo.academicList[i].current = true;
                this.academicInfo.current_academic =
                  this.academicInfo.academicList[i].pkAcademicId;
                this.academicInfo.year = this.academicInfo.academicList[i].Year;
                this.academicInfo.current_academic_state = this.academicInfo
                  .academicList[i].current
                  ? "RUNNING"
                  : this.academicInfo.academicList[i].completed
                  ? "COMPLETED"
                  : "NOT_STARTED";
              } else if (this.academicInfo.academicList[i].InActive === 1) {
                const sDate = new Date(
                  this.academicInfo.academicList[i].StartDate
                );
                const eDate = new Date(
                  this.academicInfo.academicList[i].EndDate
                );
                if (eDate < new Date()) {
                  this.academicInfo.academicList[i].completed = true;
                } else {
                  this.academicInfo.academicList[i].notstarted = true;
                }
              }
            }
             this.academicChanged();
          }
          $("body")
            .find("#multiple-id-cards-trigger")
            .attr("selected-academic", this.academicInfo.current_academic);
        },
        (error) => {}
      );
  }

  academicChanged() {
    for (const item of this.academicInfo.academicList) {
      if (item.pkAcademicId === this.academicInfo.current_academic) {
        this.academicInfo.year = item.Year;
        this.academicInfo.current_academic_state = item.current
          ? "RUNNING"
          : item.completed
          ? "COMPLETED"
          : "NOT_STARTED";
            $("body").attr("data-academic-state", this.academicInfo.current_academic_state);
      }
    }
    $("body")
      .find("#multiple-id-cards-trigger")
      .attr("selected-academic", this.academicInfo.current_academic);
    this.initDataTableServerProcess(
      "groups-student-list",
      this.getSchoolId,
      this.getAuthToken,
      this.academicInfo.current_academic,
      this.selectedCategory,
      this.selectedClass,
      this.selectedSection
    );
  }

  // get school designation list
  getSchoolDesignationList(schoolId) {
    this.groupservice
      .groupsSchoolDesignationList(schoolId, localStorage.getItem("usertoken"))
      .subscribe(
        (data: any) => {
          if (data.designationList && data.designationList.length > 0) {
            this.schoolDesignationList = JSON.parse(
              JSON.stringify(data.designationList)
            );
          } else {
            this.schoolDesignationList = [];
          }
        },
        (error) => {}
      );
  }

  // add new student function
  async addNewStudentValidate() {
    this.addNewStudentgender = 1;
    // date of birth
    this.studentDOB = $(".studentDOB").val();
    // admission date
    this.studentAdmissionDate = $(".studentAdmissionDate").val();

    this.studentGender = this.addNewStudentgender;
    this.studentClassId = this.selectedSectionAdd;
    this.studentAcademicId = this.academicId;

    // error validator
    if (!this.formValidator.validateIsData(this.studentName)) {
      const pleaseEnterStudentNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterStudentName')); 
      customToastr(pleaseEnterStudentNameTranslation, 'error');
    } else if (!this.formValidator.validateIsData(this.studentDOB)) {
     const dobIsMissingTranslation = await firstValueFrom(this.translate.get('dobIsMissing')); 
     customToastr(dobIsMissingTranslation, 'error');
    } else if (!$.isNumeric(("" + this.studentDOB + "").replace(/\//g, ""))) {
      const invalidDateOfBirthTranslation = await firstValueFrom(this.translate.get('invalidDateOfBirth')); 
      customToastr(invalidDateOfBirthTranslation, 'error');
    } else if (
      this.selectedSectionAdd === 0 ||
      this.selectedSectionAdd === null
    ) {
      const classIsNotValidPleaseSelectTranslation = await firstValueFrom(this.translate.get('classIsNotValidPleaseSelect')); 
      customToastr(classIsNotValidPleaseSelectTranslation, 'error');
    } else if (!this.formValidator.validateIsData(this.studentAdmissionDate)) {
      const pleaseSelectAdmissionDateTranslation = await firstValueFrom(this.translate.get('pleaseSelectAdmissionDate')); 
      customToastr(pleaseSelectAdmissionDateTranslation, 'error');
    } else if (
      !$.isNumeric(("" + this.studentAdmissionDate + "").replace(/\//g, ""))
    ) {
      const invalidAdmissionDateTranslation = await firstValueFrom(this.translate.get('invalidAdmissionDate')); 
      customToastr(invalidAdmissionDateTranslation, 'error');
    } else if (
      !this.formValidator.validateIsData(this.studentAdmissionNumber)
    ) {
      const enterAdmissionNumberTranslation = await firstValueFrom(this.translate.get('enterAdmissionNumber')); 
      customToastr(enterAdmissionNumberTranslation, 'error');
    } else if (!this.formValidator.validateIsData(this.studentParentName)) {
      const parentNameIsMissingTranslation = await firstValueFrom(this.translate.get('parentNameIsMissing')); 
      customToastr(parentNameIsMissingTranslation, 'error');
    } else if (!this.formValidator.validateIsData(this.studentParentContact)) {
      const pleaseFillTheContactNumberTranslation = await firstValueFrom(this.translate.get('pleaseFillTheContactNumber')); 
      customToastr(pleaseFillTheContactNumberTranslation, 'error');
    } else if (
      !$.isNumeric("" + this.studentParentContact + "") ||
      this.studentParentContact.length > 15
    ) {
     const invalidContactNumberTranslation = await firstValueFrom(this.translate.get('invalidContactNumber')); 
     customToastr(invalidContactNumberTranslation, 'error');
    } else if (!this.formValidator.validateIsData(this.studentAddress)) {
      const studentAddressIsMissingTranslation = await firstValueFrom(this.translate.get('studentAddressIsMissing')); 
      customToastr(studentAddressIsMissingTranslation, 'error');
    } else if (
      this.studentParentEmail.length > 0 &&
      !this.formValidator.validateIsEmail(this.studentParentEmail)
    ) {
      const enterValidEmailTranslation = await firstValueFrom(this.translate.get('enterValidEmail')); 
      customToastr(enterValidEmailTranslation, 'error');
    } else {
      this.addNewStudent();
    }
  }

  async addNewStudent() {
    this.loaderAddStudent = true;
    const newStudentAddedTranslation = await firstValueFrom(this.translate.get('newStudentAdded'));
     customToastr(newStudentAddedTranslation, 'success');
  }

  addNewStuDataClear() {
    this.addNewStudentName = "";
    this.addNewStudentSurName = "";
    this.addNewStudentGender = "1";
    this.addNewStudentDOB = "";
    this.addNewStudentBloodGroup = "A+";
    this.addNewStudentReligion = "Hindu";
    this.addNewStudentCaste = "General";
    this.addNewStudentNationality = "Indian";
    this.addNewStudentEmail = "";
    this.addNewFatherEmail = null;
    this.addNewMotherEmail = null
    this.addNewStudentNumber = "";
    this.addNewStudentPENNumber = "";
    this.addNewStudentIsSingleGirlChild = false;
    this.addNewStudentIsSpeciallyDisabled = false;
    this.addNewFatherPinCode = "";
    this.addNewStudentIsEWS = false;
    this.addNewStudentFatherAnnualIncome = "";
    this.addNewStudentMotherAnnualIncome = "";
    this.addNewIsMinority = false;
    this.addNewStudentAadharNumber = "";
    this.addNewStudentAademicid = this.academicId;
    this.addNewStudentAdmissionBase = "Written exam";
    this.addNewStudentAdmissionStream = "general";
    this.addNewStudentAdmissionNumber = "";
    this.addNewStudentClassId = "0";
    this.addNewStudentFatherName = "";
    this.addNewStudentFatherNumber = "";
    this.addNewStudentFatherOccupation = "";
    this.addNewStudentFatherQualification = "";
    this.addNewStudentFatherAddress = "";

    this.addNewStudentMotherName = "";
    this.addNewStudentMotherNumber = "";
    this.addNewStudentMotherOccupation = "";
    this.addNewStudentMotherQualification = "";
    this.addNewStudentMotherSameFatherAddress = "";
    this.addNewStudentMotherAddress = "";

    this.addNewStudentGuardianName = "";
    this.addNewStudentGuardianNumber = "";
    this.addNewStudentGuardianOccupation = "";
    this.addNewStudentGuardianQualification = "";
    this.addNewStudentGuardianSameFatherAddress = "";
    this.addNewStudentGuardianAddress = "";
    this.addNewStudentHouseName = null;
    this.invalidAddStudentGuardianMobileNumber = false;
    this.addNewGuardianPinCode = "";
    this.addNewMotherPinCode = "";
    this.addNewStudentGuardianAnnualIncome = "";
    $("body").find("#bus-stop-selection-add_").val("0");
    $("body").find("#bus-selection-add_").val("0");
    this.busSelectionAdd = "0";
    this.isTermsVisible = false;
    $("#studentimage").attr(
      "src",
      "https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png"
    );
    $("#openbrowser").val("");
    $("#new-student-aadhar-copy").val("");
    $("#new-student-aadhar-progressbar-div").addClass("hide");
    $("#new-student-aadhar-image-ele").addClass("hide");
    this.invalidAddStudentMobileNumber = false;
    this.invalidAddStudentFatherMobileNumber = false;
    this.addNewStudentNumberInput = "";
    this.addNewStudentNumber = "";
    this.addStudentFatherMobileNumberInput = "";
    this.addNewStudentFatherNumber = "";
    this.invalidAddStudentMotherMobileNumber = false;
    this.addNewStudentMotherNumberInput = "";
    this.addNewStudentMotherNumber = "";
    this.addNewStudentGuardianNumberInput = "";
    this.addNewStudentGuardianNumber = "";
    this.invalidAddStudentGuardianMobileNumber = false;

    $("#new-student-tc-or-birth-copy").val("");
    $("#new-student-tc-or-birth-progressbar-div").addClass("hide");
    $("#new-student-tc-or-birth-image-ele").addClass("hide");

    $("#new-student-Divyangjan-image-ele").addClass("hide");
    this.translate.get('upload').subscribe((translatedText: string) => { $('#new-student-Divyangjan-copy-button').text(translatedText); });
    $("#new-student-Divyangjan-copy").val("");

    $("#new-student-single-girl-image-ele").addClass("hide");
    this.translate.get('upload').subscribe((translatedText: string) => { $('#new-student-single-girl-copy-button').text(translatedText); });
    $("#new-student-single-girl-copy").val("");

    $("#new-student-EWS-image-ele").addClass("hide");
    this.translate.get('upload').subscribe((translatedText: string) => { $('#new-student-EWS-copy-button').text(translatedText); });
    $("#new-student-EWS-copy").val("");

    $("#new-student-caste-image-ele").addClass("hide");
    this.translate.get('upload').subscribe((translatedText: string) => { $('#new-student-caste-copy-button').text(translatedText); });
    $("#new-student-caste-copy").val("");
  }

  addNewStudentButton() {
    this.addNewStuDataClear();
    if ($.fn.intlTelInput) {
      const mobileNumberInput = $("#add-student-mobile-number");
      const fatherMobileNumberInput = $("#add-student-father-mobile-number");
      const motherMobileNumberInput = $(
        "#add-student-mother-mobile-number-new"
      );

      const guardianMobileNumberInput = $(
        "#add-student-guardian-mobile-number-new"
      );

      const countryData = this.getIntlTelInputGlobals().getCountryData();
      const matchedCountry = countryData.find((country: any) => {
        return `${country.dialCode}` == this.currentCountryCode;
      });
      mobileNumberInput.intlTelInput({
        initialCountry: matchedCountry.iso2,
        separateDialCode: false,
        autoPlaceholder: 'off',
        autoFormat: false,
        nationalMode: false,
        formatOnDisplay:false, 
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js",
      });

      // Initialize fatherMobileNumberInput with default country as India
      fatherMobileNumberInput.intlTelInput({
        initialCountry: matchedCountry.iso2,
        separateDialCode: false,
        autoPlaceholder: 'off',
        autoFormat: false,
        nationalMode: false,
        formatOnDisplay:false, 
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js",
      });
      motherMobileNumberInput.intlTelInput({
        initialCountry: matchedCountry.iso2,
        separateDialCode: false,
        autoPlaceholder: 'off',
        autoFormat: false,
        nationalMode: false,
        formatOnDisplay:false, 
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js",
      });

      guardianMobileNumberInput.intlTelInput({
        initialCountry: matchedCountry.iso2,
        separateDialCode: false,
        autoPlaceholder: 'off',
        autoFormat: false,
        nationalMode: false,
        formatOnDisplay:false, 
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js",
      });

      // Handle country change on mobileNumberInput
      mobileNumberInput.on("countrychange", () => {
        mobileNumberInput.val('');
        const countryData = mobileNumberInput.intlTelInput(
          "getSelectedCountryData"
        );
        this.studentCountryCode = countryData.dialCode;
      });

      //Handle country change on fatherMobileNumberInput
      fatherMobileNumberInput.on("countrychange", () => {
        fatherMobileNumberInput.val('');
        const countryData = fatherMobileNumberInput.intlTelInput(
          "getSelectedCountryData"
        );
        this.addNewStudentCountryCode = countryData.dialCode;
      });

      // Handle country change on motherMobileNumberInput
      motherMobileNumberInput.on("countrychange", () => {
        motherMobileNumberInput.val('');
        const countryData = motherMobileNumberInput.intlTelInput(
          "getSelectedCountryData"
        );
        this.motherCountryCode = countryData.dialCode;
      });

      // Handle country change on guardianMobileNumberInput
      guardianMobileNumberInput.on("countrychange", () => {
        guardianMobileNumberInput.val('');
        const countryData = guardianMobileNumberInput.intlTelInput(
          "getSelectedCountryData"
        );
        this.guardianCountryCode = countryData.dialCode;
      });
    }

    // particle background
    $("#hidetxtbox").removeClass("hide");
    this.mTotalBusFees = 0;
    this.getAllBusRoutes(null);
    this.getAllAvailableStopTerms();
    this.getLastRegNumber();
    this.getStudentCategoryList();
    this.offcanvas.handleOffcanvasOpen("#offcanvas-add-newstudent");
    this.getAllStops();
    $("#student-progressbar").addClass("hide");
    $(".addStudentChange").removeClass("validateErrorforAddStudent");
    $(".changestudDob").removeClass("validateErrorforAddStudent");
    $(".changeAdmsnNo").removeClass("validateErrorforAddStudent");
    $(".changeCat").removeClass("validateErrorforAddStudent");
    $(".changeClass").removeClass("validateErrorforAddStudent");
    $(".changeSection").removeClass("validateErrorforAddStudent");
    $(".changeFatherName").removeClass("validateErrorforAddStudent");
    $("#add-student-father-mobile-number").removeClass(
      "validateErrorforAddStudent"
    );
    $(".changeFatherAdd").removeClass("validateErrorforAddStudent");
    $(".changeMotherName").removeClass("validateErrorforAddStudent");
    $("#add-student-mother-mobile-number").removeClass(
      "validateErrorforAddStudent"
    );
    $(".changeMotherAdd").removeClass("validateErrorforAddStudent");
  }

  // get today date
  getTodayDate() {
    const getDateNow = new Date();
    const getMonth = getDateNow.getUTCMonth() + 1;
    const getDay = getDateNow.getUTCDate();
    const getYear = getDateNow.getUTCFullYear();
    return getDay + "/" + getMonth + "/" + getYear;
  }

  //  Vaidation for Onchange border Red for Add student
  addNewStudentNameOnchange(addNewStudentName) {
    const studentValidateName = this.formValidator.validateFieldName(
      addNewStudentName,
      "Student "
    );
    if (studentValidateName) {
      $(".addStudentChange").addClass("validateErrorforAddStudent");
    } else {
      $(".addStudentChange").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentSurNameOnchange() {
    if ($.isNumeric(this.addNewStudentSurName)) {
      $(".changeSurName").addClass("validateErrorforAddStudent");
    } else {
      $(".changeSurName").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentGenderOnchange() {
    if (!this.formValidator.validateIsData(this.addNewStudentGender)) {
      $(".changeGender").addClass("validateErrorforAddStudent");
    } else {
      $(".changeGender").removeClass("validateErrorforAddStudent");
    }
  }

  // addNewStudentCasteOnchange() {

  //   if ($.isNumeric(this.addNewStudentCaste)) {
  //     $('.changeCaste').addClass('validateErrorforAddStudent');
  //   } else {
  //     $('.changeCaste').removeClass('validateErrorforAddStudent');
  //   }
  // }

  addNewStudentEmailOnchange() {
    if (
      this.formValidator.validateIsData(this.addNewStudentEmail) &&
      !this.formValidator.validateIsEmail(this.addNewStudentEmail)
    ) {
      $(".changeEmail").addClass("validateErrorforAddStudent");
    } else {
      $(".changeEmail").removeClass("validateErrorforAddStudent");
    }
  }

  addFatherEmailOnchange() {
    if (
      this.formValidator.validateIsData(this.addNewFatherEmail) &&
      !this.formValidator.validateIsEmail(this.addNewFatherEmail)
    ) {
      $(".changeFatherEmail").addClass("validateErrorforAddStudent");
    } else {
      $(".changeFatherEmail").removeClass("validateErrorforAddStudent");
    }
  }

  addMotherEmailOnchange() {
    if (
      this.formValidator.validateIsData(this.addNewMotherEmail) &&
      !this.formValidator.validateIsEmail(this.addNewMotherEmail)
    ) {
      $(".changeMotherEmail").addClass("validateErrorforAddStudent");
    } else {
      $(".changeMotherEmail").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentBloodGrpOnchange() {
    if (
      !this.formValidator.validateDropdownData(this.addNewStudentBloodGroup)
    ) {
      $(".changeBloodgroup").addClass("validateErrorforAddStudent");
    } else {
      $(".changeBloodgroup").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentDobOnchange() {}

  addNewStudentNationalityOnchange() {
    if (
      !this.formValidator.validateDropdownData(this.addNewStudentNationality)
    ) {
      $(".changeNationality").addClass("validateErrorforAddStudent");
    } else {
      $(".changeNationality").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentAdmissionNumberOnchange() {
    if (!this.formValidator.validateIsData(this.addNewStudentAdmissionNumber)) {
      $(".changeAdmsnNo").addClass("validateErrorforAddStudent");
    } else {
      $(".changeAdmsnNo").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentChangeCategory() {
    if (this.selectedCategoryAdd === null) {
      $(".changeCat").addClass("validateErrorforAddStudent");
    } else {
      $(".changeCat").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentChangeClass() {
    if (this.selectedClassAdd === null) {
      $(".changeClass").addClass("validateErrorforAddStudent");
    } else {
      $(".changeClass").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentChangeClassSection() {
    if (!this.formValidator.validateDropdownData(this.addNewStudentClassId)) {
      $(".changeSection").addClass("validateErrorforAddStudent");
    } else {
      $(".changeSection").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentFatherNameOnchange() {
    const studentFatherNameIsValid = this.formValidator.validateFieldName(
      this.addNewStudentFatherName,
      "Student father"
    );
    if (studentFatherNameIsValid) {
      $(".changeFatherName").addClass("validateErrorforAddStudent");
    } else {
      $(".changeFatherName").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentFatherQualificationOnchange() {
    if ($.isNumeric(this.addNewStudentFatherQualification)) {
      $(".changeFatherQuali").addClass("validateErrorforAddStudent");
    } else {
      $(".changeFatherQuali").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentFatherAddressOnchange() {
    if (
      !this.formValidator.validateIsData(this.addNewStudentFatherAddress) ||
      $.isNumeric(this.addNewStudentFatherAddress)
    ) {
      $(".changeFatherAdd").addClass("validateErrorforAddStudent");
    } else {
      $(".changeFatherAdd").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentMotherNameOnchange() {
    if ($.isNumeric(this.addNewStudentMotherName)) {
      $(".changeMotherName").addClass("validateErrorforAddStudent");
    } else {
      $(".changeMotherName").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentMotherQualificationOnchange() {
    if ($.isNumeric(this.addNewStudentMotherQualification)) {
      $(".changeMotherQuali").addClass("validateErrorforAddStudent");
    } else {
      $(".changeMotherQuali").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentGuardianNameOnchange() {
    if ($.isNumeric(this.addNewStudentGuardianName)) {
      $(".changeGuardianName").addClass("validateErrorforAddStudent");
    } else {
      $(".changeGuardianName").removeClass("validateErrorforAddStudent");
    }
  }

  addNewStudentGuardianQualificationOnchange() {
    if ($.isNumeric(this.addNewStudentGuardianQualification)) {
      $(".changeGuardianQuali").addClass("validateErrorforAddStudent");
    } else {
      $(".changeGuardianQuali").removeClass("validateErrorforAddStudent");
    }
  }

  openbrowsertouplaodphoto() {
    $("#openbrowser").trigger("click");
  }

  async uploadStaffImage(authToken, imageId, staffId) {
    let profilePicUpload = false;
    let aadharUpload = false;

    let imageUploadTappedForStaff = false;

    if (
      ($("#" + imageId)[0].files && $("#" + imageId)[0].files.length > 0) ||
      ($("#new-staff-aadhar-copy")[0].files &&
        $("#new-staff-aadhar-copy")[0].files.length > 0)
    ) {
      const ImageUploadDataForStaff = new FormData();
      if ($("#" + imageId)[0].files && $("#" + imageId)[0].files.length > 0) {
        profilePicUpload = true;
        $("#progressbar").addClass("hide");
        $("#hidetextbox").addClass("hide");
        ImageUploadDataForStaff.append("image", $("#" + imageId)[0].files[0]);
      }

      if (
        $("#new-staff-aadhar-copy")[0].files &&
        $("#new-staff-aadhar-copy")[0].files.length > 0
      ) {
        aadharUpload = true;
        ImageUploadDataForStaff.append(
          "aadharReference",
          $("#new-staff-aadhar-copy")[0].files[0]
        );
      }
      $("#new-staff-progress-div").removeClass("hide");

      $.ajax({
        beforeSend(request) {
          request.setRequestHeader("enctype", "multipart/form-data");
          request.setRequestHeader("authToken", authToken);
        },
        url:
          AppSettings.API_ENDPOINT +
          "/upload/image?userType=STAFF&userId=" +
          staffId,
        data: ImageUploadDataForStaff,
        cache: false,
        processData: false,
        contentType: false,
        xhr() {
          // upload Progress
          const xhr = $.ajaxSettings.xhr();
          if (xhr.upload) {
            xhr.upload.addEventListener(
              "progress",
              (event) => {
                let percent = 0;
                const position = event.loaded || event.position;
                const total = event.total;
                if (event.lengthComputable) {
                  percent = Math.ceil((position / total) * 100);
                }
                $("#new-staff-aadhar-copy-percent-progress").attr(
                  "aria-valuenow",
                  percent
                );
                $("#new-staff-percent-progress").css({ width: percent + "%" });
                if (profilePicUpload && aadharUpload) {
                  this.translate.get('profilePicAndAadharCopyUploading').subscribe((translatedText: string) => { $("#new-staff-percent-text").text(translatedText+ percent + "%"); });
                } else if (profilePicUpload) {
                  this.translate.get('profilePicUploading').subscribe((translatedText: string) => { $("#new-staff-percent-text").text(translatedText+ percent + "%"); });
                } else if (aadharUpload) {
                  this.translate.get('aadharCopyUploading').subscribe((translatedText: string) => { $("#new-staff-percent-text").text(translatedText+ percent + "%"); });
                }
              },
              true
            );
          }
          return xhr;
        },
        type: "POST",
        async success(data, status, req) {
          imageUploadTappedForStaff = true;
          // this.translate.get('changePhoto').subscribe((translatedText: string) => { $('#change_photo_text').text(translatedText); });
          if (data && data.status) {
            //  show success message
            // $("#progressbar").removeClass("hide");
            $("#new-staff-progress-div").addClass("hide");
            const newStaffAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('newStaffAddedSuccessfully')); 
            customToastr(newStaffAddedSuccessfullyTranslation, 'success');
            // this.addNewStaffDataClear();
            $("#closeAddStaff").trigger("click");
          } else {
            $("#new-staff-progress-div").addClass("hide");
            //  show error message
            if (profilePicUpload && aadharUpload) {
              const profilePicAndAadharCopyUploadFailedTranslation = await firstValueFrom(this.translate.get('profilePicAndAadharCopyUploadFailed')); 
              customToastr(profilePicAndAadharCopyUploadFailedTranslation, 'error');
            } else if (profilePicUpload) {
              const profilePicUploadFailedTranslation = await firstValueFrom(this.translate.get('profilePicUploadFailed'));
              customToastr(profilePicUploadFailedTranslation, 'error');
            } else if (aadharUpload) {
              const aadharCopyUploadFailedTranslation = await firstValueFrom(this.translate.get('aadharCopyUploadFailed')); 
              customToastr(aadharCopyUploadFailedTranslation, 'error');
            }
          }
          this.profileImageSelectedForStaff = false;
        },
        async error(req, status, error) {
          $("#new-staff-progress-div").addClass("hide");
          if (profilePicUpload && aadharUpload) {
            const profilePicAndAadharCopyUploadFailedTranslation = await firstValueFrom(this.translate.get('profilePicAndAadharCopyUploadFailed')); 
            customToastr(profilePicAndAadharCopyUploadFailedTranslation, 'error');
          } else if (profilePicUpload) {
            const profilePicUploadFailedTranslation = await firstValueFrom(this.translate.get('profilePicUploadFailed')); 
            customToastr(profilePicUploadFailedTranslation, 'error');
          } else if (aadharUpload) {
            const aadharCopyUploadFailedTranslation = await firstValueFrom(this.translate.get('aadharCopyUploadFailed')); 
            customToastr(aadharCopyUploadFailedTranslation, 'error');
          }

          this.translate.get('changePhoto').subscribe((translatedText: string) => { $('#change_photo_text').text(translatedText); });
          imageUploadTappedForStaff = true;
          //  show error message
          this.profileImageSelectedForStaff = false;
        },
      });
    } else {
      //  show success message
      $("#new-staff-progress-div").addClass("hide");
      $("#progressbar").removeClass("hide");
      const newStaffAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('newStaffAddedSuccessfully')); 
      customToastr(newStaffAddedSuccessfullyTranslation, 'success');
      // this.addNewStaffDataClear();
      $("#closeAddStaff").trigger("click");
    }
  }

  uploadEditStaffImage(authToken, imageId, staffId) {
    let imageUploadTappedForStaff = false;
    const ImageUploadDataForStaff = new FormData();
    ImageUploadDataForStaff.append("image", $("#" + imageId)[0].files[0]);

    $.ajax({
      beforeSend(request) {
        request.setRequestHeader("enctype", "multipart/form-data");
        request.setRequestHeader("authToken", authToken);
      },
      url:
        AppSettings.API_ENDPOINT +
        "/upload/image?userType=STAFF&userId=" +
        staffId,
      data: ImageUploadDataForStaff,
      cache: false,
      processData: false,
      contentType: false,
      xhr() {
        // upload Progress
        const xhr = $.ajaxSettings.xhr();
        if (xhr.upload) {
          xhr.upload.addEventListener(
            "progress",
            (event) => {
              let percent = 0;
              const position = event.loaded || event.position;
              const total = event.total;
              if (event.lengthComputable) {
                percent = Math.ceil((position / total) * 100);
              }
              $("#staffedit-progressbar").removeClass("hide");
              this.translate.get('uploading').subscribe((translatedText: string) => { $('#staffedit-progressbar').text(translatedText + percent + "%"); });
            },
            true
          );
        }
        return xhr;
      },
      type: "POST",
      async success(data, status, req) {
        imageUploadTappedForStaff = true;
        if (data && data.status) {
          //  show success message
          // $("#progressbar").removeClass("hide");
          $("#hideforstaffedit").removeClass("hide");
          $("#staffedit-progressbar").addClass("hide");
          const staffProfileImageUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('staffProfileImageUpdatedSuccessfully')); 
          customToastr(staffProfileImageUpdatedSuccessfullyTranslation, 'success');
        } else {
          //  show error message
          $("#hideforstaffedit").removeClass("hide");
          $("#staffedit-progressbar").addClass("hide");
          const profileImageNotUpdatedTranslation = await firstValueFrom(this.translate.get('profileImageNotUpdated')); 
          customToastr(profileImageNotUpdatedTranslation, 'error');
        }
        this.profileImageSelectedForStaff = false;
      },
      async error(req, status, error) {
        imageUploadTappedForStaff = true;
        //  show error message
        $("#hideforstaffedit").removeClass("hide");
        $("#staffedit-progressbar").addClass("hide");
        const profileImageNotUpdatedServerNotReachableTranslation = await firstValueFrom(this.translate.get('profileImageNotUpdatedServerNotReachable')); 
        customToastr(profileImageNotUpdatedServerNotReachableTranslation, 'error');
        this.profileImageSelectedForStaff = false;
      },
    });
  }

  async uploadStudentImage(authToken, imageId, studentId) {
    let profilePicUpload = false;
    let aadharUpload = false;
    let tcOrBirthCopyUpload = false;
    let ewsCopyUpload = false;
    let divyangjanCopyUpload = false;
    let singleGirlChildCopyUpload = false;
    let casteCopyUpload = true;
    const imageElement = $("#" + imageId)[0];
    const aadharElement = $("#new-student-aadhar-copy")[0];
    const tcOrBirthElement = $("#new-student-tc-or-birth-copy")[0];
    const ewsElement = $("#new-student-EWS-copy")[0];
    const divyangjanElement = $("#new-student-Divyangjan-copy")[0];
    const singleGirlElement = $("#new-student-single-girl-copy")[0];
    const casteElement = $("#new-student-caste-copy")[0];
    if (
      (imageElement?.files && imageElement.files.length > 0) ||
      (aadharElement?.files && aadharElement.files.length > 0) ||
      (tcOrBirthElement?.files && tcOrBirthElement.files.length > 0) ||
      (ewsElement?.files && ewsElement.files.length > 0) ||
      (divyangjanElement?.files && divyangjanElement.files.length > 0) ||
      (singleGirlElement?.files && singleGirlElement.files.length > 0) ||
      (casteElement?.files && casteElement.files.length > 0)
    ) {
      const ImageUploadData = new FormData();
      if (imageElement?.files && imageElement.files.length > 0) {
        profilePicUpload = true;
        $("#hidetxtbox").addClass("hide");
        ImageUploadData.append("image", imageElement.files[0]);
      }

      if (aadharElement?.files && aadharElement.files.length > 0) {
        aadharUpload = true;
        ImageUploadData.append("aadharReference", aadharElement.files[0]);
      }

      if (tcOrBirthElement?.files && tcOrBirthElement.files.length > 0) {
        tcOrBirthCopyUpload = true;
        ImageUploadData.append(
          "tcOrBirthCertificate",
          tcOrBirthElement.files[0]
        );
      }

      if (ewsElement?.files && ewsElement.files.length > 0) {
        ewsCopyUpload = true;
        ImageUploadData.append("ewsCertificate", ewsElement.files[0]);
      }

      if (divyangjanElement?.files && divyangjanElement.files.length > 0) {
        divyangjanCopyUpload = true;
        ImageUploadData.append("speciallyAbled", divyangjanElement.files[0]);
      }

      if (singleGirlElement?.files && singleGirlElement.files.length > 0) {
        singleGirlChildCopyUpload = true;
        ImageUploadData.append(
          "singleGirlChildCertificate",
          singleGirlElement.files[0]
        );
      }

      if (casteElement?.files && casteElement.files.length > 0) {
        casteCopyUpload = true;
        ImageUploadData.append("casteCertificate", casteElement.files[0]);
      }
      $("#new-student-progress-div").removeClass("hide");
      let self = this;

      $.ajax({
        beforeSend(request) {
          request.setRequestHeader("enctype", "multipart/form-data");
          request.setRequestHeader("authToken", authToken);
        },
        url:
          AppSettings.API_ENDPOINT +
          "/upload/image?userType=STUDENT&userId=" +
          studentId,
        data: ImageUploadData,
        cache: false,
        processData: false,
        contentType: false,
        xhr() {
          const xhr = $.ajaxSettings.xhr();
          if (xhr.upload) {
            xhr.upload.addEventListener(
              "progress",
              (event) => {
                let percent = 0;
                const position = event.loaded || event.position;
                const total = event.total;
                if (event.lengthComputable) {
                  percent = Math.ceil((position / total) * 100);
                }
                $("#new-student-percent-progress").attr(
                  "aria-valuenow",
                  percent
                );
                $("#new-student-percent-progress").css({
                  width: percent + "%",
                });

                const uploadStatusText = [];
                if (profilePicUpload) uploadStatusText.push("Profile pic");
                if (aadharUpload) uploadStatusText.push("Aadhar copy");
                if (tcOrBirthCopyUpload)
                  uploadStatusText.push("TC or Birth certificate");
                if (ewsCopyUpload) uploadStatusText.push("EWS certificate");
                if (divyangjanCopyUpload)
                  uploadStatusText.push("Specially abled certificate");
                if (singleGirlChildCopyUpload)
                  uploadStatusText.push("Single girl child certificate");
                if (casteCopyUpload) uploadStatusText.push("Caste certificate");

                $("#new-student-percent-text").text(uploadStatusText.join(", ") + " uploading... " + percent + "%");
              },
              true
            );
          }
          return xhr;
        },
        type: "POST",
        async success(data) {
          $("#new-student-progress-div").addClass("hide");
          if (data && data.status) {
            const newStudentAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('newStudentAddedSuccessfully')); 
            customToastr(newStudentAddedSuccessfullyTranslation, 'success');
            $("#addStClose").trigger("click");
            self.addNewStuDataClear();
          } else {
            const uploadFailedTranslation = await firstValueFrom(this.translate.get('uploadFailed')); 
            customToastr(uploadFailedTranslation, 'error');
            $("#addStClose").trigger("click");
          }
          self.profileImageSelected = false;
        },
        async error() {
          const uploadFailedTranslation = await firstValueFrom(this.translate.get('uploadFailed')); 
          customToastr(uploadFailedTranslation, 'error');
          $("#addStClose").trigger("click");
          self.profileImageSelected = false;
        },
      });
    } else {
      const newStudentAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('newStudentAddedSuccessfully')); 
      customToastr(newStudentAddedSuccessfullyTranslation, 'success');
      $("#addStClose").trigger("click");
    }
  }

  uploadEditStudentImage(authToken, imageId, studentId) {
    let imageUploadTapped = false;
    const ImageUploadData = new FormData();
    ImageUploadData.append("image", $("#" + imageId)[0].files[0]);
    $.ajax({
      beforeSend(request) {
        request.setRequestHeader("enctype", "multipart/form-data");
        request.setRequestHeader("authToken", authToken);
      },
      url:
        AppSettings.API_ENDPOINT +
        "/upload/image?userType=STUDENT&userId=" +
        studentId,
      data: ImageUploadData,
      cache: false,
      processData: false,
      contentType: false,
      xhr() {
        // upload Progress
        const xhr = $.ajaxSettings.xhr();
        if (xhr.upload) {
          xhr.upload.addEventListener(
            "progress",
            (event) => {
              let percent = 0;
              const position = event.loaded || event.position;
              const total = event.total;
              if (event.lengthComputable) {
                percent = Math.ceil((position / total) * 100);
              }
              $("#editStudent-progressbar").removeClass("hide");
               this.translate.get('uploading').subscribe((translatedText: string) => { $("#editStudent-progressbar").text(translatedText + percent + "%"); });
            },
            true
          );
        }
        return xhr;
      },
      type: "POST",
      async success(data, status, req) {
        imageUploadTapped = true;
        if (data && data.status) {
          //  show success message
          $("#hidetextboxedit").removeClass("hide");
          $("#editStudent-progressbar").addClass("hide");
          const studentProfileImageUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentProfileImageUpdatedSuccessfully')); 
          customToastr(studentProfileImageUpdatedSuccessfullyTranslation, 'success');
        } else {
          //  show error message
          $("#hidetextboxedit").removeClass("hide");
          $("#editStudent-progressbar").addClass("hide");
          const profileImageNotUpdatedTranslation = await firstValueFrom(this.translate.get('profileImageNotUpdated')); 
          customToastr(profileImageNotUpdatedTranslation, 'error');
        }
        this.profileImageSelected = false;
      },
      async error(req, status, error) {
        // $(".loading-bar-container").find(".progress").remove();
        // $("#change_photo_text").text("Change Photo");
        imageUploadTapped = true;
        //  show error message
        $("#hidetextboxedit").removeClass("hide");
        $("#editStudent-progressbar").addClass("hide");
       const profileImageNotUpdatedServerNotReachableTranslation = await firstValueFrom(this.translate.get('profileImageNotUpdatedServerNotReachable')); 
       customToastr(profileImageNotUpdatedServerNotReachableTranslation, 'error');
        this.profileImageSelected = false;
      },
    });
  }

  getLastRegNumber() {
    this.groupservice.getLastRegId(localStorage.getItem("usertoken")).subscribe(
      (data: any) => {
        if (data && data.GenerateStudentRegistrationId) {
          this.generateStudentRegistrationId =
            data.GenerateStudentRegistrationId;
        } else {
          this.generateStudentRegistrationId = "MANUAL";
        }
        if (data && data.registrationId) {
          $(".last_registration_number").html(
            "(Last Reg No. <b>" + data.registrationId + "</b>)"
          );
        } else {
          $(".last_registration_number").text("");
        }
      },
      (error) => {
        $(".last_registration_number").text("");
      }
    );
  }
  async addNewStudentFinish() {
    this.addNewStudentFatherNumber = this.addStudentFatherMobileNumberInput;
    let isSingleGirlChild;
    if (this.addNewStudentGender === "0") {
      isSingleGirlChild = this.addNewStudentIsSingleGirlChild === true ? 1 : 0;
    } else {
      this.addNewStudentIsSingleGirlChild = false;
      isSingleGirlChild = 0;
    }
    let addNewStudentIsEWSInput;
    if (this.addNewStudentCaste === "General") {
      addNewStudentIsEWSInput = this.addNewStudentIsEWS === true ? 1 : 0;
    } else {
      this.addNewStudentIsEWS = false;
      addNewStudentIsEWSInput = 0;
    }

    this.addNewStudentDOB = $(".addNewStudentDOB").val();
    this.addNewStudentAademicid = this.academicId;
    const addNewStudentAdmissionDate = this.getTodayDate();
    if (this.addNewStudentMotherSameFatherAddress === true.toString()) {
      this.addNewStudentMotherAddress = this.addNewStudentFatherAddress;
    }
    if (this.addNewStudentGuardianSameFatherAddress === true.toString()) {
      this.addNewStudentGuardianAddress = this.addNewStudentFatherAddress;
    }

    //  Validation for add class border red when submitting form without data for all field for add student
    if (!this.formValidator.validateIsData(this.addNewStudentName)) {
      $(".addStudentChange").addClass("validateErrorforAddStudent");
    }
    if (!this.formValidator.validateDropdownData(this.addNewStudentGender)) {
      $("#admission-gender-groups").addClass("validateErrorforAddStudent");
    }
    if (!this.formValidator.validateIsData(this.addNewStudentDOB)) {
      this.addNewStudentDOB = null;
      $(".changestudDob").addClass("validateErrorforAddStudent");
    }

    if (this.addNewStudentPENNumber) {
      const penNumberLength = this.addNewStudentPENNumber.length;
      if (penNumberLength < 11 || penNumberLength > 12) {
        const pleaseEnterAValidPenNumberWith11Or12DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidPenNumberWith11Or12Digits')); 
        customToastr(pleaseEnterAValidPenNumberWith11Or12DigitsTranslation, 'error');
        return ;
      }
    }

    if (this.addNewStudentFatherNumber.length === 0) {
      $(".changeFatherNumber").addClass("validateErrorforAddStudent");
    }

    if (this.addNewFatherPinCode && this.addNewFatherPinCode.length < 6) {
      const pleaseEnterValidFatherPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidFatherPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidFatherPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }

    if (this.addNewMotherPinCode && this.addNewMotherPinCode.length < 6) {
      const pleaseEnterValidMotherPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMotherPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidMotherPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }

    if (this.addNewGuardianPinCode && this.addNewGuardianPinCode.length < 6) {
      const pleaseEnterValidGuardianPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidGuardianPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidGuardianPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }

    if (
      !this.formValidator.validateDropdownData(this.addNewStudentBloodGroup)
    ) {
      $(".changeBloodgroup").addClass("validateErrorforAddStudent");
    }
    if (
      !this.formValidator.validateDropdownData(this.addNewStudentNationality)
    ) {
      $(".changeNationality").addClass("validateErrorforAddStudent");
    }
    if (
      this.generateStudentRegistrationId === "MANUAL" &&
      !this.formValidator.validateIsData(this.addNewStudentAdmissionNumber)
    ) {
      $(".changeAdmsnNo").addClass("validateErrorforAddStudent");
    }
    if (
      this.formValidator.validateIsData(this.addNewStudentAadharNumber) &&
      !/^[0-9]{12}$/.test(this.addNewStudentAadharNumber)
    ) {
      $("#add-student-aadharNumber-std").addClass("validateErrorforAddStudent");
    }
    if (this.selectedCategoryAdd === null) {
      $(".changeCat").addClass("validateErrorforAddStudent");
    }
    if (this.selectedClassAdd === null) {
      $(".changeClass").addClass("validateErrorforAddStudent");
    }
    if (this.addNewStudentClassId === "0") {
      $(".changeSection").addClass("validateErrorforAddStudent");
    }
    if (
      this.addNewStudentFatherName === undefined ||
      !this.formValidator.validateIsData(this.addNewStudentFatherName)
    ) {
      $(".changeFatherName").addClass("validateErrorforAddStudent");
    }
    if (
      !this.addNewStudentFatherNumber ||
      (this.addNewStudentFatherNumber &&
        this.invalidAddStudentFatherMobileNumber)
    ) {
      const pleaseEnterValidMobileFatherNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMobileFatherNumber')); 
      customToastr(pleaseEnterValidMobileFatherNumberTranslation, 'error');
      return;
    }
    if (
      this.addNewStudentFatherAddress === undefined ||
      !this.formValidator.validateIsData(this.addNewStudentFatherAddress)
    ) {
      $(".changeFatherAdd").addClass("validateErrorforAddStudent");
    }

    this.addNewStudentName = $.trim(this.addNewStudentName);
    this.addNewStudentSurName = $.trim(this.addNewStudentSurName);
    this.addNewStudentCaste = $.trim(this.addNewStudentCaste);
    this.addNewStudentEmail = $.trim(this.addNewStudentEmail);
    this.addNewFatherEmail = this.formValidator.validateIsData(this.addNewFatherEmail) ? this.addNewFatherEmail.trim() : null;
    if (
      this.formValidator.validateIsData(this.addNewFatherEmail) &&
      !this.formValidator.validateIsEmail(this.addNewFatherEmail)
    ) {
      $(".changeFatherEmail").addClass("validateErrorforAddStudent");
      const pleaseEnterValidFatherEmailTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidFatherEmail'));
      customToastr(pleaseEnterValidFatherEmailTranslation, 'error');
      return;
    }
    this.addNewMotherEmail = this.formValidator.validateIsData(this.addNewMotherEmail) ? this.addNewMotherEmail.trim() : null;
    if (
      this.formValidator.validateIsData(this.addNewMotherEmail) &&
      !this.formValidator.validateIsEmail(this.addNewMotherEmail)
    ) {
      $(".changeMotherEmail").addClass("validateErrorforAddStudent");
      const pleaseEnterValidMotherEmailTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMotherEmail'));
      customToastr(pleaseEnterValidMotherEmailTranslation, 'error');
      return;
    } 
    this.addNewStudentNumber = $.trim(this.addNewStudentNumber);
    this.addNewStudentPENNumber = $.trim(this.addNewStudentPENNumber);

    this.addNewStudentAadharNumber = $.trim(this.addNewStudentAadharNumber);
    if (this.generateStudentRegistrationId === "MANUAL") {
      this.addNewStudentAdmissionNumber = $.trim(
        this.addNewStudentAdmissionNumber
      );
    } else {
      this.addNewStudentAdmissionNumber = null;
    }
    this.addNewStudentFatherName = $.trim(this.addNewStudentFatherName);
    this.addNewStudentFatherNumber = $.trim(this.addNewStudentFatherNumber);
    this.addNewStudentFatherQualification = $.trim(
      this.addNewStudentFatherQualification
    );
    this.addNewStudentFatherAddress = $.trim(this.addNewStudentFatherAddress);
    this.addNewStudentMotherName = $.trim(this.addNewStudentMotherName);
    this.addNewStudentMotherNumber = $.trim(this.addNewStudentMotherNumber);
    this.addNewStudentMotherQualification = $.trim(
      this.addNewStudentMotherQualification
    );
    this.addNewStudentMotherAddress = $.trim(this.addNewStudentMotherAddress);
    this.addNewStudentGuardianName = $.trim(this.addNewStudentGuardianName);
    this.addNewStudentGuardianNumber = $.trim(this.addNewStudentGuardianNumber);
    this.addNewStudentGuardianQualification = $.trim(
      this.addNewStudentGuardianQualification
    );
    this.addNewStudentMotherQualification = $.trim(
      this.addNewStudentMotherQualification
    );
    this.addNewStudentGuardianAddress = $.trim(
      this.addNewStudentGuardianAddress
    );

    let busId = this.busSelectionAdd;
    let stopId = $("body").find("#bus-stop-selection-add_").val();

    if (!this.formValidator.validateIsDataForNumber(busId) || busId == 0) {
      busId = null;
    }

    if (!this.formValidator.validateIsDataForNumber(stopId) || stopId == 0) {
      stopId = null;
    }

    if (stopId && !busId) {
      const pleaseSelectBusAlsoTranslation = await firstValueFrom(this.translate.get('pleaseSelectBusAlso')); 
      customToastr(pleaseSelectBusAlsoTranslation, 'error');
      return;
    }
    if (busId && stopId && this.selectedBusTerms.length === 0) {
      const pleaseSelectAtLeastOneTermTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtLeastOneTerm')); 
      customToastr(pleaseSelectAtLeastOneTermTranslation, 'error');
      return;
    }
    if (
      !this.formValidator.validateIsDataForNumber(this.addNewStudentMotherName)
    ) {
      this.addNewStudentMotherName = null;
    } else if (
      !this.formValidator.validateForName(this.addNewStudentMotherName) ||
      $.isNumeric(this.addNewStudentMotherName)
    ) {
      const pleaseEnterAValidMotherNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidMotherName')); 
      customToastr(pleaseEnterAValidMotherNameTranslation, 'error');
      return;
    }

    this.addNewStudentNumber = this.addNewStudentNumberInput;
    if (this.addNewStudentNumberInput) {
      if (this.addNewStudentNumberInput && this.invalidAddStudentMobileNumber) {
        const pleaseEnterValidStudentMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidStudentMobileNumber')); 
        customToastr(pleaseEnterValidStudentMobileNumberTranslation, 'error');
        return;
      }
    }
    this.addNewStudentMotherNumber = this.addNewStudentMotherNumberInput;
    if (this.addNewStudentMotherNumberInput) {
      if (
        this.addNewStudentMotherNumberInput &&
        this.invalidAddStudentMotherMobileNumber
      ) {
        const pleaseEnterValidStudentMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidStudentMobileNumber')); 
        customToastr(pleaseEnterValidStudentMobileNumberTranslation, 'error');
        return;
      }
    }

    if (
      this.formValidator.validateIsData(this.addNewStudentAadharNumber) &&
      !/^[0-9]{12}$/.test(this.addNewStudentAadharNumber)
    ) {
      const enterAValid12DigitAadharUidNumberTranslation = await firstValueFrom(this.translate.get('enterAValid12DigitAadharUidNumber')); 
      customToastr(enterAValid12DigitAadharUidNumberTranslation, 'error');
      return;
    }

    if (
      !this.formValidator.validateIsDataForNumber(
        this.addNewStudentMotherAddress
      )
    ) {
      this.addNewStudentMotherAddress = null;
    }

    if (
      !this.formValidator.validateIsDataForNumber(
        this.addNewStudentGuardianName
      )
    ) {
      this.addNewStudentGuardianName = null;
    } else if (
      !this.formValidator.validateForName(this.addNewStudentGuardianName) ||
      $.isNumeric(this.addNewStudentGuardianName)
    ) {
      const pleaseEnterAValidGuardianNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidGuardianName')); 
      customToastr(pleaseEnterAValidGuardianNameTranslation, 'error');
      return;
    }

    this.addNewStudentGuardianNumber = this.addNewStudentGuardianNumberInput;

    if (this.addNewStudentGuardianNumberInput) {
      if (
        this.addNewStudentGuardianNumberInput &&
        this.invalidAddStudentGuardianMobileNumber
      ) {
       const pleaseEnterValidGuardianMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidGuardianMobileNumber')); 
       customToastr(pleaseEnterValidGuardianMobileNumberTranslation, 'error');
        return;
      }
    }

    if (
      !this.formValidator.validateIsDataForNumber(
        this.addNewStudentGuardianAddress
      )
    ) {
      this.addNewStudentGuardianAddress = null;
    }
    if (
      this.formValidator.validateIsData(this.addNewStudentName) &&
      this.formValidator.validateIsData(this.addNewStudentDOB) &&
      this.formValidator.validateIsData(this.addNewStudentFatherAddress) &&
      this.formValidator.validateIsData(this.selectedCategoryAdd) &&
      this.formValidator.validateIsData(this.selectedClassAdd) &&
      this.addNewStudentClassId !== "0"
    ) {
      const admissionObj = {
        schoolId: this.getSchoolId,
        registrationId: null,
        studentName: this.addNewStudentName,
        studentImage: this.addNewStudentImage,
        classId: this.addNewStudentClassId,
        parentName: this.addNewStudentFatherName,
        studentEmail: this.addNewStudentEmail,
        emailId: this.addNewFatherEmail,
        dateOfBirth: this.addNewStudentDOB,
        mobileNumber: this.addNewStudentFatherNumber,
        mobileCode: this.addNewStudentCountryCode,
        motherCountryCode:this.motherCountryCode,
        guardianCountryCode:this.guardianCountryCode,
        studentCountryCode: this.studentCountryCode,
        dateOfAdmission: addNewStudentAdmissionDate, // today date
        address: this.addNewStudentFatherAddress,
        fkAcademicId: this.addNewStudentAademicid,
        academicId: this.addNewStudentAademicid,
        surname: this.addNewStudentSurName,
        bloodGroup: this.addNewStudentBloodGroup,
        religion: this.addNewStudentReligion,
        cast: this.addNewStudentCaste,
        nationality: this.addNewStudentNationality,
        studentPhone: this.addNewStudentNumber,
        houseName: this.addNewStudentHouseName,
        fatherOccupation: this.addNewStudentFatherOccupation,
        fatherQualification: this.addNewStudentFatherQualification,
        fatherEmail: "",
        motherName: this.addNewStudentMotherName,
        motherPhone: this.addNewStudentMotherNumber,
        motherOccupation: this.addNewStudentMotherOccupation,
        motherQualification: this.addNewStudentMotherQualification,
        motherEmail: this.addNewMotherEmail,
        motherAddress: this.addNewStudentMotherAddress,
        guardianName: this.addNewStudentGuardianName,
        guardianPhone: this.addNewStudentGuardianNumber,
        guardianOccupation: this.addNewStudentGuardianOccupation,
        guardianQualification: this.addNewStudentGuardianQualification,
        guardianAddress: this.addNewStudentGuardianAddress,
        guardianEmail: "",
        gender: this.addNewStudentGender, // 0 r 1
        admissionBase: this.addNewStudentAdmissionBase,
        admissionStream: this.addNewStudentAdmissionStream,
        stopId,
        busId,
        busTerms: this.selectedBusTerms,
        aadharNumber: this.addNewStudentAadharNumber,
        penNumber: this.addNewStudentPENNumber,
        isMinority: this.addNewIsMinority === true ? 1 : 0,
        fatherPinCode: this.addNewFatherPinCode,
        motherAnnualIncome: this.addNewStudentMotherAnnualIncome,
        fatherAnnualIncome: this.addNewStudentFatherAnnualIncome,
        isSingleGirlChild: isSingleGirlChild,
        isEWSCategory: addNewStudentIsEWSInput,
        isSpeciallyAbled:
          this.addNewStudentIsSpeciallyDisabled === true ? 1 : 0,
        motherPinCode: this.addNewMotherPinCode,
        guardianPinCode: this.addNewGuardianPinCode,
        guardianAnnualIncome: this.addNewStudentGuardianAnnualIncome,
      };


      if (this.generateStudentRegistrationId === "MANUAL") {
        admissionObj.registrationId = this.addNewStudentAdmissionNumber;
      }
      if (this.addNewStudentAdmissionStream === "general") {
        this.addNewStudentAdmissionStream = null;
      }
      $("#addStudentbutton").attr("disabled", true);
      this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addStudentbutton').text(translatedText); });
      this.callNewAdmissionService(admissionObj);
    } else {
      const pleaseFillTheMandatoryFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillTheMandatoryFields')); 
      customToastr(pleaseFillTheMandatoryFieldsTranslation, 'error');
    }
  }

  addStudentBusSelect(busId): void {
    this.busSelectionAdd = busId;
    $("body").find("#bus-selection-add_").val(busId);
  }

  addStd_updateSelectedBusRoute(stopId: string): void {
    if (stopId == "0") {
      $("body").find("#bus-stop-selection-add_").val(0);
    } else {
      $("body").find("#bus-stop-selection-add_").val(stopId);
      let stopName = "";
      for (const item of this.busStopListData) {
        if (item.PkBusStopId == stopId) {
          this.mTotalBusFees = item.fare;
          stopName = item.BusStopName;
        }
      }
      this.isTermsVisible = true;
      this.transportservice
        .getBusListForStop(
          stopId,
          this.academicInfo.current_academic,
          localStorage.getItem("usertoken")
        )
        .subscribe(
          async (data: any) => {
            this.busListData = data;
            if (this.busListData.length === 0) {
              const thereAreNoBusesPassingThroughTheStopTranslation = await firstValueFrom(this.translate.get('thereAreNoBusesPassingThroughTheStop'));
              customToastr(thereAreNoBusesPassingThroughTheStopTranslation + stopName,"error");
            }
          },
          (error) => {
            this.busListData = [];
          }
        );
    }
  }

  addStd_updateSelectedBusStop(stopNumber: string): void {
    // stopNumber = $("#bus-stop-selection-add_").val();
    if (stopNumber !== "0") {
      this.isTermsVisible = true;
    } else {
      this.isTermsVisible = false;
    }
    const h = this;
    this.busStopListData.forEach((item) => {
      if (item.pkBusStopId === stopNumber) {
        h.mTotalBusFees = item.fare;
      }
    });
  }

  getFatherAddress(copy) {
    this.addNewStudentMotherAddress = copy
      ? this.addNewStudentFatherAddress
      : "";
    this.addNewStudentMotherNumber = copy ? this.addNewStudentFatherNumber : "";
    this.addNewStudentMotherNumberInput = copy
      ? this.addStudentFatherMobileNumberInput
      : "";
    this.invalidAddStudentMotherMobileNumber = false;
    this.addNewMotherPinCode = copy ? this.addNewFatherPinCode : "";
  }

  getFatherAddressForGuadian(copytwo) {
    this.addNewStudentGuardianAddress = copytwo
      ? this.addNewStudentFatherAddress
      : "";
    this.addNewGuardianPinCode = copytwo ? this.addNewFatherPinCode : "";
  }

  callNewAdmissionService(admissionObj) {
    admissionObj.studentImage =
      "https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png";
    this.admissionservice
      .createNewAdmission(admissionObj, localStorage.getItem("usertoken"))
      .subscribe(
        async (data: any) => {
          $("#addStudentbutton").attr("disabled", false);
          this.translate.get('finish').subscribe((translatedText: string) => { $('#addStudentbutton').text(translatedText); });
          // TODO: Check Status & show status message
          if (data.status === true) {
            this.uploadStudentImage(
              localStorage.getItem("usertoken"),
              "openbrowser",
              data.studentId
            );
            this.addNewStuDataClear();
          } else if (data.message) {
            const addNewStudentFailedTranslation = await firstValueFrom(this.translate.get('addNewStudentFailed'));
            customToastr(addNewStudentFailedTranslation +" <br>" + data.message,"error","New admission");
          } else if (data.errorcode === 10037) {
           const only100StudentsAreAllowedToAddInTrailSubscriptionTranslation = await firstValueFrom(this.translate.get('only100StudentsAreAllowedToAddInTrailSubscription')); 
           customToastr(only100StudentsAreAllowedToAddInTrailSubscriptionTranslation, 'error');
          } else {
            const somethingWentWrongPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('somethingWentWrongPleaseTryAgain')); 
            customToastr(somethingWentWrongPleaseTryAgainTranslation, 'error');
          }
        },
        (error) => {
          $("#addStudentbutton").attr("disabled", false);
          this.translate.get('finish').subscribe((translatedText: string) => { $('#addStudentbutton').text(translatedText); });
          // TODO: Show error message
        }
      );
  }

  importStudentSelectCategory(getcatId) {
    this.getClassInImport = [];
    this.getSectionInImport = [];
    this.getImportStudentsClassId = 0;
    // get class with cat id
    this.groupservice
      .groupsAvailableClass(
        this.getSchoolId,
        getcatId,
        localStorage.getItem("usertoken")
      )
      .subscribe(
        (data: any) => {
          for (const item of data.className) {
            this.getClassInImport.push(item);
          }
        },
        (error) => {}
      );
  }

  importStudentSelectClass(getclassId) {
    this.getSectionInImport = [];
    this.getImportStudentsClassId = 0;
    // get class section with class id
    this.groupservice
      .groupsAvailableClassSection(
        getclassId,
        localStorage.getItem("usertoken")
      )
      .subscribe(
        (data: any) => {
          for (const item of data) {
            this.getSectionInImport.push(item);
          }
        },
        (error) => {}
      );
  }

  importStudentSelectSection(getSectionId) {
    this.getImportStudentsClassId = getSectionId;
    // file process
    const filename = $("#studentBulkUploadSelectFile").val();
    //  check if file extn is the required one
    let extension = filename.replace(/^.*\./, "");
    if (extension === filename) {
      extension = "";
    } else {
      extension = extension.toLowerCase();
    }

    if (extension === "xls") {
      this.proceedxlx = true;
    } else {
      this.proceedxlx = false;
    }

    if (this.proceedxlx === false) {
      this.getImportStudentProceedStatus = false;
    } else {
      this.getImportStudentProceedStatus = true;
    }
  }

  async importStudentProceed() {
    // file process
    const filename = $("#studentBulkUploadSelectFile").val();
    //  check if file extn is the required one
    let extension = filename.replace(/^.*\./, "");
    if (extension === filename) {
      extension = "";
    } else {
      extension = extension.toLowerCase();
    }

    if (extension === "xls" || extension === "xlsx") {
      this.proceedxlx = true;
    } else {
      this.proceedxlx = false;
    }
    // validation
    if (this.getImportStudentsClassId === 0) {
      this.getImportStudentProceedStatus = false;
      const pleaseSelectTheClassTranslation = await firstValueFrom(this.translate.get('pleaseSelectTheClass')); 
      customToastr(pleaseSelectTheClassTranslation, 'error');
    } else if (this.proceedxlx === false) {
      this.getImportStudentProceedStatus = false;
      // importStudentProceedCanvas
      const fileFormatShouldBeInXlsOrXlsxFormatDownloadTheTemplateFileAndUseItTranslation = await firstValueFrom(this.translate.get('fileFormatShouldBeInXlsOrXlsxFormatDownloadTheTemplateFileAndUseIt')); 
      customToastr(fileFormatShouldBeInXlsOrXlsxFormatDownloadTheTemplateFileAndUseItTranslation, 'error');
    } else { 
      this.getImportStudentProceedStatus = true;

      this.loaderImportStudent = false;

      this.fileList[0].schoolId = this.getSchoolId;
      this.fileList[0].classId = this.getImportStudentsClassId;
      if (this.fileList.length > 0) {
        const file: File = this.fileList[0];
        const formData: FormData = new FormData();
        formData.append("uploadfile", file, file.name);
        $(".resolve-proceed-data1").show();
        $(".resolve-proceed-data2").hide();
        this.destroyDataTable("new-admission-import-table");
        this.importStudentListArray = [];

        let getAuthToken = localStorage.getItem("usertoken");
        const headers = new HttpHeaders().append("authToken", getAuthToken);

        this.http
          .post(
            this.URL +
              "/uploadxlsjson?schoolId=" +
              this.getSchoolId +
              "&classId=" +
              this.getImportStudentsClassId,
            formData,
            { headers }
          )
          .pipe(map((res) => res))
          .subscribe(
            async (data: any) => {
              // this.Exceldata = data.ExcelJSONPath;
              this.loaderImportStudent = true;
              if (data.errorcode === 10037) {
               const only100StudentsAreAllowedToAddInTrailSubscriptionTranslation = await firstValueFrom(this.translate.get('only100StudentsAreAllowedToAddInTrailSubscription')); 
               customToastr(only100StudentsAreAllowedToAddInTrailSubscriptionTranslation, 'error');
              } else if (data.sqlMessage) {
                customToastr(data.sqlMessage + `Please Check The Excel sheet`,"error");
              } else {
                $("#bulkUploadSTudentClose").trigger("click");
                this.offcanvas.handleOffcanvasOpen("#import-student-canvas");
                for (let i = 0; i < data.length; i++) {
                  this.importStudentListArray.push(data[i]);
                  if (data.length - 1 === i) {
                    this.initializeDataTableNoPagination(
                      "new-admission-import-table"
                    );
                  }
                }
              }
            },
            async (error) => {
              this.getImportStudentProceedStatus = false;
              this.loaderImportStudent = true;
              const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong')); 
              customToastr(somethingWentWrongTranslation, 'error');
            }
          );

        /*        this.groupservice.upload(this.getSchoolId,this.getImportStudentsClassId,formData).subscribe(
                  (data: any) => {
                    // this.Exceldata = data.ExcelJSONPath;
                    if(data.status === 'progress'){
        
                    }
                    else{
                      this.loaderImportStudent = true;
                      if (data.errorcode === 10037) {
                        customToastr('Only 100 students are allowed to add in Trail subscription!', 'error');
                      } else {
                        this.offcanvas.handleOffcanvasOpen('#import-student-canvas');
                        for (let i = 0; i < data.length; i++) {
                          this.importStudentListArray.push(data[i]);
                          if (data.length - 1 === i) {
                            this.initializeDataTableNoPagination('new-admission-import-table');
                          }
                        }
                      }
                    }
                  },
                  error => {
                    console.error('error on import student: ',error);
                  }
                );*/
      }
    }
  }

  openStudentImportForm() {
    $("#categoryselect").val("0");
    $("#classselect").val("0");
    $("#sectionselect").val("0");
    $("#studentBulkUploadSelectFile").val("");
    $("#displayFileName").val('');
  }

  resolveErrors() {
    $("#new-admission-import-table .import-error").each(function (index) {
      const getattr = $(this).attr("name");
      $(this).html("");
      if (getattr === "admissiondate") {
        $(this).html(
          "<div class='form-group' style='margin: 0;'><label for='admission-student-name'  style='opacity: initial;'>" +
            getattr +
            `</label><input type='text' id=admissionDate-${index} name='admissionDate' class='form-control' style='color: white;font-size: 13px;border-color: white;height: 15px;'  data-provide='datepicker' data-date-format='dd/mm/yyyy' data-date-end-date='0d'></div>`
        ); 
        $(this).find(`#admissionDate-${index}`).datepicker().on("changeDate",async ()=> {
          const currentRow = $(this).closest("tr");
          const admissionDate = currentRow.find('input[name="admissionDate"]').val();
          const parsedDate = moment(admissionDate, "DD/MM/YYYY", true);
          let dob = currentRow.find('input[name="dob"]').val();
          if (!dob) {
            dob = currentRow.find('td[name="dob"]').text().trim(); 
          }
          const parsedDob = moment(dob, ['DD/MM/YYYY','DD-MM-YYYY','YYYY-MM-DD'], true);
          if (parsedDate.isBefore(parsedDob)) {
           const dateOfAdmissionCannotBeBeforeDateOfBirthTranslation = await firstValueFrom(this.translate.get('dateOfAdmissionCannotBeBeforeDateOfBirth')); 
           customToastr(dateOfAdmissionCannotBeBeforeDateOfBirthTranslation, 'error');
            currentRow.find('input[name="admissionDate"]').val("");
          }
        });
      }
      else if(getattr === "dob"){
        $(this).html(
          "<div class='form-group' style='margin: 0;'><label for='admission-student-name'  style='opacity: initial;'>" +
            getattr +
            `</label><input type='text' name='dob' class='form-control' id=dob-${index} style='color: white;font-size: 13px;border-color: white;height: 15px;'  data-provide='datepicker' data-date-format='dd/mm/yyyy' data-date-end-date='0d'</div>`
        );
        $(this).find(`#dob-${index}`).datepicker().on('changeDate', async () => {
          const dob = $(`#dob-${index}`).val();
          const currentRow = $(this).closest("tr");
          let admissionDate = currentRow.find('input[name="admissionDate"]').val();
          if (!admissionDate) {
            admissionDate = currentRow.find('td[name="admissiondate"]').text().trim(); 
          }
          const parsedDate = moment(admissionDate, ['DD/MM/YYYY','DD-MM-YYYY','YYYY-MM-DD'], true);
          const parsedDob = moment(dob, "DD/MM/YYYY", true);
          const currentDate = moment();
          const minDob = currentDate.clone().subtract(2, 'years');
          if (parsedDob.isValid()) {
            if (parsedDob.isAfter(parsedDate)) {
             const dateOfBirthCannotBeAfterTheDateOfAdmissionTranslation = await firstValueFrom(this.translate.get('dateOfBirthCannotBeAfterTheDateOfAdmission')); 
             customToastr(dateOfBirthCannotBeAfterTheDateOfAdmissionTranslation, 'error');
              $(`#dob-${index}`).val('');  
            }
            if (moment(parsedDob).isAfter(minDob)) {
              const dateOfBirthShouldBeAtLeast2YearsAgoTranslation = await firstValueFrom(this.translate.get('dateOfBirthShouldBeAtLeast2YearsAgo')); 
              customToastr(dateOfBirthShouldBeAtLeast2YearsAgoTranslation, 'error');
              $(`#dob-${index}`).val('');  
            }
          } else {
            const pleaseEnterAValidDateOfBirthTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidDateOfBirth')); 
            customToastr(pleaseEnterAValidDateOfBirthTranslation, 'error');
            $(`#dob-${index}`).val('');  
          }
        });
      }

      else if (getattr === "parentcontact") {
        $(this).html(
          "<div class='form-group' style='margin: 0;'><label for='admission-student-name'  style='opacity: initial;'>" +
            getattr +
            "</label><input class='form-control' type='number' style='color: white;font-size: 13px;border-color: white;height: 15px;'></div>"
        );
      } else if (getattr === "gender") {
        $(this).html(
          "<div class='form-group' style='margin: 0;'><label for='admission-student-name'  style='opacity: initial;'>" +
            getattr +
            "</label><select  class='form-control' style='text-transform: initial;color: black;font-size: 13px;'><option value='m'>M</option><option value='f'>F</option></select></div>"
        );
      } else {
        $(this).html(
          "<div class='form-group' style='margin: 0;'><label for='admission-student-name'  style='opacity: initial;'>" +
            getattr +
            "</label><input class='form-control' type='text' style='color: white;font-size: 13px;border-color: white;height: 15px;'></div>"
        );
      }
      $(this).removeClass("import-error");
      $(this).addClass("import-edit");
    });
  }

  // resolve errors and proceed data
  resolveErrorsProceedData() {
    const h = this;
    // validate get email function [jquery]
    function validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    // check for duplicates in array [for more than twice]
    function moreThanOnce(array, searched) {
      let occurence = 0;
      for (let i = 0; i < array.length; i++) {
        if (array[i] === searched) {
          occurence++;
        }
      }
      return occurence;
    }

    const getStudentClassIdArray = [];
    const getStudentAdmissionIdArray = [];

    $("#new-admission-import-table .import-edit")
      .each(function () {
        const getAttr = $(this).attr("name");
        let getInputValue;
        if (getAttr === "gender") {
          getInputValue = $(this).find("select").val();
        } else {
          getInputValue = $(this).find("input").val();
        }

        $(this).html("");
        $(this).html(getInputValue);
        $(this).removeClass("import-edit");

        // to get all imported student classid
        $(".import-students-classids").each(function () {
          if ($(this).html() !== "") {
            getStudentClassIdArray.push($(this).html());
          }
        });

        // to get all imported student admisssion id
        $(".import-students-admissionids").each(function () {
          if ($(this).html() !== "") {
            getStudentAdmissionIdArray.push($(this).html());
          }
        });

        // is data validation
        if (
          getInputValue === "" ||
          getInputValue === null ||
          getInputValue === undefined ||
          getInputValue.replace(/\s/g, "").length === 0
        ) {
          $(this).addClass("import-error");
        } else {
          // $(this).removeClass('import-edit');
          if (getAttr === "classid") {
            if (moreThanOnce(getStudentClassIdArray, getInputValue) > 1) {
              $(this).addClass("import-error");
            }
          }
          if (getAttr === "admissionid") {
            if (moreThanOnce(getStudentAdmissionIdArray, getInputValue) > 1) {
              $(this).addClass("import-error");
            }
          } else {
            $(this).removeClass("import-edit");
          }
        }

        // email validation
        if (getAttr === "parentemail") {
          if (validateEmail(getInputValue) !== true) {
            $(this).addClass("import-error");
          } else {
            $(this).removeClass("import-edit");
          }
        }
        if (getAttr === "parentcontact") {
          if (!h.formValidator.validateOnlyMobileNumber(getInputValue)) {
            $(this).addClass("import-error");
          } else {
            $(this).removeClass("import-edit");
          }
        } else {
          $(this).removeClass("import-edit");
        }

        // email validation
        if (getAttr === "parentemail") {
          if (validateEmail(getInputValue) !== true) {
            $(this).addClass("import-error");
          } else {
            $(this).removeClass("import-edit");
          }
        }
      })
      .promise()
      .done(async function () {
        let errorValue = 0;
        $("#new-admission-import-table .import-error").each(function () {
          errorValue++;
        });
        $(".resolve-proceed-data1").show();
        $(".resolve-proceed-data2").hide();
        // if no errors
        if (errorValue === 0) {
          // table to json
          const $table = $("#new-admission-import-table");
          const rows = [];
          const header = [];
          $table.find("thead th").each(function () {
            header.push($(this).html());
          });
          $table.find("tbody tr").each(function () {
            const row = {};

            $(this)
              .find("td")
              .each(function (i) {
                const key = header[i];
                row[key] = $(this).html();
              });
            rows.push(row);
          });
          $(".get-json-value").html();
          $(".get-json-value").html(JSON.stringify(rows));

          $(".resolve-proceed-data1").hide();
          $(".resolve-proceed-data2").show();
          const allAreValidatedPleaseProceedToImportTranslation = await firstValueFrom(this.translate.get('allAreValidatedPleaseProceedToImport')); 
          customToastr(allAreValidatedPleaseProceedToImportTranslation, 'success');
        } else {
          const pleaseResolveErrorsTranslation = await firstValueFrom(this.translate.get('pleaseResolveErrors')); 
          customToastr(pleaseResolveErrorsTranslation, 'error');
        }
      });
  }

  // validate for duplicate data in temp table
  validateImportStudentByDuplicate() {
    const getJsonStringData = $(".get-json-value").html(); 
    const getSchoolId = this.getSchoolId;
    const getImportStudentsClassId = this.getImportStudentsClassId;
    const getCurrentAcademicId = this.academicId;
    // insert json data in to temp db for validate duplicate data
    this.groupservice
      .validateJsonDataOnProceed(
        getJsonStringData,
        getSchoolId,
        getImportStudentsClassId,
        getCurrentAcademicId,
        localStorage.getItem("usertoken")
      )
      .subscribe(
        async (data: any) => {
          if (data && data.sqlMessage) {
            customToastr(data.sqlMessage + " " + "Please Provide Valid Details","error");
          } else if (data && data[0] && data[0].status === false) {
            customToastr(data[0].message, "error");
          } else {
            this.loaderImportStudent = true;
            const studentImportedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentImportedSuccessfully')); 
            customToastr(studentImportedSuccessfullyTranslation, 'success');
            this.getGroupsClassCategories(this.getSchoolId);
            this.offcanvas.handleOffcanvasOpen("#import-student-canvas");
            const getcatId = "";
            this.importStudentSelectCategory(getcatId);
          }
        },
        (error) => {}
      );
  }

  // get imported file
  getImportFile($event) {
    this.fileList = $event.target.files;
    if (this.getImportStudentsClassId === 0) {
      this.getImportStudentProceedStatus = false;
    } else {
      this.getImportStudentProceedStatus = true;
    }
  }

  /*// // // // // // // // // // // // // // // // // // // // // */

  // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // /

  updateSelectedBusRoute(routeId: string): void {
    routeId = $("body").find("#bus-route-selection-edit").val();
    if (routeId === "0") {
      $("body").find("#bus-stop-selection-edit").val(0);
      this.isTermsVisible = false;
    } else {
      this.isTermsVisible = true;
      const h = this;
      this.busListData.forEach((item) => {
        if (item.pkBusId === routeId) {
          h.getStopsOfRoute(null, item.pkRouteId);
        }
      });
    }
  }

  updateSelectedBus(busId) {
    if (busId === 0) {
      this.selectedBusIdForUpdateStudent = null;
    } else {
      this.selectedBusIdForUpdateStudent = busId;
    }
    $("#bus-selection-edit").val(busId);
    this.studentSelectedTerms.forEach(function (term) {
      if (term.isEditable) {
        term.fkBusStopId = $("#bus-stop-selection-edit").val();
      }
    });
  }

  updateSelectedBusStop(stopId: string): void {
    $("#bus-stop-selection-edit").val(stopId);
    if (stopId === "0") {
      this.isTermsVisible = false;
    } else {
      this.isTermsVisible = true;
      let stopName = "";
      for (const item of this.busStopListData) {
        if (item.PkBusStopId === stopId) {
          this.mTotalBusFees = item.fare;
          stopName = item.BusStopName;
        }
      }
      this.isTermsVisible = true;
      this.transportservice
        .getBusListForStop(
          stopId,
          this.academicInfo.current_academic,
          localStorage.getItem("usertoken")
        )
        .subscribe(
          async (data: any) => {
            this.busListData = data;
            if (this.busListData.length === 0) {
              const thereAreNoBusesPassingThroughTheStopTranslation = await firstValueFrom(this.translate.get('thereAreNoBusesPassingThroughTheStop'))
              customToastr(thereAreNoBusesPassingThroughTheStopTranslation + stopName,"error");
            }
          },
          (error) => {
            this.busListData = [];
          }
        );
      if (this.studentSelectedTerms.length === 0) {
        this.transportservice
          .getStudentTermsDetail(this.selectedStudentListId, this.getAuthToken)
          .subscribe(
            (data: any) => {
              if (data.success === true) {
                const studentTerms = data.data;
                const sortedTerms = [];
                for (let i = studentTerms.length - 1; i >= 0; i--) {
                  sortedTerms.push(studentTerms[i]);
                }
                for (const item of sortedTerms) {
                  // for(var i=(studentTerms.length-1);i>=0;i--){
                  if (item.isSelectedTerm === undefined) {
                    item.isSelectedTerm = false;
                  } else if (item.isSelectedTerm) {
                    this.viewStudentTerms.push(item);
                    this.viewStudentTermIds.push(item.pkBusStopTermId);
                  }
                  if (item.isPaid === undefined) {
                    item.isPaid = false;
                  }
                  if (item.isPaid) {
                    item.isEditable = false;
                  } else {
                    item.isEditable = true;
                  }
                }
                this.studentSelectedTerms = sortedTerms;
              }
            },
            (error) => {}
          );
      }
    }
  }

  getAllBusRoutes(schoolId) {
    this.transportservice
      .getAllBuses(
        schoolId,
        this.academicInfo.current_academic,
        localStorage.getItem("usertoken")
      )
      .subscribe(
        (data: any) => {
          this.busListData = data;
        },
        (error) => {}
      );
  }

  getStopsOfRoute(schoolId, classId) {
    this.transportservice
      .getstopsOfRoute(
        schoolId,
        classId,
        this.academicInfo.current_academic,
        localStorage.getItem("usertoken")
      )
      .subscribe(
        (data: any) => {
          // this.busStopListData = data;
        },
        (error) => {}
      );
  }

  getAllStops() {
    this.transportservice
      .fetchBusStop(
        this.academicInfo.current_academic,
        localStorage.getItem("usertoken")
      )
      .subscribe(
        (data: any) => {
          this.busStopListData = data;
        },
        (error) => {}
      );
  }

  getAllStopTerms() {
    this.transportservice
      .getStopTerms(localStorage.getItem("usertoken"))
      .subscribe(
        (data: any) => {
          if (data.success) {
            this.allTermsList = data.data;
          }
        },
        (error) => {}
      );
  }

  getAllAvailableStopTerms() {
    this.transportservice
      .getAvailableStopTerms(localStorage.getItem("usertoken"))
      .subscribe(
        (data: any) => {
          if (data.success) {
            this.avalialableTermsList = data.data;
          }
        },
        (error) => {}
      );
  }

  onBusTermChanged(event, termId) {
    const isChecked = event.currentTarget.checked;
    if (this.selectedBusTerms.indexOf(termId) !== -1 && isChecked === false) {
      const index = this.selectedBusTerms.indexOf(termId);
      this.selectedBusTerms.splice(index, 1);
    } else {
      this.selectedBusTerms.push(termId);
    }
  }

  onBusTermChangedSelectAllTerms(event) {
    const isChecked = event.currentTarget.checked;
    this.selectedBusTerms = [];
    if (isChecked === true) {
      for (let i = 0; i < this.avalialableTermsList.length; i++) {
        this.avalialableTermsList[i].isSelectedTerm = true;
        this.selectedBusTerms.push(
          this.avalialableTermsList[i].pkBusStopTermId
        );
      }
    } else {
      for (let i = 0; i < this.avalialableTermsList.length; i++) {
        this.avalialableTermsList[i].isSelectedTerm = false;
      }
    }
  }

  onBusTermChangedSelectAllTerms_editStudent(event) {
    const isChecked = event.currentTarget.checked;
    // this.selectedBusTerms = [];
    if (isChecked === true) {
      const _fixedTerms = [];
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.studentSelectedTerms.length; i++) {
        _fixedTerms.push(this.studentSelectedTerms[i].pkBusStopTermId);
        this.studentSelectedTerms[i].isSelectedTerm = true;
      }

      this.viewStudentTermIds = _fixedTerms;
    } else {
      const fixedTerms = [];
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.studentSelectedTerms.length; i++) {
        if (!this.studentSelectedTerms[i].isEditable) {
          fixedTerms.push(this.studentSelectedTerms[i].pkBusStopTermId);
        } else {
          this.studentSelectedTerms[i].isSelectedTerm = false;
        }
      }
      this.viewStudentTermIds = fixedTerms;
    }
  }

  onEditBusTermChanged(event, term) {
    const isChecked = event.currentTarget.checked;
    const termId = term.pkBusStopTermId;
    term.isSelectedTerm = isChecked;
    if (this.viewStudentTermIds.indexOf(termId) !== -1 && isChecked === false) {
      const index = this.viewStudentTermIds.indexOf(termId);
      this.viewStudentTermIds.splice(index, 1);
    } else {
      this.viewStudentTermIds.push(termId);
    }
  }

  updateStudentRollNumberToAlphabetOrder(classId) {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#update-student-rool-number-ok').text(translatedText); });
    $(
      "#update-student-rool-number-ok, #update-student-rool-number-cancel"
    ).attr("disabled", true);
    this.groupservice
      .updateStudentRollNumbersToAlphabetOrder(
        classId,
        localStorage.getItem("usertoken")
      )
      .subscribe(
        async (data: any) => {
          this.translate.get('OK').subscribe((translatedText: string) => { $('#update-student-rool-number-ok').text(translatedText); });
          if (data.status) {
            const studentRollNumbersAreChangedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentRollNumbersAreChangedSuccessfully')); 
            customToastr(studentRollNumbersAreChangedSuccessfullyTranslation, 'success');
          }
          $(
            "#update-student-rool-number-ok, #update-student-rool-number-cancel"
          ).attr("disabled", false);
          $("#update-student-rool-number-cancel").trigger("click");
          this.initDataTableServerProcess(
            "groups-student-list",
            this.getSchoolId,
            this.getAuthToken,
            this.academicInfo.current_academic,
            this.selectedCategory,
            this.selectedClass,
            this.selectedSection
          );
        },
        async (error) => {
          const failedToUpdateStudentRollNumbersTranslation = await firstValueFrom(this.translate.get('failedToUpdateStudentRollNumbers')); 
          customToastr(failedToUpdateStudentRollNumbersTranslation, 'error');
        }
      );
  }

  openUpdateRollNumberPopup() {
    const selectedClassInfo: any = this.schoolClasses.find((c: any) => c.classid == this.selectedClass);
    const selectedSectionInfo: any = this.schoolClassesSections.find((s: any) => s.claaSectionId == this.selectedSection);
    this.updateRollNumberClassName = selectedClassInfo ? selectedClassInfo.classname : "";
    this.updateRollNumberSectionName = selectedSectionInfo ? selectedSectionInfo.classSection : "";

    this.rollNumberSearchText = "";
    this.updateRollNumberStudentList = [];
    this.filteredRollNumberStudentList = [];
    this.updateRollNumberLoading = true;
    this.showUpdateRollNumberPopup = true;

    this.groupservice.getClassStudentListForRollNumber(this.selectedSection).subscribe(
      async (data: any) => {
        this.updateRollNumberLoading = false;
        const studentList = (data && data.body && data.body.studentList) || [];
        this.updateRollNumberStudentList = studentList.map((student: any) => ({
          studentId: student.studentId,
          studentName: student.studentName,
          studentImage: student.studentImage,
          admissionNumber: student.admissionNumber,
          fatherName: student.parentName,
          mobileNumber: student.mobileNumber,
          rollNumber: student.rollNumber,
        }));
        this.filteredRollNumberStudentList = this.updateRollNumberStudentList;
      },
      async (error) => {
        this.updateRollNumberLoading = false;
        const genericErrorTranslation = await firstValueFrom(this.translate.get('error'));
        customToastr(error?.error?.message ? error.error.message : genericErrorTranslation, 'error');
      }
    );
  }

  filterRollNumberStudentList() {
    const searchText = (this.rollNumberSearchText || "").trim().toLowerCase();
    if (!searchText) {
      this.filteredRollNumberStudentList = this.updateRollNumberStudentList;
      return;
    }
    this.filteredRollNumberStudentList = this.updateRollNumberStudentList.filter((student: any) =>
      (student.studentName || "").toLowerCase().includes(searchText) ||
      (student.admissionNumber || "").toLowerCase().includes(searchText) ||
      (student.fatherName || "").toLowerCase().includes(searchText) ||
      (student.mobileNumber || "").includes(searchText)
    );
  }

  getStudentInitials(studentName: string): string {
    if (!studentName) {
      return "";
    }
    return studentName
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
  }

  // function for generate dummy array for skelton loader
  generateDummyArray(count: number): any[] {
    return Array.from({ length: count }, () => ({}));
  }

  sanitizeRollNumberOnPaste(event: ClipboardEvent, student: any) {
    event.preventDefault();
    const pastedText = event.clipboardData ? event.clipboardData.getData('text') : '';
    student.rollNumber = pastedText.replace(/\D/g, '').slice(0, 4);
  }

  hasEmptyRollNumber(): boolean {
    return this.updateRollNumberStudentList.some((student: any) => !student.rollNumber);
  }

  saveRollNumbers() {
    if (this.hasEmptyRollNumber()) {
      return;
    }

    const studentList = this.updateRollNumberStudentList.map((student: any) => ({
      studentId: student.studentId,
      rollNumber: student.rollNumber,
    }));

    this.savingRollNumbers = true;
    this.groupservice.bulkUpdateStudentRollNumber(this.selectedSection, studentList).subscribe(
      async (data: any) => {
        this.savingRollNumbers = false;
        const rollNumbersUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentRollNumbersAreChangedSuccessfully'));
        customToastr(rollNumbersUpdatedSuccessfullyTranslation, 'success');
        this.showUpdateRollNumberPopup = false;
        this.initDataTableServerProcess(
          "groups-student-list",
          this.getSchoolId,
          this.getAuthToken,
          this.academicInfo.current_academic,
          this.selectedCategory,
          this.selectedClass,
          this.selectedSection
        );
      },
      async (error) => {
        this.savingRollNumbers = false;
        const genericErrorTranslation = await firstValueFrom(this.translate.get('error'));
        customToastr(error?.error?.message ? error.error.message : genericErrorTranslation, 'error');
      }
    );
  }

  closeUpdateRollNumberPopup() {
    this.showUpdateRollNumberPopup = false;
  }

  getStudentCategoryList() {
    this.admissionservice
      .getStudentCategoriesFoAdmission(localStorage.getItem("usertoken"))
      .subscribe(
        (data: any) => {
          if (data && data.length) {
            this.studentCategoryListForAdmission = data;
          } else {
            this.studentCategoryListForAdmission = [];
          }
        },
        (error) => {
          this.studentCategoryListForAdmission = [];
        }
      );
  }
  async clearTransportOptions() {
    if (this.studentSelectedTerms.length > 0) {
      let nonEditableTermsExist = false;
      for (const item of this.studentSelectedTerms) {
        if (!item.isEditable) {
          nonEditableTermsExist = true;
        }
      }
      if (!nonEditableTermsExist) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.studentSelectedTerms.length; i++) {
          this.studentSelectedTerms[i].isSelectedTerm = false;
        }
        this.busListData = [];
        const stops = JSON.parse(JSON.stringify(this.busStopListData));
        this.busStopListData = JSON.parse(JSON.stringify([]));
        $("body").find("#bus-stop-selection-edit").val("0");
        $("body").find("#bus-selection-edit").val("0");
        this.busStopListData = JSON.parse(JSON.stringify(stops));
        this.mTotalBusFees = 0;
        this.isTermsVisible = false;
      } else {
        const notAllowedToClearTransportFacilityStudentAlreadyPaidFeesPleaseCancelTheFeesAndClearTransportFacilityTranslation = await firstValueFrom(this.translate.get('notAllowedToClearTransportFacilityStudentAlreadyPaidFeesPleaseCancelTheFeesAndClearTransportFacility')); 
        customToastr(notAllowedToClearTransportFacilityStudentAlreadyPaidFeesPleaseCancelTheFeesAndClearTransportFacilityTranslation, 'error');
      }
    }
  }

  initDataTableServerProcessStaffstable = null;
  initDataTableServerProcessStaffs() {
    if (this.initDataTableServerProcessStaffstable) {
      $("#staff-list-table").DataTable().destroy();
    }
    this.staffListHasData = false;

    const token = this.getAuthToken;
    const printIdElement = document.getElementById('printIdHeader');
    let designationId: number | null = null;
    let appStatus: number | null = null;
    const h = this;
    const male = this.genderTranslations['male'];
    const female = this.genderTranslations['female'];
    const active = this.isActiveTranslations['active'];
    const inactive = this.isActiveTranslations['inactive'];
    const isActiveTranslations = this.isActiveTranslations;

    if (this.staffFilterDesignation !== 'all') {
      const id = parseInt(this.staffFilterDesignation, 10);
      if (!isNaN(id)) designationId = id;
    }
    if (this.staffFilterAppStatus !== 'all') {
      const status = parseInt(this.staffFilterAppStatus, 10);
      if (!isNaN(status)) appStatus = status;
    }
    this.translate.get([
      'dataTables.processing',
      'dataTables.search',
      'dataTables.processing',
      'dataTables.lengthMenu',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.infoFiltered',
      'dataTables.paginate.first',
      'dataTables.paginate.last',
      'dataTables.paginate.next',
      'dataTables.paginate.previous',
      'dataTables.printId'
    ]).subscribe(translations => {
    this.initDataTableServerProcessStaffstable = $(
      "#staff-list-table"
    ).DataTable({
      destroy: true,
      language: {
        search: translations['dataTables.search'],
        lengthMenu: translations['dataTables.lengthMenu'],
        info: translations['dataTables.info'],
        infoEmpty: translations['dataTables.infoEmpty'],
        infoFiltered: translations['dataTables.infoFiltered'],
        paginate: {
          first: translations['dataTables.paginate.first'],
          last: translations['dataTables.paginate.last'],
          next: translations['dataTables.paginate.next'],
          previous: translations['dataTables.paginate.previous']
        },
        processing:
          `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`,
      },
      processing: true,
      serverSide: true,
      ajax: {
        beforeSend(request) {
          request.setRequestHeader("Content-Type", "application/json");
          request.setRequestHeader("authToken", token);
        },
        url: AppSettings.API_ENDPOINT + "/stafflist/searchStaff",
        type: "POST",
        data(d) {
          return JSON.stringify({
            schoolId: localStorage.getItem("schoolinfo"),
            designationId,
            appStatus,
            countFrom: d.start,
            lengthOf: d.length,
            search: d.search.value,
            sort: d.order,
          });
        },
        dataSrc: function (json) {
          try {
            console.log('Staff list API response (stafflist/searchStaff):', json);
            const total = (json && typeof json === 'object' && (json.recordsTotal !== undefined || json.recordsFiltered !== undefined))
              ? (json.recordsTotal ?? json.recordsFiltered)
              : (json && json.data && Array.isArray(json.data) ? json.data.length : 0);
            h.ngZone.run(() => { h.staffListHasData = Number(total) > 0; });
          } catch (e) { }
          return (json && json.data && Array.isArray(json.data)) ? json.data : [];
        },
      },
      columns: [
        { data: "staffName" },
        { data: "employmentId" },
        { data: "designation" },
        { data: "emailId" },
        { data: "mobileNumber" },
        {
          data: "gender",
          defaultContent: "",
          render: function (data, type, row) {
            if (data === 0) return female;
            if (data === 1) return male;
            return '';
          }
        },
        { data: "isAppUser",
          defaultContent: "",
          render: function (data, type, row) {
            if (data === 0) return inactive ;
            if (data === 1) return active;
            return '';
          }
         },
         {
          data: null,
          orderable: false,
          className: "staff-checkbox-column",
          defaultContent: `
            <label class='checkbox-inline checkbox-styled checkbox-primary'>
              <input type='checkbox' class='staff-row-checkbox' name='staff-checkbox'>
              <span class='checkbox-material'><span class='check'></span></span>
            </label>
          `,
          width: "5%"
        }
      ],

      createdRow(row, data, index) {
        const d = $(row);
        d.css({ cursor: "pointer" });
        d.attr("id", data.staffId); 

        $(row).find('.staff-row-checkbox, .checkbox-material').on('change click', function (e) {
          e.stopPropagation(); 

          // Find the actual checkbox input
          const checkbox = $(this).hasClass('staff-row-checkbox')
            ? $(this)
            : $(this).closest('label').find('.staff-row-checkbox');

          const isChecked = checkbox.prop('checked');
          h.staffSelectedInTable(isChecked, e);
        });

        // Handle row clicks (excluding checkbox column)
        d.on("click", (e) => {
          if ($(e.target).closest('.staff-checkbox-column').length > 0) {
            return; 
          }
          h.listSelectedStaff(data.staffId);
        });
      }
    });
    /*// // // // // // // /*/
  });
  }

  editStaffDeactiveStateChange(state) {
    const active = $("#accstatus").prop("checked");
    const deActive = $("#accstatus2").prop("checked");
    if (deActive) {
      $("#reasonStaff").removeClass("hide");
    } else {
      $("#reasonStaff").addClass("hide");
    }
  }

  openEditStaffAadharCopyUpload() {
    $("#edit-staff-aadhar-copy").trigger("click");
  }

  startUploadingEditStaffAadharCopy() {
    if (
      this.validateImage(
        "#edit-staff-aadhar-copy",
        "#edit-staff-aadhar-progressbar",
        "#edit-staff-aadhar-image-ele",
        ""
      )
    ) {
      $("#edti-staff-aadhar-copy-button").addClass("hide");
      const authToken = this.getAuthToken;
      const imageId = "edit-staff-aadhar-copy";

      const staffId = this.selectedStaffId;
      let imageUploadTapped = false;
      const ImageUploadData = new FormData();
      ImageUploadData.append("aadharReference", $("#" + imageId)[0].files[0]);
      $.ajax({
        beforeSend(request) {
          request.setRequestHeader("enctype", "multipart/form-data");
          request.setRequestHeader("authToken", authToken);
        },
        url:
          AppSettings.API_ENDPOINT +
          "/upload/image?userType=STAFF&userId=" +
          staffId,
        data: ImageUploadData,
        cache: false,
        processData: false,
        contentType: false,
        xhr() {
          // upload Progress
          const xhr = $.ajaxSettings.xhr();
          if (xhr.upload) {
            xhr.upload.addEventListener(
              "progress",
              function (event) {
                let percent = 0;
                const position = event.loaded || event.position;
                const total = event.total;
                if (event.lengthComputable) {
                  percent = Math.ceil((position / total) * 100);
                }
                $("#edit-staff-aadhar-progressbar-div").removeClass("hide");
                this.translate.get('uploading').subscribe((translatedText: string) => { $("#edit-staff-aadhar-progressbar").text(translatedText+ percent + "%"); });
              },
              true
            );
          }
          return xhr;
        },
        type: "POST",
        async success(data, status, req) {
          imageUploadTapped = true;
          $("#edti-staff-aadhar-copy-button").removeClass("hide");
          if (data && data.status) {
            //  show success message
            $("#edit-staff-aadhar-image-ele").removeClass("hide");
            $("#edit-staff-aadhar-progressbar-div").addClass("hide");
           const studentAadharCopyUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentAadharCopyUpdatedSuccessfully')); 
           customToastr(studentAadharCopyUpdatedSuccessfullyTranslation, 'success');
            this.translate.get('change').subscribe((translatedText: string) => { $('#edti-staff-aadhar-copy-button').text(translatedText); });
          } else {
            //  show error message
            // $("#edit-student-aadhar-image-ele").removeClass('hide');
            $("#edit-staff-aadhar-progressbar-div").addClass("hide");
            const aadharNotUpdatedTranslation = await firstValueFrom(this.translate.get('aadharNotUpdated')); 
            customToastr(aadharNotUpdatedTranslation, 'error');
            if (this.editSelectedStaffAadharCopy) {
              this.translate.get('change').subscribe((translatedText: string) => { $('#edti-staff-aadhar-copy-button').text(translatedText); });
              $("#edit-staff-aadhar-copy").val("");
              $("#edit-staff-aadhar-image-ele").attr(
                "src",
                this.editSelectedStaffAadharCopy
              );
              $("#edit-staff-aadhar-image-ele").removeClass("hide");
            } else {
              this.translate.get('upload').subscribe((translatedText: string) => { $('#edti-staff-aadhar-copy-button').text(translatedText); });
              $("#edit-staff-aadhar-copy").val("");
              $("#edit-staff-aadhar-image-ele").val("");
              $("#edit-staff-aadhar-image-ele").addClass("hide");
            }
          }
          this.profileImageSelected = false;
        },
        async error(req, status, error) {
          if (this.editSelectedStaffAadharCopy) {
            this.translate.get('change').subscribe((translatedText: string) => { $('#edti-staff-aadhar-copy-button').text(translatedText); });
            $("#edit-staff-aadhar-copy").val("");
            $("#edit-staff-aadhar-image-ele").attr(
              "src",
              this.editSelectedStaffAadharCopy
            );
            $("#edit-staff-aadhar-image-ele").removeClass("hide");
          } else {
            this.translate.get('upload').subscribe((translatedText: string) => { $('#edti-staff-aadhar-copy-button').text(translatedText); });
            $("#edit-staff-aadhar-copy").val("");
            $("#edit-staff-aadhar-image-ele").attr("src", "");
            $("#edit-staff-aadhar-image-ele").addClass("hide");
          }
          // $(".loading-bar-container").find(".progress").remove();
          // $("#change_photo_text").text("Change Photo");
          imageUploadTapped = true;
          //  show error message
          // $("#edit-student-aadhar-image-ele").removeClass('hide');
          $("#edit-staff-aadhar-progressbar-div").addClass("hide");
          const aadharCopyNotUpdatedServerNotReachableTranslation = await firstValueFrom(this.translate.get('aadharCopyNotUpdatedServerNotReachable')); 
          customToastr(aadharCopyNotUpdatedServerNotReachableTranslation, 'error');
          this.profileImageSelected = false;
        },
      });
    }
  }

  async validateImage(id, progressbarId, imageEleId, certificateType) {
    const extension = $(id).val().split(".").pop().toLowerCase();
    const allowedExtensions = ["gif", "jpeg", "png", "jpg", "pdf"];
    if (!allowedExtensions.includes(extension)) {
      $(progressbarId).addClass("hide");
      const pleaseSelectAValidImageTypeGifJpegPngJpgPdfTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidImageTypeGifJpegPngJpgPdf')); 
      customToastr(pleaseSelectAValidImageTypeGifJpegPngJpgPdfTranslation, 'error');
      return false;
    }
    const file = $(id).get(0).files[0];
    if (file.size > 1024 * 1024 * 20) {
      $(progressbarId).addClass("hide");
      const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('imageSizeShouldNotExceed20Mb')); 
      customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
      return false;
    }

    if (file) {
      const imageAadharElem = document.getElementById(
        "new-student-aadhar-image-ele"
      );
      const pdfAadaharIconElem = document.getElementById("aadhar-pdf-icon");
      const imageCasteElem = document.getElementById(
        "new-student-caste-image-ele"
      );
      const pdfCasteIconElem = document.getElementById("caste-pdf-icon");
      const imageTcOrBirthElem = document.getElementById(
        "new-student-tc-or-birth-image-ele"
      );
      const pdfTcOrBirthIconElem = document.getElementById(
        "tc-or-birth-pdf-icon"
      );
      const divyangjanElem = document.getElementById(
        "new-student-Divyangjan-image-ele"
      );
      const pdfDivyangjanIconElem = document.getElementById(
        "divyangjan-pdf-icon"
      );
      const singleGirlElem = document.getElementById(
        "new-student-single-girl-image-ele"
      );
      const singleGirlIconElem = document.getElementById(
        "single-girl-pdf-icon"
      );
      const ewsElem = document.getElementById("new-student-EWS-image-ele");
      const ewsIconElem = document.getElementById("EWS-pdf-icon");

      if (
        file.type === "application/pdf" &&
        certificateType === "aadharReference"
      ) {
        pdfAadaharIconElem.classList.remove("hide");
        imageAadharElem.style.display = "none";
      } else if (
        file.type !== "application/pdf" &&
        certificateType === "aadharReference"
      ) {
        pdfAadaharIconElem.classList.add("hide");
        imageAadharElem.style.display = "block";
      }
      if (
        file.type === "application/pdf" &&
        certificateType === "casteCertificate"
      ) {
        pdfCasteIconElem.classList.remove("hide");
        imageCasteElem.style.display = "none";
      } else if (
        file.type !== "application/pdf" &&
        certificateType === "casteCertificate"
      ) {
        pdfCasteIconElem.classList.add("hide");
        imageCasteElem.style.display = "block";
      }
      if (
        file.type === "application/pdf" &&
        certificateType === "tcOrBirthCertificate"
      ) {
        pdfTcOrBirthIconElem.classList.remove("hide");
        imageTcOrBirthElem.style.display = "none";
      } else if (
        file.type !== "application/pdf" &&
        certificateType === "tcOrBirthCertificate"
      ) {
        pdfTcOrBirthIconElem.classList.add("hide");
        imageTcOrBirthElem.style.display = "block";
      }
      if (
        file.type === "application/pdf" &&
        certificateType === "speciallyAbled"
      ) {
        pdfDivyangjanIconElem.classList.remove("hide");
        divyangjanElem.style.display = "none";
      } else if (
        file.type !== "application/pdf" &&
        certificateType === "speciallyAbled"
      ) {
        pdfDivyangjanIconElem.classList.add("hide");
        divyangjanElem.style.display = "block";
      }
      if (
        file.type === "application/pdf" &&
        certificateType === "singleGirlChildCertificate"
      ) {
        singleGirlIconElem.classList.remove("hide");
        singleGirlElem.style.display = "none";
      } else if (
        file.type !== "application/pdf" &&
        certificateType === "singleGirlChildCertificate"
      ) {
        singleGirlIconElem.classList.add("hide");
        singleGirlElem.style.display = "block";
      }
      if (
        file.type === "application/pdf" &&
        certificateType === "ewsCertificate"
      ) {
        ewsIconElem.classList.remove("hide");
        ewsElem.style.display = "none";
      } else if (
        file.type !== "application/pdf" &&
        certificateType === "ewsCertificate"
      ) {
        ewsIconElem.classList.add("hide");
        ewsElem.style.display = "block";
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        $(imageEleId).attr("src", e.target.result).removeClass("hide");
      };
      reader.readAsDataURL(file);
    }

    return true;
  }

  openNewStudentAadharCopyUpload() {
    $("#new-student-aadhar-copy").trigger("click");
  }

  startUploadingNewStudentAadharCopy(event) {
    if (
      this.validateImage(
        "#new-student-aadhar-copy",
        "#new-student-aadhar-progressbar",
        "#new-student-aadhar-image-ele",
        "aadharReference"
      )
    ) {
      this.translate.get('change').subscribe((translatedText: string) => { $('#new-student-aadhar-copy-button').text(translatedText); });
    }
  }

  openNewStaffAadharCopyUpload() {
    $("#new-staff-aadhar-copy").trigger("click");
  }

  startUploadingNewStaffAadharCopy() {
    if (
      this.validateImage(
        "#new-staff-aadhar-copy",
        "#new-staff-aadhar-progressbar",
        "#new-staff-aadhar-image-ele",
        ""
      )
    ) {
      this.translate.get('change').subscribe((translatedText: string) => { $('#new-staff-aadhar-copy-button').text(translatedText); });
    }
  }

  removeStaffProfilePic() {
    this.removeStaffProfilePicStatus = true;
    this.groupservice
      .removeStaffProfilePic(
        localStorage.getItem("usertoken"),
        this.selectedStaffId
      )
      .subscribe(
        async (data: any) => {
          if (data.errorcode) {
            this.removeStaffProfilePicStatus = false;
           const failedToDeletedStaffImageBecuseNoImageExistsTranslation = await firstValueFrom(this.translate.get('failedToDeletedStaffImageBecuseNoImageExists')); 
           customToastr(failedToDeletedStaffImageBecuseNoImageExistsTranslation, 'error');
            $("#deleteStaffPopupClose").trigger("click");
          } else {
            this.removeStaffProfilePicStatus = false;
            this.selectedStaffImage = "";
            const staffProfileImageSuccessfullyDeletedTranslation = await firstValueFrom(this.translate.get('staffProfileImageSuccessfullyDeleted')); 
            customToastr(staffProfileImageSuccessfullyDeletedTranslation, 'success');
            $("#deleteStaffPopupClose").trigger("click");
          }
        },
        async (error) => {
          this.removeStaffProfilePicStatus = false;
          const failedToDeletedStaffImagePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeletedStaffImagePleaseTryAgain')); 
          customToastr(failedToDeletedStaffImagePleaseTryAgainTranslation, 'error');
          $("#deleteStaffPopupClose").trigger("click");
        }
      );
  }

  ///////Add staff contact number ///////

  handleDebounceAddStaffMobileNumber(value: HTMLInputElement): void {
      this.mobileNumberValidator(value);
  }

  mobileNumberValidator(mobileNumberInput: HTMLInputElement): void {
    const fullNumber = $(mobileNumberInput).intlTelInput("getNumber");
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidAddStaffMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    this.invalidAddStaffMobileNumber = !(isValid);
  }

  ///////Edit staff contact number ///////////

  handleDebounceEditStaffMobileNumber(value: HTMLInputElement): void {  
    this.editStaffMobileNumberValidator(value);
  }

  editStaffMobileNumberValidator(mobileNumberInput: HTMLInputElement): void {
    const fullNumber = $(mobileNumberInput).intlTelInput("getNumber");
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidEditStaffMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    this.invalidEditStaffMobileNumber = !(isValid);
  }

  handleDebounceAddStudentMobileNumber(value: HTMLInputElement): void {
      this.addStudentMobileNumberValidator(value);
      if (this.addNewStudentNumberInput == "") {
        this.invalidAddStudentMobileNumber = false;
      }
  }

  addStudentMobileNumberValidator(mobileNumberInput: HTMLInputElement): void {
    const fullNumber = $(mobileNumberInput).intlTelInput("getNumber");
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidAddStudentMobileNumber = true;
      return;
    }
    console.log("dd",phoneNumber);
    
    const isValid = phoneNumber.isValid(); 
    this.invalidAddStudentMobileNumber = !(isValid);
  }

  getCurrencyByCountryCode(countryCode: string): string {
    return countryCurrency.getAllInfoByISO(countryCode)?.currency || "USD";
  }

  handleDebounceAddStudentFatherMobileNumber(value: HTMLInputElement): void {
      this.addStudentMobileFatherNumberValidator(value);
  }

  addStudentMobileFatherNumberValidator(
    mobileNumberInput: HTMLInputElement
  ): void {
    const fullNumber = $(mobileNumberInput).intlTelInput("getNumber");
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidAddStudentFatherMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    this.invalidAddStudentFatherMobileNumber = !isValid;
  }

  handleDebounceAddStudentMotherMobileNumber(value: HTMLInputElement): void {
      this.addStudentMobileMotherNumberValidator(value);
      if (this.addNewStudentMotherNumberInput == "") {
        this.invalidAddStudentMotherMobileNumber = false;
      }
  }

  addStudentMobileMotherNumberValidator(
    mobileNumberInput: HTMLInputElement
  ): void {
    const fullNumber = $(mobileNumberInput).intlTelInput("getNumber");
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidAddStudentMotherMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    this.invalidAddStudentMotherMobileNumber = !isValid;
  }

  handleDebounceAddStudentGuardianMobileNumber(value: HTMLInputElement): void {
      this.addStudentMobileGuardianNumberValidator(value);
      if (this.addNewStudentGuardianNumberInput == "") {
        this.invalidAddStudentGuardianMobileNumber = false;
      }
  }

  addStudentMobileGuardianNumberValidator(
    mobileNumberInput: HTMLInputElement
  ): void {
    const fullNumber = $(mobileNumberInput).intlTelInput("getNumber");
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidAddStudentGuardianMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    this.invalidAddStudentGuardianMobileNumber = !isValid;
  }
  //////// Upload TC / Birth cirtificate /////

  openNewStudentTcOrBirthCopyUpload() {
    $("#new-student-tc-or-birth-copy").trigger("click");
  }

  startUploadingNewTcOrBirthCopy() {
    if (
      this.validateImage(
        "#new-student-tc-or-birth-copy",
        "#new-student-tc-or-birth-progressbar",
        "#new-student-tc-or-birth-image-ele",
        "tcOrBirthCertificate"
      )
    ) {
      this.translate.get('change').subscribe((translatedText: string) => { $('#new-student-tc-or-birth-copy-button').text(translatedText); });
    }
  }

  openNewStudentEWSCopyUpload() {
    $("#new-student-EWS-copy").trigger("click");
  }

  startUploadingNewEWSCopy() {
    if (
      this.validateImage(
        "#new-student-EWS-copy",
        "#new-student-EWS-progressbar",
        "#new-student-EWS-image-ele",
        "ewsCertificate"
      )
    ) {
      this.translate.get('change').subscribe((translatedText: string) => { $('#new-student-EWS-copy-button').text(translatedText); });
    }
  }

  openNewStudentDivyangjanCopyUpload() {
    $("#new-student-Divyangjan-copy").trigger("click");
  }

  startUploadingNewDivyangjanCopy() {
    if (
      this.validateImage(
        "#new-student-Divyangjan-copy",
        "#new-student-Divyangjan-progressbar",
        "#new-student-Divyangjan-image-ele",
        "speciallyAbled"
      )
    ) {
      this.translate.get('change').subscribe((translatedText: string) => { $('#new-student-Divyangjan-copy-button').text(translatedText); });
    }
  }

  openNewStudentSingleGirlCopyUpload() {
    $("#new-student-single-girl-copy").trigger("click");
  }

  startUploadingNewSingleGirlCopy() {
    if (
      this.validateImage(
        "#new-student-single-girl-copy",
        "#new-student-single-girl-progressbar",
        "#new-student-single-girl-image-ele",
        "singleGirlChildCertificate"
      )
    ) {
      this.translate.get('change').subscribe((translatedText: string) => { $('#new-student-single-girl-copy-button').text(translatedText); });
    }
  }

  openNewStudentCasteCopyUpload() {
    $("#new-student-caste-copy").trigger("click");
  }

  startUploadingNewCasteCopy() {
    if (
      this.validateImage(
        "#new-student-caste-copy",
        "#new-student-caste-progressbar",
        "#new-student-caste-image-ele",
        "casteCertificate"
      )
    ) {
      this.translate.get('change').subscribe((translatedText: string) => { $('#new-student-caste-copy-button').text(translatedText); });
    }
  }

  // function for open upload document ui
  openUploadDocument() {
    this.documentIndex="";
    this.isOpenUploadDocument = !this.isOpenUploadDocument;
    this.fetchInfoForDocument();
  }

  // function for fetch info according to ui upload and list
  fetchInfoForDocument() {
    if (this.isOpenUploadDocument) {
      this.getDocumentType();
      this.documentTypesInfo = [];
      this.selectedDocumentType = null;
      this.selectedFileForUpload = null;
    } else {
      this.getUploadedDocumentOnHub();
    }
  }

  // api for get document type in upload document
  async getDocumentType() {
    try {
      this.fetchingDocumentType = true;
      const response: any = await firstValueFrom(
        this.groupservice.getDocumentType()
      );
      if (response.status && response.body) {
        this.documentTypesInfo = response.body.documentTypeList
          ? response.body.documentTypeList
          : [];
      } else {
        this.documentTypesInfo = [];
      }
      this.fetchingDocumentType = false;
    } catch (error) {
      this.documentTypesInfo = [];
      this.fetchingDocumentType = false;
      customToastr(error.error.message ? error.error.message : "Error","error" );
    }
  }

  // function for upload document
  async uploadDocumentForDocHub(data) {
    if (this.selectedDocumentType == null) {
      this.fileInputDocumentHub.nativeElement.value = "";
      const pleaseSelectTheDocumentTypeFirstTranslation = await firstValueFrom(this.translate.get('pleaseSelectTheDocumentTypeFirst')); 
      customToastr(pleaseSelectTheDocumentTypeFirstTranslation, 'error');
      return;
    }
    const files = data.target.files[0];
    this.selectedFileForUpload = data.target.files[0];
  }

  // api for upload document
  async uploadFilesForDochub(title, description) {
    try {
      if (
        this.selectedDocumentType?.documentTypeName === "Other" &&
        title.trim() == ""
      ) {
        const pleaseProvideTitleOfTheDocumentTranslation = await firstValueFrom(this.translate.get('pleaseProvideTitleOfTheDocument')); 
        customToastr(pleaseProvideTitleOfTheDocumentTranslation, 'error');
        return;
      }
      if (this.selectedFileForUpload == null) {
        const pleaseUploadTheDocumentFirstTranslation = await firstValueFrom(this.translate.get('pleaseUploadTheDocumentFirst')); 
        customToastr(pleaseUploadTheDocumentFirstTranslation, 'error');
        return;
      }
      const mediaSize = this.selectedFileForUpload.size;
      const mediaSizeInMb = mediaSize / (1024 * 1024);
      if (mediaSizeInMb > this.selectedDocumentType.mediaSize) {
        const pleaseUploadTheDocumentLessThanTranslation = await firstValueFrom(this.translate.get('pleaseUploadTheDocumentLessThan')); 
        const mbTranslation = await firstValueFrom(this.translate.get('mb')); 
        customToastr(`${pleaseUploadTheDocumentLessThanTranslation} ${this.selectedDocumentType.mediaSize} ${mbTranslation}.`,"error");
        return;
      }
      this.uploadingDocument = true;
      const schoolInfo = localStorage.getItem("schoolAllInfo");
      const parsedSchoolInfo = JSON.parse(schoolInfo);
      const lang = "en";
      const body = {
        lang: lang,
        academicId:  this.academicInfo.current_academic,
        documentTitle: title,
        documentDescription: description,
        documentTypeId: this.selectedDocumentType.pkDocumentTypeId,
        studentId: this.studentBasicInfoStudentId,
      };
      const response: any = await firstValueFrom(
        this.groupservice.uploadDocumentForDocumentHub(
          body,
          this.selectedFileForUpload
        )
      );
      if (response.status && response.body) {
        customToastr(response.body.message ? response.body.message : "Success","success");
      }
      this.uploadingDocument = false;
      this.openUploadDocument();
    } catch (error) {
      this.uploadingDocument = false;
      customToastr(error.error.message ? error.error.message : "Error","error");
    }
  }

  // function for search data in document list
  searchDocumentsByTitle(searchQuery) {
    this.documentHubData = this.uploadedDocumentList.filter((document) =>
      document.documentTypeName
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }

  // api for get document data
  async getUploadedDocumentOnHub() {
    try {
      this.fetchingUploadedDocumentList = true;
      const response: any = await firstValueFrom(
        this.groupservice.getUploadedDocumentInfo(
          this.studentBasicInfoStudentId,
          this.academicInfo.current_academic
        )
      );
      if (response.status && response.body) {
        this.uploadedDocumentList = response.body.uploadedDocumentsList
          ? response.body.uploadedDocumentsList
          : [];
        this.documentHubData = response.body.uploadedDocumentsList
          ? response.body.uploadedDocumentsList
          : [];
      } else {
        this.uploadedDocumentList = [];
        this.documentHubData = [];
      }
      this.fetchingUploadedDocumentList = false;
    } catch (error) {
      this.fetchingUploadedDocumentList = false;
      this.uploadedDocumentList = [];
      this.documentHubData = [];
      customToastr(error.error.message ? error.error.message : "Error","error");
    }
  }


  // fucnion for handle media preview
  handleMediaPreviewDocumentHub(data,index) {
    event.stopPropagation();
    if(this.deletingDocument || this.previewingDocumentIndex!=""){
      return;
    }
    this.previewingDocumentIndex = index;
    const schoolId = localStorage.getItem('schoolinfo');
    const token = localStorage.getItem('usertoken');
    const schoolData = localStorage.getItem('schoolAllInfo');
    const parsedData = JSON.parse(schoolData);
    this.documentIndex='';
    fetch(this.baseURLVersion3+apiConstants.previewDoc, {
        method: 'GET',
        headers: {
            'authorization':token,
            'documentid' : data.pkStudentDocumentsId,
            'lang' : "en",
            'schoolid' : schoolId,
            'academicId' :  this.academicInfo.current_academic,
            'studentId' : this.studentBasicInfoStudentId
        }
    })
    .then(response => {
        if (response.ok) {
            return response.blob();
        } 
    })
    .then(blob => {
      this.previewingDocumentIndex = '';
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        this.documentIndex="";
    })
    .catch(error => {
      customToastr(error.error.message?error.error.message: "Error", "error");
    });
}

  // fucntion for open tab
  openActionsForDocument(index){
    event.stopPropagation();
    if(this.documentIndex===index){
      this.documentIndex = "";
      return;
    }
    this.documentIndex = index;
  }

  // close actions tab for delete
  closeActionsFromDocument(){
    this.documentIndex ="";
  }

  // api for delete uploded document
  async deleteUploadedDoc(data){
    try{
      this.deletingDocument = true;
      const schoolInfo  = localStorage.getItem('schoolAllInfo');
      const parsedSchoolInfo = JSON.parse(schoolInfo)
      const body ={
        academicId : this.academicInfo.current_academic,
        documentId : data.pkStudentDocumentsId,
        lang : "en",
        studentId : this.studentBasicInfoStudentId
      }
      const response:any = await firstValueFrom(this.groupservice.deleteUploadedDoc(body))
      if(response.status && response.body){
        customToastr(response.body.message,"success");
        this.getUploadedDocumentOnHub();
        this.closeActionsFromDocument();
      }
      this.deletingDocument = false;
    }
    catch(error){
      customToastr(error.error.message?error.error.message: "Error","error");
      this.deletingDocument = false;
      this.closeActionsFromDocument();
    }
  }

  // function for close pop 
  closeDocumentHubPopUp(){
    $("#documentHubData").modal("hide");
  }

  // trimContactNumber(contactNumber: string):
  trimData(data){
    if(data){
      return data.trim();
    }
    else{
      return data;
    }
  }
}